let _news_data = [
	{
		"id": 121371,
		"img": require("@/assets/news/01/01.png"),
		"title": "共筑教育新生态 | 赢科产品亮相世界数字教育大会全球数字教育成果展",
		"date": "2026年5月14日 17:30",
		"content": `<div class="rich_media_content js_underline_content autoTypeSetting24psection" id="js_content">
				<section
					style="box-sizing: border-box; font-style: normal; font-weight: 400; text-align: justify; font-size: 16px; color: rgb(62, 62, 62); visibility: visible; margin-bottom: 0px;">
					<section
						style="text-align: center; margin-top: 10px; margin-bottom: 10px; line-height: 0; box-sizing: border-box; visibility: visible;">
						<section
							style="max-width: 100%; vertical-align: middle; display: inline-block; line-height: 0; box-sizing: border-box; visibility: visible;"
							nodeleaf=""><img class="rich_pages wxw-img" data-aistatus="1" data-backh="288" data-backw="578"
								data-imgfileid="503352238" data-ratio="0.49907407407407406" data-s="300,640"
								data-type="webp" data-w="1080"
								style="vertical-align: middle; max-width: 100%; width: 677px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
								data-original-style="vertical-align:middle;max-width:100%;width:100%;box-sizing:border-box;"
								data-index="4"
								src="@/assets/news/01/01.png"
								_width="100%" alt="图片" data-report-img-idx="18" data-fail="0"></section>
					</section>
					<section
						style="transform: rotateZ(5deg); transform-origin: left top; margin-top: 0px; margin-bottom: 0px; box-sizing: border-box; visibility: visible;">
						<section
							style="text-align: left; justify-content: flex-start; display: flex; flex-flow: row; margin: 10px 0px -20px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: middle; width: auto; min-width: 5%; max-width: 100%; flex: 0 0 auto; height: auto; align-self: center; margin: 0px -13px 0px 0px; box-sizing: border-box; visibility: visible;">
								<section
									style="display: flex; width: 100%; flex-flow: column; box-sizing: border-box; visibility: visible;">
									<section
										style="z-index: 1; transform: rotateZ(354deg); box-sizing: border-box; visibility: visible;">
										<section
											style="text-align: center; margin: 0px; line-height: 0; box-sizing: border-box; visibility: visible;">
											<section
												style="max-width: 100%; vertical-align: middle; display: inline-block; line-height: 0; width: 28px; height: auto; box-sizing: border-box; visibility: visible;"
												nodeleaf=""><img
													class="rich_pages wxw-img" data-ratio="1.262" data-s="300,640"
													data-type="png" data-w="500"
													style="vertical-align: middle; max-width: 100%; width: 28px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
													data-imgfileid="503352236" data-aistatus="1"
													data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
													data-index="5"
													src="@/assets/news/other/03.png"
													_width="100%" alt="图片" data-report-img-idx="16" data-fail="0"></section>
										</section>
									</section>
								</section>
							</section>
							<section data-cacheurl="" data-remoteid=""
								style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 auto; background-repeat: repeat; background-attachment: scroll; min-width: 5%; max-width: 100%; height: auto; padding: 0px 12px 8px 0px; box-sizing: border-box; background-image: url(&quot;https://mmbiz.qpic.cn/mmbiz_png/Q5cdRCrVHC8c3poI0WpkVXesibwLth63wCib3zRcGYbhic5MicavDcesVAbfseaicp5byg3WN8ymEk30zib6asw5ia8bBoywJcfuxoiaaNLYtlibv1E0/640?wx_fmt=png&amp;from=appmsg&amp;tp=webp&amp;wxfrom=15&amp;wx_lazy=1&quot;); background-position: 0% 0% !important; background-size: 3.93371% !important; visibility: visible;"
								data-lazy-bgimg="https://mmbiz.qpic.cn/mmbiz_png/Q5cdRCrVHC8c3poI0WpkVXesibwLth63wCib3zRcGYbhic5MicavDcesVAbfseaicp5byg3WN8ymEk30zib6asw5ia8bBoywJcfuxoiaaNLYtlibv1E0/640?wx_fmt=png&amp;from=appmsg"
								class="" data-fail="0">
								<section
									style="transform: rotateZ(355deg); transform-origin: left top; margin-top: 0px; margin-bottom: 0px; box-sizing: border-box; visibility: visible;">
									<section
										style="justify-content: flex-start; display: flex; flex-flow: row; width: 100%; align-self: flex-start; background-color: rgba(142, 201, 101, 0.21); padding: 8px 8px 8px 15px; box-sizing: border-box; visibility: visible;">
										<section
											style="text-align: justify; color: rgb(0, 154, 86); font-size: 18px; width: 100%; box-sizing: border-box; visibility: visible;">
											<p
												style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
												<strong style="box-sizing: border-box; visibility: visible;"><span leaf=""
														style="visibility: visible;">智联全球 · 育见未来</span></strong></p>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left; justify-content: flex-start; display: flex; flex-flow: row; margin: 0px 0px 10px; box-sizing: border-box; visibility: visible;">
						<section
							style="display: inline-block; width: 100%; vertical-align: top; align-self: flex-start; flex: 0 0 auto; border-style: solid; border-width: 1px; border-color: rgb(142, 201, 101); height: auto; margin: 0px; padding: 19px; box-sizing: border-box; visibility: visible;">
							<section
								style="text-align: justify; line-height: 1.8; box-sizing: border-box; visibility: visible;">
								<p
									style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
									<span leaf="" style="visibility: visible;"><br style="visibility: visible;"></span></p>
								<p
									style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
									<span leaf=""
										style="visibility: visible;">2026年5月13日，2026世界数字教育大会及其全球数字教育成果展在浙江杭州圆满落幕。</span></p>
								<p
									style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
									<span leaf="" style="visibility: visible;"><br style="visibility: visible;"></span></p>
								<p
									style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
									<span leaf="" style="visibility: visible;">在这场探讨全球教育数字化的盛会上，由&nbsp;</span><strong
										style="box-sizing: border-box; visibility: visible;"><span leaf=""
											style="visibility: visible;">北京航空航天大学</span></strong><span leaf=""
										style="visibility: visible;">&nbsp;与&nbsp;</span><strong
										style="box-sizing: border-box; visibility: visible;"><span leaf=""
											style="visibility: visible;">北京赢科天地电子有限公司</span></strong><span leaf=""
										style="visibility: visible;">&nbsp;携手共建的 “智学北航”
										平台于全球数字教育成果展中展出。同时，该平台搭载的教育智能体，入选了本次大会高等教育平行会议发布的&nbsp;</span><strong
										style="box-sizing: border-box; visibility: visible;"><span leaf=""
											style="visibility: visible;">首批高等教育智能体&nbsp;<span textstyle=""
												style="font-weight: normal; visibility: visible;">名单</span></span></strong><span
										leaf="" style="visibility: visible;">。</span></p>
							</section>
						</section>
					</section>
					<section
						style="text-align: center;margin-top: 10px;margin-bottom: 10px;line-height: 0;box-sizing: border-box;">
						<section
							style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
							nodeleaf=""><img class="rich_pages wxw-img" data-aistatus="1" data-backh="489" data-backw="578"
								data-imgfileid="503352235" data-ratio="0.8461538461538461" data-s="300,640"
								data-type="png" data-w="936"
								style="vertical-align: middle; max-width: 100%; width: 677px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
								data-original-style="vertical-align:middle;max-width:100%;width:100%;box-sizing:border-box;"
								data-index="6"
								src="@/assets/news/01/02.png"
								_width="100%" alt="图片" data-report-img-idx="10" data-fail="0"></section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgba(142, 201, 101, 0.11);box-sizing: border-box;">
							<section
								style="text-align: right;justify-content: flex-end;display: flex;flex-flow: row;margin: -10px 0px 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section style="text-align: left;box-sizing: border-box;">
										<section style="color: rgb(0, 154, 86);font-size: 18px;box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
													style="box-sizing: border-box;"><span
														style="font-size: 20px;box-sizing: border-box;"><span leaf="">借数字之风
															· 探教育之本</span></span></strong></p>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;box-sizing: border-box;">
									<section style="line-height: 0;margin: 0px;box-sizing: border-box;">
										<section
											style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 83.0234px;height: auto;box-sizing: border-box;"
											nodeleaf=""><img
												class="rich_pages wxw-img" data-ratio="0.2212962962962963" data-s="300,640"
												data-type="png" data-w="1080"
												style="vertical-align: middle; max-width: 100%; width: 83.0156px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
												data-imgfileid="503352240" data-aistatus="1"
												data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
												data-index="7"
												src="@/assets/news/other/01.png"
												_width="100%" alt="图片" data-report-img-idx="11" data-fail="0"></section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgba(142, 201, 101, 0.21);border-style: solid;border-width: 1px;border-color: transparent;height: auto;margin: 0px;padding: 19px;box-sizing: border-box;">
							<section style="text-align: justify;line-height: 1.8;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">面对高等教育数字化转型与国家“人工智能+”行动的时代机遇，北京赢科荣幸与北航深度同行。今天，让我们一起走进“智学北航”，看看这座高等教育智学平台教学智能体是如何运转的。</span>
								</p>
							</section>
						</section>
					</section>
					<section
						style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;align-self: flex-end;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
							<section style="margin: 0px;line-height: 0;box-sizing: border-box;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 40px;height: auto;box-sizing: border-box;"
									nodeleaf=""><img
										class="rich_pages wxw-img" data-ratio="0.9964664310954063" data-s="300,640"
										data-type="png" data-w="283"
										style="vertical-align: middle; max-width: 100%; width: 40px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
										data-imgfileid="503352239" data-aistatus="1"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="8"
										src="@/assets/news/other/02.png"
										_width="100%" alt="图片" data-report-img-idx="12" data-fail="0"></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;align-self: flex-end;flex: 100 100 0%;height: auto;padding: 0px;margin: 0px 0px 0px -20px;box-sizing: border-box;">
							<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
								<section style="z-index: auto;box-sizing: border-box;">
									<section
										style="margin: 0px;transform: translate3d(15px, 0px, 0px);-webkit-transform: translate3d(15px, 0px, 0px);-moz-transform: translate3d(15px, 0px, 0px);-o-transform: translate3d(15px, 0px, 0px);box-sizing: border-box;">
										<section
											style="text-align: justify;letter-spacing: 1px;color: rgb(142, 201, 101);box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<strong style="box-sizing: border-box;"><span leaf=""><span textstyle=""
															style="font-size: 18px;">01 /&nbsp;</span></span><span
														leaf=""><span textstyle=""
															style="font-size: 18px;">聚焦场景：重塑教与学的核心&nbsp;</span></span></strong>
											</p>
										</section>
									</section>
								</section>
							</section>
							<section style="margin: 2px 0px 8px;box-sizing: border-box;">
								<section style="background-color: rgb(178, 219, 191);height: 1px;box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-end;padding: 0px 0px 0px 8px;box-sizing: border-box;">
							<section
								style="text-align: justify;font-size: 10px;color: rgb(178, 219, 191);letter-spacing: 1px;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">INCO</span></p>
							</section>
						</section>
					</section>
					<section style="box-sizing: border-box;">
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								style="color: rgb(160, 160, 160);box-sizing: border-box;"><span
									style="font-size: 14px;box-sizing: border-box;"><span leaf="">-
										面对拥有的3200余门课程、海量校本视频与教学文档，如何让这些资源“活起来”？&nbsp;</span></span></span></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">“智学北航”给出的答案是：构建全场景教育教学智能体。平台不仅将庞杂的资源进行了精细的结构化梳理，更聚焦于</span><strong
								style="box-sizing: border-box;"><span leaf="">教师</span></strong><span
								leaf="">与</span><strong style="box-sizing: border-box;"><span
									leaf="">学生</span></strong><span leaf="">最真实的痛点。</span></p>
					</section>
					<section style="margin: 0.5em auto;text-align: center;box-sizing: border-box;">
						<section
							style="max-width: 100%;display: inline-block;line-height: 0;border-color: rgb(204, 204, 204);border-width: 8px;border-style: solid;box-sizing: border-box;"
							nodeleaf=""><img
								class="rich_pages wxw-img" data-ratio="0.5555555555555556" data-s="300,640" data-type="png"
								data-w="1080"
								style="vertical-align: middle; max-width: 100%; width: 661px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
								data-backw="562" data-backh="312" data-imgfileid="503352242" data-aistatus="1"
								data-original-style="vertical-align:middle;max-width:100%;width:100%;box-sizing:border-box;"
								data-index="9"
								src="@/assets/news/01/03.png"
								_width="100%" alt="图片" data-report-img-idx="9" data-fail="0"></section>
					</section>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							leaf=""><br></span></p>
					<section
						style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;align-self: flex-end;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
							<section style="margin: 0px;line-height: 0;box-sizing: border-box;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 40px;height: auto;box-sizing: border-box;"
									nodeleaf=""><img
										class="rich_pages wxw-img" data-ratio="0.9964664310954063" data-s="300,640"
										data-type="png" data-w="283"
										style="vertical-align: middle; max-width: 100%; width: 40px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
										data-imgfileid="503352241" data-aistatus="1"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="10"
										src="@/assets/news/other/02.png"
										_width="100%" alt="图片" data-report-img-idx="8" data-fail="0"></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;align-self: flex-end;flex: 100 100 0%;height: auto;padding: 0px;margin: 0px 0px 0px -20px;box-sizing: border-box;">
							<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
								<section style="z-index: auto;box-sizing: border-box;">
									<section
										style="margin: 0px;transform: translate3d(15px, 0px, 0px);-webkit-transform: translate3d(15px, 0px, 0px);-moz-transform: translate3d(15px, 0px, 0px);-o-transform: translate3d(15px, 0px, 0px);box-sizing: border-box;">
										<section
											style="text-align: justify;letter-spacing: 1px;color: rgb(142, 201, 101);box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<strong style="box-sizing: border-box;"><span leaf=""><span textstyle=""
															style="font-size: 18px;">02 /&nbsp;</span></span><span
														leaf=""><span textstyle=""
															style="font-size: 18px;">虚实融合：打通跨时空的课堂</span></span></strong>
											</p>
										</section>
									</section>
								</section>
							</section>
							<section style="margin: 2px 0px 8px;box-sizing: border-box;">
								<section style="background-color: rgb(178, 219, 191);height: 1px;box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-end;padding: 0px 0px 0px 8px;box-sizing: border-box;">
							<section
								style="text-align: justify;font-size: 10px;color: rgb(178, 219, 191);letter-spacing: 1px;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">INCO</span></p>
							</section>
						</section>
					</section>
					<section style="box-sizing: border-box;">
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								style="font-size: 14px;color: rgb(160, 160, 160);box-sizing: border-box;"><span leaf="">-
									教室不再仅是实体的房间，而是双向交互的数字枢纽。平台与北航的智慧教室硬件深度耦合，重塑了课堂体验。</span></span></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
							class="list-paddingleft-2">
							<li style="box-sizing: border-box;list-style-type: disc;">
								<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span leaf="" style="font-weight: 700;">全景直录播体系</span></strong></p>
							</li>
						</ul>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">课堂实况自动录制入库，支持按权限分级查看、视频快编与智能剪辑。</span></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
							class="list-paddingleft-2">
							<li style="box-sizing: border-box;list-style-type: disc;">
								<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span leaf="" style="font-weight: 700;">无界课堂互动</span></strong></p>
							</li>
						</ul>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">打通“智慧教室云桌面”与“学生移动端(i北航)”。课中随堂测验、随机点名、多端同步发卷，一键激活课堂氛围。</span></p>
					</section>
					<section style="margin: 0.5em auto;text-align: center;box-sizing: border-box;">
						<section
							style="max-width: 100%;display: inline-block;line-height: 0;border-color: rgb(204, 204, 204);border-width: 8px;border-style: solid;box-sizing: border-box;"
							nodeleaf=""><img
								class="rich_pages wxw-img" data-ratio="0.5722222222222222" data-s="300,640" data-type="png"
								data-w="1080"
								style="vertical-align: middle; max-width: 100%; width: 661px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
								data-backw="562" data-backh="322" data-imgfileid="503352243" data-aistatus="1"
								data-original-style="vertical-align:middle;max-width:100%;width:100%;box-sizing:border-box;"
								data-index="11"
								src="@/assets/news/01/04.png"
								_width="100%" alt="图片" data-report-img-idx="7" data-fail="0"></section>
					</section>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							leaf=""><br></span></p>
					<section
						style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;align-self: flex-end;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
							<section style="margin: 0px;line-height: 0;box-sizing: border-box;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 40px;height: auto;box-sizing: border-box;"
									nodeleaf=""><img
										class="rich_pages wxw-img" data-ratio="0.9964664310954063" data-s="300,640"
										data-type="png" data-w="283"
										style="vertical-align: middle; max-width: 100%; width: 40px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
										data-imgfileid="503352245" data-aistatus="1"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="12"
										src="@/assets/news/other/02.png"
										_width="100%" alt="图片" data-report-img-idx="6" data-fail="0"></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;align-self: flex-end;flex: 100 100 0%;height: auto;padding: 0px;margin: 0px 0px 0px -20px;box-sizing: border-box;">
							<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
								<section style="z-index: auto;box-sizing: border-box;">
									<section
										style="margin: 0px;transform: translate3d(15px, 0px, 0px);-webkit-transform: translate3d(15px, 0px, 0px);-moz-transform: translate3d(15px, 0px, 0px);-o-transform: translate3d(15px, 0px, 0px);box-sizing: border-box;">
										<section
											style="text-align: justify;letter-spacing: 1px;color: rgb(142, 201, 101);box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<strong style="box-sizing: border-box;"><span leaf=""><span textstyle=""
															style="font-size: 18px;">03 /&nbsp;</span></span><span
														leaf=""><span textstyle=""
															style="font-size: 18px;">智能伴学：打造有温度的助教</span></span></strong>
											</p>
										</section>
									</section>
								</section>
							</section>
							<section style="margin: 2px 0px 8px;box-sizing: border-box;">
								<section style="background-color: rgb(178, 219, 191);height: 1px;box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-end;padding: 0px 0px 0px 8px;box-sizing: border-box;">
							<section
								style="text-align: justify;font-size: 10px;color: rgb(178, 219, 191);letter-spacing: 1px;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">INCO</span></p>
							</section>
						</section>
					</section>
					<section style="box-sizing: border-box;">
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								style="font-size: 14px;color: rgb(160, 160, 160);box-sizing: border-box;"><span leaf="">-
									我们坚持应用至上。在“智学北航”中，AI不仅是聪明的答题机，更是引导者和减负者。</span></span></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
							class="list-paddingleft-2">
							<li style="box-sizing: border-box;list-style-type: disc;">
								<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span leaf="" style="font-weight: 700;">让老师回归育人本质</span></strong></p>
							</li>
						</ul>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">覆盖全校课程，提供精准的智能答疑。它能从由浅入深的提问中进行连续交互解答。不仅能分担大量基础答疑工作，还能自我进化，让老师们将精力更多地投入到能力培养与价值引导上。</span>
						</p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
							class="list-paddingleft-2">
							<li style="box-sizing: border-box;list-style-type: disc;">
								<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span leaf="" style="font-weight: 700;">启发式引导，突破学习壁垒</span></strong></p>
							</li>
						</ul>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">特别是针对编程与计算思维培养，平台打造了专属编程助手。 它不直接给答案，而是通过自动定位代码逻辑谬误，分步引导学生思考，提供个性化纠错指导。目前已覆盖
								300个知识点与7000余道习题。</span></p>
					</section>
					<section style="margin: 0.5em auto;text-align: center;box-sizing: border-box;">
						<section
							style="max-width: 100%;display: inline-block;line-height: 0;border-color: rgb(204, 204, 204);border-width: 8px;border-style: solid;box-sizing: border-box;"
							nodeleaf=""><img
								class="rich_pages wxw-img" data-ratio="0.7304347826086957" data-s="300,640" data-type="png"
								data-w="805"
								style="vertical-align: middle; max-width: 100%; width: 661px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
								data-backw="562" data-backh="411" data-imgfileid="503352246" data-aistatus="1"
								data-original-style="vertical-align:middle;max-width:100%;width:100%;box-sizing:border-box;"
								data-index="13"
								src="@/assets/news/01/05.png"
								_width="100%" alt="图片" data-report-img-idx="5" data-fail="0"></section>
					</section>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							leaf=""><br></span></p>
					<section
						style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;align-self: flex-end;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
							<section style="margin: 0px;line-height: 0;box-sizing: border-box;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 40px;height: auto;box-sizing: border-box;"
									nodeleaf=""><img
										class="rich_pages wxw-img" data-ratio="0.9964664310954063" data-s="300,640"
										data-type="png" data-w="283"
										style="vertical-align: middle; max-width: 100%; width: 40px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
										data-imgfileid="503352244" data-aistatus="1"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="14"
										src="@/assets/news/other/02.png"
										_width="100%" alt="图片" data-report-img-idx="4" data-fail="0"></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;align-self: flex-end;flex: 100 100 0%;height: auto;padding: 0px;margin: 0px 0px 0px -20px;box-sizing: border-box;">
							<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
								<section style="z-index: auto;box-sizing: border-box;">
									<section
										style="margin: 0px;transform: translate3d(15px, 0px, 0px);-webkit-transform: translate3d(15px, 0px, 0px);-moz-transform: translate3d(15px, 0px, 0px);-o-transform: translate3d(15px, 0px, 0px);box-sizing: border-box;">
										<section
											style="text-align: justify;letter-spacing: 1px;color: rgb(142, 201, 101);box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<strong style="box-sizing: border-box;"><span leaf=""><span textstyle=""
															style="font-size: 18px;">04 /&nbsp;</span></span><span
														leaf=""><span textstyle=""
															style="font-size: 18px;">技术筑基：构建懂教育的大脑</span></span></strong>
											</p>
										</section>
									</section>
								</section>
							</section>
							<section style="margin: 2px 0px 8px;box-sizing: border-box;">
								<section style="background-color: rgb(178, 219, 191);height: 1px;box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-end;padding: 0px 0px 0px 8px;box-sizing: border-box;">
							<section
								style="text-align: justify;font-size: 10px;color: rgb(178, 219, 191);letter-spacing: 1px;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">INCO</span></p>
							</section>
						</section>
					</section>
					<section style="box-sizing: border-box;">
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								style="color: rgb(160, 160, 160);font-size: 14px;box-sizing: border-box;"><span leaf="">-
									高等教育的严谨性，要求AI必须兼具“高智商”与“高可靠”，赢科为平台打造了极具实效的技术底座。</span></span></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
							class="list-paddingleft-2">
							<li style="box-sizing: border-box;list-style-type: disc;">
								<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span leaf="" style="font-weight: 700;">拒绝“幻觉”，精准输出</span></strong></p>
							</li>
						</ul>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">采用「基座模型私有化 + RAG（检索增强生成）」。通过北航私有化高质量语料库深度微调，确保知识传递绝对严谨。</span></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
							class="list-paddingleft-2">
							<li style="box-sizing: border-box;list-style-type: disc;">
								<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span leaf="" style="font-weight: 700;">像老师一样启发思考</span></strong></p>
							</li>
						</ul>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">通过「教育专用思维链（CoT）」技术，将复杂逻辑拆解为分步启发，真正在做教育，而非单纯的信息检索。</span></p>
					</section>
					<section style="margin: 0.5em auto;text-align: center;box-sizing: border-box;">
						<section
							style="max-width: 100%;display: inline-block;line-height: 0;border-color: rgb(204, 204, 204);border-width: 8px;border-style: solid;box-sizing: border-box;"
							nodeleaf=""><img
								class="rich_pages wxw-img" data-ratio="0.5361111111111111" data-type="png" data-w="1080"
								style="width: 661px !important; height: auto !important; visibility: visible !important;"
								data-backw="562" data-backh="301" data-imgfileid="503352280" data-aistatus="1"
								data-original-style="width:100%;" data-index="15"
								src="@/assets/news/01/06.png"
								_width="100%" alt="图片" data-report-img-idx="3" data-fail="0"></section>
					</section>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							leaf=""><br></span></p>
					<section
						style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;align-self: flex-end;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
							<section style="margin: 0px;line-height: 0;box-sizing: border-box;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 40px;height: auto;box-sizing: border-box;"
									nodeleaf=""><img
										class="rich_pages wxw-img" data-ratio="0.9964664310954063" data-s="300,640"
										data-type="png" data-w="283"
										style="vertical-align: middle; max-width: 100%; width: 40px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
										data-imgfileid="503352248" data-aistatus="1"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="16"
										src="@/assets/news/other/02.png"
										_width="100%" alt="图片" data-report-img-idx="1" data-fail="0"></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;align-self: flex-end;flex: 100 100 0%;height: auto;padding: 0px;margin: 0px 0px 0px -20px;box-sizing: border-box;">
							<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
								<section style="z-index: auto;box-sizing: border-box;">
									<section
										style="margin: 0px;transform: translate3d(15px, 0px, 0px);-webkit-transform: translate3d(15px, 0px, 0px);-moz-transform: translate3d(15px, 0px, 0px);-o-transform: translate3d(15px, 0px, 0px);box-sizing: border-box;">
										<section
											style="text-align: justify;letter-spacing: 1px;color: rgb(142, 201, 101);box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<strong style="box-sizing: border-box;"><span leaf=""><span textstyle=""
															style="font-size: 18px;">05 /&nbsp;</span></span><span
														leaf=""><span textstyle=""
															style="font-size: 18px;">落地生根：激发新质化的潜能</span></span></strong>
											</p>
										</section>
									</section>
								</section>
							</section>
							<section style="margin: 2px 0px 8px;box-sizing: border-box;">
								<section style="background-color: rgb(178, 219, 191);height: 1px;box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-end;padding: 0px 0px 0px 8px;box-sizing: border-box;">
							<section
								style="text-align: justify;font-size: 10px;color: rgb(178, 219, 191);letter-spacing: 1px;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">INCO</span></p>
							</section>
						</section>
					</section>
					<section style="box-sizing: border-box;">
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								style="font-size: 14px;color: rgb(160, 160, 160);box-sizing: border-box;"><span leaf="">-
									数字化的最终目的，是回馈于人。</span></span></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
					</section>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							leaf="">随着“智学北航”的深入应用，改变正在校园中悄然发生：</span></p>
					<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
						class="list-paddingleft-1">
						<li style="box-sizing: border-box;list-style-type: disc;">
							<p style="margin: 0px;padding: 0px;box-sizing: border-box;text-align: left;"><span
									leaf="">覆盖面广：AI助教已覆盖大部分在线教学课程。</span></p>
						</li>
						<li style="box-sizing: border-box;list-style-type: disc;">
							<p style="margin: 0px;padding: 0px;box-sizing: border-box;text-align: left;"><span
									leaf="">准准度高：日均答疑准确率与响应速度获师生高度认可。</span></p>
						</li>
						<li style="box-sizing: border-box;list-style-type: disc;">
							<p style="margin: 0px;padding: 0px;box-sizing: border-box;text-align: left;"><span
									leaf="">主动性强：编程助手带动习题库使用率攀升至 94.1%，学生面对编程难题的心理门槛显著降低。</span></p>
						</li>
					</ul>
					<section style="margin: 0.5em auto;text-align: center;box-sizing: border-box;">
						<section
							style="max-width: 100%;display: inline-block;line-height: 0;border-color: rgb(204, 204, 204);border-width: 8px;border-style: solid;box-sizing: border-box;"
							nodeleaf=""><img
								class="rich_pages wxw-img" data-ratio="0.562962962962963" data-s="300,640" data-type="png"
								data-w="1080"
								style="vertical-align: middle; max-width: 100%; width: 661px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
								data-backw="562" data-backh="316" data-imgfileid="503352253" data-aistatus="1"
								data-original-style="vertical-align:middle;max-width:100%;width:100%;box-sizing:border-box;"
								data-index="17"
								src="@/assets/news/01/07.png"
								_width="100%" alt="图片" data-report-img-idx="0" data-fail="0"></section>
					</section>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							leaf=""><br></span></p>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgba(142, 201, 101, 0.11);box-sizing: border-box;">
							<section
								style="text-align: right;justify-content: flex-end;display: flex;flex-flow: row;margin: -10px 0px 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section
										style="text-align: left;color: rgb(0, 154, 86);font-size: 20px;box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span leaf="">科技向善 · 教育向新</span></strong>
										</p>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;box-sizing: border-box;">
									<section style="line-height: 0;margin: 0px;box-sizing: border-box;">
										<section
											style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 83.0234px;height: auto;box-sizing: border-box;"
											nodeleaf=""><img
												class="rich_pages wxw-img" data-ratio="0.2212962962962963" data-s="300,640"
												data-type="png" data-w="1080"
												style="vertical-align: middle; max-width: 100%; width: 83.0156px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
												data-imgfileid="503352250" data-aistatus="1"
												data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
												data-index="18"
												src="@/assets/news/other/01.png"
												_width="100%" alt="图片" data-report-img-idx="2" data-fail="0"></section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;width: 100%;align-self: flex-start;border-style: solid;border-width: 1px;border-color: rgb(142, 201, 101);padding: 17px;box-sizing: border-box;">
						<section style="text-align: justify;line-height: 1.8;width: 100%;box-sizing: border-box;">
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf="">从底层教务的无缝对接，到智慧课堂的虚实交融；从海量数据的沉淀分析，到教育智能体的精准伴学。“智学北航”用科技丈量了教育的深度与广度。</span></p>
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf=""><br></span></p>
							<p><span leaf="">借&nbsp;<span textstyle=""
										style="font-weight: bold;">2026世界数字教育大会</span>&nbsp;契机，赢科交出了一份关于“AI+高等教育”的北航答卷。但这并非终点，而是新的起点。</span><span
									leaf="">面对数智化教育变革浪潮，赢科将继续深耕教学场景，打磨技术内核，筑牢架构底座，以专业铸就可靠，用科技助力跃升，为全球“AI+高等教育”发展贡献更多中国方案！</span>
							</p>
						</section>
					</section>
					<section style="margin: 0.5em auto;text-align: center;box-sizing: border-box;">
						<section
							style="max-width: 100%;display: inline-block;line-height: 0;border-color: rgb(204, 204, 204);border-width: 8px;border-style: solid;box-sizing: border-box;"
							nodeleaf=""><img
								class="rich_pages wxw-img" data-ratio="0.7490740740740741" data-s="300,640" data-type="jpeg"
								data-w="1080"
								style="vertical-align: middle; max-width: 100%; width: 661px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
								data-cropselx2="562" data-cropsely2="422" data-backw="562" data-backh="421"
								data-imgfileid="503352258" data-aistatus="1"
								data-original-style="vertical-align:middle;max-width:100%;width:100%;box-sizing:border-box;"
								data-index="19"
								src="@/assets/news/01/08.jpg"
								_width="100%" alt="图片" data-report-img-idx="13" data-fail="0"></section>
						<section
							style="box-sizing: border-box;font-style: normal;font-weight: 400;text-align: justify;font-size: 16px;color: rgb(62, 62, 62);"
							data-pm-slice="0 0 []">
							<section
								style="transform: rotateZ(5deg);-webkit-transform: rotateZ(5deg);-moz-transform: rotateZ(5deg);-o-transform: rotateZ(5deg);transform-origin: left top;-webkit-transform-origin: left top;-moz-transform-origin: left top;-o-transform-origin: left top;margin-top: 0px;margin-bottom: 0px;box-sizing: border-box;">
								<section
									style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 10px 0px -20px;box-sizing: border-box;">
									<section
										style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;margin: 0px -13px 0px 0px;box-sizing: border-box;">
										<section
											style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
											<section
												style="z-index: 1;transform: rotateZ(354deg);-webkit-transform: rotateZ(354deg);-moz-transform: rotateZ(354deg);-o-transform: rotateZ(354deg);box-sizing: border-box;">
												<section
													style="text-align: center;margin: 0px;line-height: 0;box-sizing: border-box;">
													<span leaf=""><br></span></section>
											</section>
										</section>
									</section>
								</section>
							</section>
							<section style="margin: 0.5em auto;text-align: center;box-sizing: border-box;">
								<section
									style="max-width: 100%;display: inline-block;line-height: 0;border-color: rgb(204, 204, 204);border-width: 8px;border-style: solid;box-sizing: border-box;"
									nodeleaf=""><img
										class="rich_pages wxw-img" data-ratio="0.7490740740740741" data-s="300,640"
										data-type="jpeg" data-w="1080"
										style="vertical-align: middle; max-width: 100%; width: 661px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
										data-cropselx2="562" data-cropsely2="422" data-backw="562" data-backh="421"
										data-imgfileid="503352259" data-aistatus="1"
										data-original-style="vertical-align:middle;max-width:100%;width:100%;box-sizing:border-box;"
										data-index="20"
										src="@/assets/news/01/09.jpg"
										_width="100%" alt="图片" data-report-img-idx="14" data-fail="0"></section>
							</section>
						</section>
					</section>
				</section>
			</div>`
	}, 
	{
		"id": 121372,
		"img": require("@/assets/news/02/01.jpg"),
		"title": "智领未来！赢科亮相2026腾讯云合作伙伴大会，共同发布未来学习中心解决方案",
		"date": "2026年1月28日 12:00:00",
		"content": `<div class="rich_media_content js_underline_content autoTypeSetting24psection" id="js_content" style="">
				<section
					style="box-sizing: border-box; font-style: normal; font-weight: 400; text-align: justify; font-size: 16px; color: rgb(62, 62, 62); visibility: visible; margin-bottom: 0px;">
					<section style="line-height: 0; box-sizing: border-box; visibility: visible;">
						<section
							style="max-width: 100%; vertical-align: middle; display: inline-block; line-height: 0; box-sizing: border-box; visibility: visible;"
							nodeleaf=""></section>
					</section>
					<section
						style="transform: rotateZ(5deg); transform-origin: left top; margin-top: 0px; margin-bottom: 0px; box-sizing: border-box; visibility: visible;">
						<section
							style="text-align: left; justify-content: flex-start; display: flex; flex-flow: row; margin: 10px 0px -20px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: middle; width: auto; min-width: 5%; max-width: 100%; flex: 0 0 auto; height: auto; align-self: center; margin: 0px -13px 0px 0px; box-sizing: border-box; visibility: visible;">
								<section
									style="display: flex; width: 100%; flex-flow: column; box-sizing: border-box; visibility: visible;">
									<section
										style="z-index: 1; transform: rotateZ(354deg); box-sizing: border-box; visibility: visible;">
										<section
											style="text-align: center; margin: 0px; line-height: 0; box-sizing: border-box; visibility: visible;">
											<section
												style="max-width: 100%; vertical-align: middle; display: inline-block; line-height: 0; width: 28px; height: auto; box-sizing: border-box; visibility: visible;"
												nodeleaf=""><img
													class="rich_pages wxw-img" data-ratio="1.262" data-s="300,640"
													data-type="png" data-w="500"
													style="vertical-align: middle; max-width: 100%; width: 28px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
													data-imgfileid="503352204" data-aistatus="1"
													data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
													data-index="4"
													src="@/assets/news/other/03.png"
													_width="100%" alt="图片" data-report-img-idx="2" data-fail="0"
													data-extentions-extra-ocr-id="8433217c053862dd3e4b7372f980321c">
											</section>
										</section>
									</section>
								</section>
							</section>
							<section data-cacheurl="" data-remoteid=""
								style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 auto; background-repeat: repeat; background-attachment: scroll; min-width: 5%; max-width: 100%; height: auto; padding: 0px 12px 8px 0px; box-sizing: border-box; background-image: url(&quot;https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfTxbYictx5MpPVV3CZdlc9ibE1dEtgV4Nf3p2wcK3iaF4BZubuUPx574OzRvKUeuAR3baOibyY2AicwmQ/640?wx_fmt=png&amp;from=appmsg&amp;tp=webp&amp;wxfrom=15&amp;wx_lazy=1&quot;); background-position: 0% 0% !important; background-size: 3.93371% !important; visibility: visible;"
								data-lazy-bgimg="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfTxbYictx5MpPVV3CZdlc9ibE1dEtgV4Nf3p2wcK3iaF4BZubuUPx574OzRvKUeuAR3baOibyY2AicwmQ/640?wx_fmt=png&amp;from=appmsg"
								class="" data-fail="0">
								<section
									style="transform: rotateZ(355deg); transform-origin: left top; margin-top: 0px; margin-bottom: 0px; box-sizing: border-box; visibility: visible;">
									<section
										style="justify-content: flex-start; display: flex; flex-flow: row; width: 100%; align-self: flex-start; background-color: rgba(142, 201, 101, 0.21); padding: 8px 8px 8px 15px; box-sizing: border-box; visibility: visible;">
										<section
											style="text-align: justify; color: rgb(0, 154, 86); font-size: 18px; width: 100%; box-sizing: border-box; visibility: visible;">
											<p
												style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
												<strong style="box-sizing: border-box; visibility: visible;"><span leaf=""
														style="visibility: visible;font-weight: 700;">科 | 技 | 盛 | 会&nbsp;</span></strong></p>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left; justify-content: flex-start; display: flex; flex-flow: row; margin: 0px 0px 10px; box-sizing: border-box; visibility: visible;">
						<section
							style="display: inline-block; width: 100%; vertical-align: top; align-self: flex-start; flex: 0 0 auto; border-style: solid; border-width: 1px; border-color: rgb(142, 201, 101); height: auto; margin: 0px; padding: 19px; box-sizing: border-box; visibility: visible;">
							<section
								style="text-align: justify; line-height: 1.8; box-sizing: border-box; visibility: visible;">
								<p
									style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
									<span leaf="" style="visibility: visible;"><br style="visibility: visible;"></span></p>
								<p
									style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
									<span leaf=""
										style="visibility: visible;">日前，备受瞩目的“智同道合·势在必得”——2026腾讯云合作伙伴大会在热烈的氛围中举行。作为智慧教育领域的深耕者，北京赢科天地电子有限公司受邀出席此次盛会的智慧教育专场，与行业领袖及生态伙伴共同探讨
										AI + 教育的新范式。</span></p>
							</section>
						</section>
					</section>
					<section style="margin: 0.5em auto; text-align: center; box-sizing: border-box; visibility: visible;">
						<section
							style="max-width: 100%; display: inline-block; line-height: 0; border-color: rgb(204, 204, 204); border-width: 8px; border-style: solid; box-sizing: border-box; visibility: visible;"
							nodeleaf=""><img
								class="rich_pages wxw-img" data-ratio="0.5555555555555556" data-s="300,640" data-type="jpeg"
								data-w="900"
								style="vertical-align: middle; max-width: 100%; width: 661px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
								data-imgfileid="503352205" data-aistatus="1"
								data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
								data-index="5"
								src="@/assets/news/02/01.jpg"
								_width="100%" alt="图片" data-report-img-idx="1" data-fail="0"
								data-extentions-extra-ocr-id="1b4b00a6985b4a61b9524338682ce8da"></section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgba(142, 201, 101, 0.11);box-sizing: border-box;">
							<section
								style="text-align: right;justify-content: flex-end;display: flex;flex-flow: row;margin: -10px 0px 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section style="text-align: left;box-sizing: border-box;">
										<section style="color: rgb(0, 154, 86);font-size: 18px;box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
													style="box-sizing: border-box;"><span
														style="font-size: 20px;box-sizing: border-box;"><span leaf="" style="font-weight: 700;">聚焦 AI
															前沿，共探教育新图景</span></span></strong></p>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;box-sizing: border-box;">
									<section style="line-height: 0;margin: 0px;box-sizing: border-box;">
										<section
											style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 83.0234px;height: auto;box-sizing: border-box;"
											nodeleaf=""><img
												class="rich_pages wxw-img" data-ratio="0.2212962962962963" data-s="300,640"
												data-type="png" data-w="1080"
												style="vertical-align: middle; max-width: 100%; width: 83.0156px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
												data-imgfileid="503352202" data-aistatus="1"
												data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
												data-index="6"
												src="@/assets/news/other/01.png"
												_width="100%" alt="图片" data-report-img-idx="0" data-fail="0"
												data-extentions-extra-ocr-id="983899a27c8ea47fab80eb1e6b7f1494"></section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgba(142, 201, 101, 0.21);border-style: solid;border-width: 1px;border-color: transparent;height: auto;margin: 0px;padding: 19px;box-sizing: border-box;">
							<section style="text-align: justify;line-height: 1.8;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">智慧教育专场深入聚焦如何利用人工智能、云计算等尖端技术重构教学空间。赢科在数字化转型的浪潮中展现出深厚的积淀，与合作伙伴共同擘画教育未来的宏伟图景。</span>
								</p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">大会的核心高光时刻，莫过于“腾讯教育教育服务云生态联合方案发布仪式”。在全场嘉宾的共同见证下，赢科正式发布了面向未来的战略级成果——【未来学习中心解决方案】。</span>
								</p>
							</section>
						</section>
					</section>
					<section style="margin: 0.5em auto;text-align: center;box-sizing: border-box;">
						<section
							style="max-width: 100%;display: inline-block;line-height: 0;border-color: rgb(204, 204, 204);border-width: 8px;border-style: solid;box-sizing: border-box;"
							nodeleaf=""><img
								class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
								data-ratio="0.6111111111111112" data-s="300,640" data-type="jpeg" data-w="1080"
								style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.63636) / 1; width: 661px !important; height: auto !important;"
								data-imgfileid="503352206" data-aistatus="1"
								data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
								data-index="7"
								src="@/assets/news/02/02.jpg"
								_width="100%" alt="图片" data-extentions-extra-ocr-id="4a29ff5eaab1bbff15ac07220c60020f">
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgba(142, 201, 101, 0.11);box-sizing: border-box;">
							<section
								style="text-align: right;justify-content: flex-end;display: flex;flex-flow: row;margin: -10px 0px 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section
										style="text-align: left;color: rgb(0, 154, 86);font-size: 20px;box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span
													leaf="" style="font-weight: 700;">&nbsp;重磅发布：未来学习中心解决方案</span></strong></p>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;box-sizing: border-box;">
									<section style="line-height: 0;margin: 0px;box-sizing: border-box;">
										<section
											style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 83.0234px;height: auto;box-sizing: border-box;"
											nodeleaf=""><img
												class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
												data-ratio="0.2212962962962963" data-s="300,640" data-type="png"
												data-w="1080"
												style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(4.51883) / 1; width: 83px !important; height: auto !important;"
												data-imgfileid="503352208" data-aistatus="1"
												data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
												data-index="8"
												src="@/assets/news/other/01.png"
												_width="100%" alt="图片"
												data-extentions-extra-ocr-id="4a29ff5eaab1bbff15ac07220c60020f"></section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;width: 100%;align-self: flex-start;border-style: solid;border-width: 1px;border-color: rgb(142, 201, 101);padding: 17px;box-sizing: border-box;">
						<section style="text-align: justify;line-height: 1.8;width: 100%;box-sizing: border-box;">
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf="">这一方案的问世，标志着双方在教育数字化转型领域的合作迈向了更深层次。该方案紧扣教育数字化升级的时代脉搏，深度融合了腾讯教育教育服务云的强大底层能力，结合赢科在教育行业的深厚积淀，旨在为学习者构建一个智慧、感知、互联的全新生长空间。</span>
							</p>
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf=""><br></span></p>
							<p
								style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
								<strong style="box-sizing: border-box;"><span
										style="color: rgb(0, 154, 86);box-sizing: border-box;"><span
											leaf="">【数智融合】&nbsp;</span></span></strong></p>
							<p
								style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
								<span leaf="">深度整合云计算与人工智能技术，实现教学资源的精准推送。</span></p>
							<p
								style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
								<span style="color: rgb(0, 154, 86);box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span leaf="">【全景覆盖】&nbsp;</span></strong></span>
							</p>
							<p
								style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
								<span leaf="">贯穿“教、学、管、评、测”全流程，提升教育教学效率。</span></p>
							<p
								style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
								<span style="color: rgb(0, 154, 86);box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span leaf="">【生态协同】&nbsp;</span></strong></span>
							</p>
							<p
								style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
								<span leaf="">打破信息孤岛，构建真正意义上的智慧教育生态圈。</span></p>
						</section>
					</section>
					<section style="margin: 0.5em auto;text-align: center;box-sizing: border-box;">
						<section
							style="max-width: 100%;display: inline-block;line-height: 0;border-color: rgb(204, 204, 204);border-width: 8px;border-style: solid;box-sizing: border-box;"
							nodeleaf=""><img
								class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
								data-ratio="0.6694444444444444" data-s="300,640" data-type="jpeg" data-w="1080"
								style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.49378) / 1; width: 661px !important; height: auto !important;"
								data-imgfileid="503352210" data-aistatus="1"
								data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
								data-index="9"
								src="@/assets/news/02/03.jpg"
								_width="100%" alt="图片" data-extentions-extra-ocr-id="4a29ff5eaab1bbff15ac07220c60020f">
						</section>
					</section>
					<section
						style="text-align: right;justify-content: flex-end;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;background-color: rgb(255, 255, 255);padding: 0px 0px 0px 14px;box-sizing: border-box;">
							<section
								style="justify-content: flex-end;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section
										style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
										<section
											style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 0%;height: auto;box-sizing: border-box;">
											<section
												style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;box-sizing: border-box;">
												<section
													style="display: inline-block;width: 16px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;border-style: solid;border-width: 0px 0px 0px 2px;border-left-color: rgb(142, 201, 101);margin: 0px 0px 0px 4px;box-sizing: border-box;">
													<section
														style="transform: translate3d(-6px, 0px, 0px);-webkit-transform: translate3d(-6px, 0px, 0px);-moz-transform: translate3d(-6px, 0px, 0px);-o-transform: translate3d(-6px, 0px, 0px);margin: 4px 0px 8px;box-sizing: border-box;">
														<section
															style="background-color: rgb(142, 201, 101);height: 2px;box-sizing: border-box;">
															<svg viewBox="0 0 1 1"
																style="float:left;line-height:0;width:0;vertical-align:top;"
																role="img" aria-label="插图"></svg></section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;padding: 7px 0px;margin: 0px -10px;box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 28px;height: 28px;vertical-align: top;overflow: hidden;border-radius: 42px;background-color: rgb(0, 154, 86);box-sizing: border-box;">
													<section style="margin: 5px 0px 0px;box-sizing: border-box;">
														<section
															style="font-size: 18px;color: rgb(255, 255, 255);line-height: 1;box-sizing: border-box;">
															<p style="margin: 0px;padding: 0px;box-sizing: border-box;">
																<strong style="box-sizing: border-box;"><span
																		leaf="">01</span></strong></p>
														</section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: bottom;width: auto;flex: 0 0 0%;height: auto;align-self: flex-end;box-sizing: border-box;">
											<section
												style="transform: perspective(0px);-webkit-transform: perspective(0px);-moz-transform: perspective(0px);-o-transform: perspective(0px);transform-style: flat;box-sizing: border-box;">
												<section
													style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;transform: rotateX(180deg) rotateY(180deg);-webkit-transform: rotateX(180deg) rotateY(180deg);-moz-transform: rotateX(180deg) rotateY(180deg);-o-transform: rotateX(180deg) rotateY(180deg);box-sizing: border-box;">
													<section
														style="display: inline-block;width: 16px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;border-style: solid;border-width: 0px 0px 0px 2px;border-left-color: rgb(142, 201, 101);margin: 0px 0px 0px 4px;box-sizing: border-box;">
														<section
															style="transform: translate3d(-6px, 0px, 0px);-webkit-transform: translate3d(-6px, 0px, 0px);-moz-transform: translate3d(-6px, 0px, 0px);-o-transform: translate3d(-6px, 0px, 0px);margin: 4px 0px 8px;box-sizing: border-box;">
															<section
																style="background-color: rgb(142, 201, 101);height: 2px;box-sizing: border-box;">
																<svg viewBox="0 0 1 1"
																	style="float:left;line-height:0;width:0;vertical-align:top;"
																	role="img" aria-label="插图"></svg></section>
														</section>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: middle;width: auto;margin: 0px 0px 0px 11px;align-self: center;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;padding: 0px 7px;border-style: solid;border-width: 0px 0px 10px;border-bottom-color: rgb(179, 211, 156);box-sizing: border-box;">
									<section style="margin: 0px 0px -10px;box-sizing: border-box;">
										<section style="text-align: justify;box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<strong style="box-sizing: border-box;"><span
														leaf="">“虚实结合、时空无限”的学习新空间</span></strong></p>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;padding: 7px 17px 38px;border-style: solid;border-width: 0px 2px 2px 0px;border-color: rgb(142, 201, 101);overflow: hidden;height: auto;margin: 0px;border-bottom-right-radius: 20px;box-sizing: border-box;">
							<section style="text-align: justify;line-height: 1.8;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">未来学习中心将学习活动由线下拓展至线上、由物理空间拓展至虚拟空间，有效破除学习活动的时空限制，让学生可以随时随地获取教学资源、接受教学服务，灵活选择线下、线上或线下线上结合的方式开展学习，真正做到</span><span
										style="color: rgb(0, 154, 86);box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span leaf="">“人人皆学、处处能学、
												时时可学”</span></strong></span><span leaf="">。</span></p>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: -30px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;background-color: rgb(255, 255, 255);padding: 0px 15px 0px 0px;box-sizing: border-box;">
							<section
								style="text-align: right;justify-content: flex-end;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section
										style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
										<section
											style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 0%;height: auto;box-sizing: border-box;">
											<section
												style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;box-sizing: border-box;">
												<section
													style="display: inline-block;width: 16px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;border-style: solid;border-width: 0px 0px 0px 2px;border-left-color: rgb(142, 201, 101);margin: 0px 0px 0px 4px;box-sizing: border-box;">
													<section
														style="transform: translate3d(-6px, 0px, 0px);-webkit-transform: translate3d(-6px, 0px, 0px);-moz-transform: translate3d(-6px, 0px, 0px);-o-transform: translate3d(-6px, 0px, 0px);margin: 4px 0px 8px;box-sizing: border-box;">
														<section
															style="background-color: rgb(142, 201, 101);height: 2px;box-sizing: border-box;">
															<svg viewBox="0 0 1 1"
																style="float:left;line-height:0;width:0;vertical-align:top;"
																role="img" aria-label="插图"></svg></section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;padding: 7px 0px;margin: 0px -10px;box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 28px;height: 28px;vertical-align: top;overflow: hidden;border-radius: 42px;background-color: rgb(0, 154, 86);box-sizing: border-box;">
													<section style="margin: 5px 0px 0px;box-sizing: border-box;">
														<section
															style="font-size: 18px;color: rgb(255, 255, 255);line-height: 1;box-sizing: border-box;">
															<p style="margin: 0px;padding: 0px;box-sizing: border-box;">
																<strong style="box-sizing: border-box;"><span
																		leaf="">02</span></strong></p>
														</section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: bottom;width: auto;flex: 0 0 0%;height: auto;align-self: flex-end;box-sizing: border-box;">
											<section
												style="transform: perspective(0px);-webkit-transform: perspective(0px);-moz-transform: perspective(0px);-o-transform: perspective(0px);transform-style: flat;box-sizing: border-box;">
												<section
													style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;transform: rotateX(180deg) rotateY(180deg);-webkit-transform: rotateX(180deg) rotateY(180deg);-moz-transform: rotateX(180deg) rotateY(180deg);-o-transform: rotateX(180deg) rotateY(180deg);box-sizing: border-box;">
													<section
														style="display: inline-block;width: 16px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;border-style: solid;border-width: 0px 0px 0px 2px;border-left-color: rgb(142, 201, 101);margin: 0px 0px 0px 4px;box-sizing: border-box;">
														<section
															style="transform: translate3d(-6px, 0px, 0px);-webkit-transform: translate3d(-6px, 0px, 0px);-moz-transform: translate3d(-6px, 0px, 0px);-o-transform: translate3d(-6px, 0px, 0px);margin: 4px 0px 8px;box-sizing: border-box;">
															<section
																style="background-color: rgb(142, 201, 101);height: 2px;box-sizing: border-box;">
																<svg viewBox="0 0 1 1"
																	style="float:left;line-height:0;width:0;vertical-align:top;"
																	role="img" aria-label="插图"></svg></section>
														</section>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: middle;width: auto;margin: 0px 0px 0px 11px;align-self: center;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;padding: 0px 7px;border-style: solid;border-width: 0px 0px 10px;border-bottom-color: rgb(179, 211, 156);box-sizing: border-box;">
									<section style="margin: 0px 0px -10px;box-sizing: border-box;">
										<section style="text-align: justify;box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<strong style="box-sizing: border-box;"><span
														leaf="">“数智赋能、个性灵动”的学习新体验</span></strong></p>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;padding: 7px 17px 30px;border-style: solid;border-width: 0px 0px 2px 2px;border-color: rgb(142, 201, 101);border-bottom-left-radius: 20px;overflow: hidden;height: auto;margin: 0px 0px 0px 20px;box-sizing: border-box;">
							<section style="text-align: justify;line-height: 1.8;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">未来学习中心将发挥人工智能技术优势，打破规模化教育与个性化培养的天然矛盾。通过 AI 算法模型，科学评估学生学业状态， 量身打造</span><span
										style="color: rgb(0, 154, 86);box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span
												leaf="">虚拟教师、虚拟助教、虚拟学伴、虚拟辅导员</span></strong></span><span
										leaf="">等辅学角色，精准推送学习资源，为学生提供沉浸式、伴随式、拟人化、个性化的全新学习体验，使学生能够专注而放松的高效学习。</span></p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
							</section>
						</section>
					</section>
					<section
						style="text-align: right;justify-content: flex-end;display: flex;flex-flow: row;margin: -30px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;background-color: rgb(255, 255, 255);padding: 0px 0px 0px 14px;box-sizing: border-box;">
							<section
								style="justify-content: flex-end;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section
										style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
										<section
											style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 0%;height: auto;box-sizing: border-box;">
											<section
												style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;box-sizing: border-box;">
												<section
													style="display: inline-block;width: 16px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;border-style: solid;border-width: 0px 0px 0px 2px;border-left-color: rgb(142, 201, 101);margin: 0px 0px 0px 4px;box-sizing: border-box;">
													<section
														style="transform: translate3d(-6px, 0px, 0px);-webkit-transform: translate3d(-6px, 0px, 0px);-moz-transform: translate3d(-6px, 0px, 0px);-o-transform: translate3d(-6px, 0px, 0px);margin: 4px 0px 8px;box-sizing: border-box;">
														<section
															style="background-color: rgb(142, 201, 101);height: 2px;box-sizing: border-box;">
															<svg viewBox="0 0 1 1"
																style="float:left;line-height:0;width:0;vertical-align:top;"
																role="img" aria-label="插图"></svg></section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;padding: 7px 0px;margin: 0px -10px;box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 28px;height: 28px;vertical-align: top;overflow: hidden;border-radius: 42px;background-color: rgb(0, 154, 86);box-sizing: border-box;">
													<section style="margin: 5px 0px 0px;box-sizing: border-box;">
														<section
															style="font-size: 18px;color: rgb(255, 255, 255);line-height: 1;box-sizing: border-box;">
															<p style="margin: 0px;padding: 0px;box-sizing: border-box;">
																<strong style="box-sizing: border-box;"><span
																		leaf="">03</span></strong></p>
														</section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: bottom;width: auto;flex: 0 0 0%;height: auto;align-self: flex-end;box-sizing: border-box;">
											<section
												style="transform: perspective(0px);-webkit-transform: perspective(0px);-moz-transform: perspective(0px);-o-transform: perspective(0px);transform-style: flat;box-sizing: border-box;">
												<section
													style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;transform: rotateX(180deg) rotateY(180deg);-webkit-transform: rotateX(180deg) rotateY(180deg);-moz-transform: rotateX(180deg) rotateY(180deg);-o-transform: rotateX(180deg) rotateY(180deg);box-sizing: border-box;">
													<section
														style="display: inline-block;width: 16px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;border-style: solid;border-width: 0px 0px 0px 2px;border-left-color: rgb(142, 201, 101);margin: 0px 0px 0px 4px;box-sizing: border-box;">
														<section
															style="transform: translate3d(-6px, 0px, 0px);-webkit-transform: translate3d(-6px, 0px, 0px);-moz-transform: translate3d(-6px, 0px, 0px);-o-transform: translate3d(-6px, 0px, 0px);margin: 4px 0px 8px;box-sizing: border-box;">
															<section
																style="background-color: rgb(142, 201, 101);height: 2px;box-sizing: border-box;">
																<svg viewBox="0 0 1 1"
																	style="float:left;line-height:0;width:0;vertical-align:top;"
																	role="img" aria-label="插图"></svg></section>
														</section>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: middle;width: auto;margin: 0px 0px 0px 11px;align-self: center;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;padding: 0px 7px;border-style: solid;border-width: 0px 0px 10px;border-bottom-color: rgb(179, 211, 156);box-sizing: border-box;">
									<section style="margin: 0px 0px -10px;box-sizing: border-box;">
										<section style="text-align: justify;box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<strong style="box-sizing: border-box;"><span
														leaf="">“学为中心、能力导向”的学习新范式</span></strong></p>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;padding: 7px 17px 38px;border-style: solid;border-width: 0px 2px 2px 0px;border-color: rgb(142, 201, 101);overflow: hidden;height: auto;margin: 0px;border-bottom-right-radius: 20px;box-sizing: border-box;">
							<section style="text-align: justify;line-height: 1.8;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">作为教育服务对象和教学活动主体，学生的主动参与、积极思考和深度探究是能力培养的重要前提。未来学习中心将改变单向从教师端发力的教改定式，基于能力模型科学设计学习模式和学习
										内容，充分满足学生多样化学习需求，有效</span><span
										style="color: rgb(0, 154, 86);box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span
												leaf="">激发求知欲望、释放创新潜力、提升综合力</span></strong></span><span
										leaf="">，让学生真正成为学业主角。</span></p>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgba(142, 201, 101, 0.11);box-sizing: border-box;">
							<section
								style="text-align: right;justify-content: flex-end;display: flex;flex-flow: row;margin: -10px 0px 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section
										style="text-align: left;color: rgb(0, 154, 86);font-size: 20px;box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span leaf="" style="font-weight: 700;">携手共赢：生态联合的战略布局</span></strong>
										</p>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;box-sizing: border-box;">
									<section style="line-height: 0;margin: 0px;box-sizing: border-box;">
										<section
											style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 83.0234px;height: auto;box-sizing: border-box;"
											nodeleaf=""><img
												class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
												data-ratio="0.2212962962962963" data-s="300,640" data-type="png"
												data-w="1080"
												style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(4.51883) / 1; width: 83px !important; height: auto !important;"
												data-imgfileid="503352207" data-aistatus="1"
												data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
												data-index="10"
												src="@/assets/news/other/01.png"
												_width="100%" alt="图片"
												data-extentions-extra-ocr-id="4a29ff5eaab1bbff15ac07220c60020f"></section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;width: 100%;align-self: flex-start;border-style: solid;border-width: 1px;border-color: rgb(142, 201, 101);padding: 17px;box-sizing: border-box;">
						<section style="text-align: justify;line-height: 1.8;width: 100%;box-sizing: border-box;">
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf="">在本次大会中，赢科展现了其作为行业领先者的技术实力与创新思维。通过深度挖掘教育场景下的实际需求，赢科与腾讯教育协同作战，将技术优势转化为实实在在的教育生产力。</span>
							</p>
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf=""><br></span></p>
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf="">赢科始终坚持以技术创新为基石，以用户需求为导向。此次出席大会并发布联合方案，不仅是对过往合作成果的肯定，更是对未来智慧教育蓝图的宏伟展望。</span></p>
						</section>
					</section>
					<section style="margin: 0.5em auto;text-align: center;box-sizing: border-box;">
						<section
							style="max-width: 100%;display: inline-block;line-height: 0;border-color: rgb(204, 204, 204);border-width: 8px;border-style: solid;box-sizing: border-box;"
							nodeleaf=""><img
								class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
								data-ratio="0.6666666666666666" data-s="300,640" data-type="jpeg" data-w="1080"
								style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.5) / 1; width: 661px !important; height: auto !important;"
								data-imgfileid="503352211" data-aistatus="1"
								data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
								data-index="11"
								src="@/assets/news/02/04.jpg"
								_width="100%" alt="图片" data-extentions-extra-ocr-id="4a29ff5eaab1bbff15ac07220c60020f">
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgba(142, 201, 101, 0.11);box-sizing: border-box;">
							<section
								style="text-align: right;justify-content: flex-end;display: flex;flex-flow: row;margin: -10px 0px 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section
										style="text-align: left;color: rgb(0, 154, 86);font-size: 20px;box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span leaf="" style="font-weight: 700;">智领未来：势在必得的新征程</span></strong>
										</p>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;box-sizing: border-box;">
									<section style="line-height: 0;margin: 0px;box-sizing: border-box;">
										<section
											style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 83.0234px;height: auto;box-sizing: border-box;"
											nodeleaf=""><img
												class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
												data-ratio="0.2212962962962963" data-s="300,640" data-type="png"
												data-w="1080"
												style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(4.51883) / 1; width: 83px !important; height: auto !important;"
												data-imgfileid="503352209" data-aistatus="1"
												data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
												data-index="12"
												src="@/assets/news/other/01.png"
												_width="100%" alt="图片"
												data-extentions-extra-ocr-id="4a29ff5eaab1bbff15ac07220c60020f"></section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgba(142, 201, 101, 0.21);border-style: solid;border-width: 1px;border-color: transparent;height: auto;margin: 0px;padding: 19px;box-sizing: border-box;">
							<section style="text-align: justify;line-height: 1.8;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">未来的教育将不再受限于物理空间，而是基于数据驱动的个性化成长历程。赢科将继续深耕智慧教育领域，与腾讯云及更多生态伙伴紧密协作，共同探索AI、大数据等前沿技术在教育细分场景的应用边界，为推动教育公平化、个性化和智能化贡献“赢科智慧”。</span>
								</p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">合志赢科，让智慧教育触手可及！</span></p>
							</section>
						</section>
					</section>
				</section>
			</div>`
	},
	{
		"id": 121373,
		"img": require("@/assets/news/03/01.png"),
		"title": "「 智育英才 · 数启未来 」国家卓越工程师学院的数字化革新",
		"date": "2025年9月26日 15:00:00",
		"content": `<div class="rich_media_content js_underline_content autoTypeSetting24psection" id="js_content" style="">
				<section
					style="box-sizing: border-box; font-style: normal; font-weight: 400; text-align: justify; font-size: 16px; color: rgb(62, 62, 62); visibility: visible; margin-bottom: 0px;">
					<section
						style="text-align: center; justify-content: center; display: flex; flex-flow: row; margin: 10px 0px; box-sizing: border-box; visibility: visible;">
						<section
							style="display: inline-block; width: auto; vertical-align: top; min-width: 10%; max-width: 100%; flex: 0 0 auto; height: auto; align-self: flex-start; box-sizing: border-box; visibility: visible;">
							<section
								style="margin: 0px; isolation: isolate; justify-content: center; display: flex; flex-flow: row; box-sizing: border-box; visibility: visible;">
								<section
									style="display: inline-block; width: auto; vertical-align: top; background-color: rgb(142, 201, 101); margin: 0px; min-width: 10%; max-width: 100%; flex: 0 0 auto; height: auto; padding: 12px 23px; align-self: flex-start; box-sizing: border-box; visibility: visible;">
									<section
										style="color: rgb(255, 255, 255); text-align: justify; box-sizing: border-box; visibility: visible;">
										<p
											style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
											<strong style="box-sizing: border-box; visibility: visible;"><span leaf=""
													style="visibility: visible;font-weight: bold;">中国工科教育的战略机遇</span></strong>
										</p>
									</section>
								</section>
							</section>
							<section
								style="display: flex; flex-flow: row; margin: 0px; justify-content: center; box-sizing: border-box; visibility: visible;">
								<section
									style="display: inline-block; vertical-align: top; width: auto; flex: 0 0 0%; height: auto; align-self: flex-start; box-sizing: border-box; visibility: visible;">
									<section style="text-align: left; box-sizing: border-box; visibility: visible;">
										<section
											style="display: inline-block; vertical-align: top; overflow: hidden; height: 0px; width: 0px; border-style: solid; border-width: 4px; border-color: rgb(142, 201, 101) rgb(142, 201, 101) rgba(255, 255, 255, 0) rgba(255, 255, 255, 0); box-sizing: border-box; visibility: visible;">
											<svg viewBox="0 0 1 1"
												style="float: left; line-height: 0; width: 0px; vertical-align: top; visibility: visible;"
												role="img" aria-label="插图"></svg>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block; vertical-align: top; width: auto; flex: 100 100 0%; align-self: flex-start; height: auto; background-color: rgb(225, 234, 225); box-sizing: border-box; visibility: visible;">
									<section style="margin: -8px 0px 0px; box-sizing: border-box; visibility: visible;">
										<section
											style="color: rgb(225, 234, 225); text-align: justify; box-sizing: border-box; visibility: visible;">
											<p
												style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
												<span leaf="" style="visibility: visible;"><br
														style="visibility: visible;"></span>
											</p>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block; vertical-align: top; width: auto; flex: 0 0 0%; height: auto; box-sizing: border-box; visibility: visible;">
									<section
										style="transform: perspective(0px); transform-style: flat; box-sizing: border-box; visibility: visible;">
										<section
											style="text-align: left; transform: rotateY(180deg); box-sizing: border-box; visibility: visible;">
											<section
												style="display: inline-block; vertical-align: top; overflow: hidden; height: 0px; width: 0px; border-style: solid; border-width: 4px; border-color: rgb(142, 201, 101) rgb(142, 201, 101) rgba(255, 255, 255, 0) rgba(255, 255, 255, 0); box-sizing: border-box; visibility: visible;">
												<svg viewBox="0 0 1 1"
													style="float: left; line-height: 0; width: 0px; vertical-align: top; visibility: visible;"
													role="img" aria-label="插图"></svg>
											</section>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<p style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span leaf=""
							style="visibility: visible;">在中华民族伟大复兴的征程中，高层次工程技术人才是国家战略需求的关键支撑。国家卓越工程师学院应运而生，肩负着为高端装备制造、新一代信息技术等关键领域输送领军人才的重任。</span>
					</p>
					<section
						style="text-align: center; justify-content: center; margin: 10px 0%; display: flex; flex-flow: row; box-sizing: border-box; visibility: visible;">
						<section
							style="display: inline-block; vertical-align: middle; width: auto; flex: 100 100 0%; align-self: center; height: auto; box-sizing: border-box; visibility: visible;">
							<section style="margin: 0px 0%; box-sizing: border-box; visibility: visible;">
								<section
									style="height: 1px; background-color: rgb(142, 201, 101); box-sizing: border-box; visibility: visible;">
									<svg viewBox="0 0 1 1"
										style="float: left; line-height: 0; width: 0px; vertical-align: top; visibility: visible;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block; vertical-align: middle; width: auto; min-width: 5%; max-width: 100%; flex: 0 0 auto; height: auto; align-self: center; margin: 0px 15px; box-sizing: border-box; visibility: visible;">
							<section style="margin: 0px; line-height: 0; box-sizing: border-box; visibility: visible;">
								<section
									style="max-width: 100%; vertical-align: middle; display: inline-block; line-height: 0; width: 55px; height: auto; box-sizing: border-box; visibility: visible;"
									nodeleaf=""><img class="rich_pages wxw-img" data-imgfileid="503351970" data-ratio="0.69"
										data-s="300,640"
										data-type="png" data-w="500"
										style="vertical-align: middle; max-width: 100%; width: 55px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="4"
										src="@/assets/news/other/04.png"
										_width="100%" alt="图片" data-report-img-idx="0" data-fail="0"></section>
							</section>
						</section>
						<section
							style="display: inline-block; vertical-align: middle; width: auto; flex: 100 100 0%; align-self: center; height: auto; box-sizing: border-box; visibility: visible;">
							<section style="margin: 0px 0%; box-sizing: border-box; visibility: visible;">
								<section
									style="height: 1px; background-color: rgb(142, 201, 101); box-sizing: border-box; visibility: visible;">
									<svg viewBox="0 0 1 1"
										style="float: left; line-height: 0; width: 0px; vertical-align: top; visibility: visible;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
					</section>
					<section style="text-align: center; padding: 0px 20px; box-sizing: border-box; visibility: visible;">
						<p style="margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;"><span leaf=""
								style="visibility: visible;">国家卓越工程师学院以</span><span
								style="color: rgb(0, 154, 86); box-sizing: border-box; visibility: visible;"><strong
									style="box-sizing: border-box; visibility: visible;"><span leaf=""
										style="visibility: visible;">跨学科融合</span></strong></span><span leaf=""
								style="visibility: visible;">的项目制教学、</span><span
								style="color: rgb(0, 154, 86); box-sizing: border-box; visibility: visible;"><strong
									style="box-sizing: border-box; visibility: visible;"><span leaf=""
										style="visibility: visible;">校企深度协同</span></strong></span><span leaf=""
								style="visibility: visible;">的育人模式，着重培养以硕博为主的高质量复合型</span><span
								style="color: rgb(0, 154, 86); box-sizing: border-box; visibility: visible;"><strong
									style="box-sizing: border-box; visibility: visible;"><span leaf=""
										style="visibility: visible;">工程技术人才</span></strong></span><span leaf=""
								style="visibility: visible;">。</span></p>
						<p style="margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;"><span leaf=""
								style="visibility: visible;"><br style="visibility: visible;"></span></p>
						<p style="margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;"><span leaf=""
								style="visibility: visible;">自2022年首批18家建设单位启动，到2023年新增14所高校，国卓学院正加速发展。</span></p>
						<p style="margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;"><span leaf=""
								style="visibility: visible;"><br style="visibility: visible;"></span></p>
						<p style="margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;"><span leaf=""
								style="visibility: visible;">截至2025年，多所高校已形成特色培养体系，并与40余家头部企业开展联合培养。</span></p>
					</section>
					<section
						style="text-align: center; justify-content: center; display: flex; flex-flow: row; margin: 10px 0px; box-sizing: border-box; visibility: visible;">
						<section
							style="display: inline-block; width: auto; vertical-align: top; align-self: flex-start; flex: 0 0 auto; min-width: 5%; max-width: 100%; height: auto; box-sizing: border-box; visibility: visible;">
							<section
								style="display: flex; flex-flow: row; text-align: left; justify-content: flex-start; margin: 10px 0px; box-sizing: border-box; visibility: visible;">
								<section
									style="display: inline-block; vertical-align: bottom; width: auto; flex: 0 0 0%; height: auto; align-self: flex-end; box-sizing: border-box; visibility: visible;">
									<section
										style="transform: rotateZ(19deg); box-sizing: border-box; visibility: visible;">
										<section style="text-align: center; box-sizing: border-box; visibility: visible;">
											<section
												style="display: inline-block; vertical-align: top; overflow: hidden; height: 34px; width: 3px; background-color: rgb(142, 201, 101); box-sizing: border-box; visibility: visible;">
												<svg viewBox="0 0 1 1"
													style="float: left; line-height: 0; width: 0px; vertical-align: top; visibility: visible;"
													role="img" aria-label="插图"></svg>
											</section>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block; vertical-align: top; width: auto; flex: 0 0 0%; align-self: stretch; height: auto; box-sizing: border-box; visibility: visible;">
									<section style="text-align: right; box-sizing: border-box; visibility: visible;">
										<section
											style="display: inline-block; vertical-align: top; overflow: hidden; height: 0px; width: 0px; border-style: solid; border-width: 24px 8px; border-color: rgba(255, 255, 255, 0) rgb(142, 201, 101) rgb(142, 201, 101) rgba(255, 255, 255, 0); box-sizing: border-box; visibility: visible;">
											<svg viewBox="0 0 1 1"
												style="float: left; line-height: 0; width: 0px; vertical-align: top; visibility: visible;"
												role="img" aria-label="插图"></svg>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block; width: auto; vertical-align: top; background-color: rgb(142, 201, 101); flex: 100 100 0%; align-self: stretch; height: auto; padding: 11px 14px 0px; box-sizing: border-box; visibility: visible;">
									<section style="margin: 0px; box-sizing: border-box; visibility: visible;">
										<section
											style="color: rgb(255, 255, 255); text-align: justify; box-sizing: border-box; visibility: visible;">
											<p
												style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
												<b style="box-sizing: border-box; visibility: visible;"><span leaf=""
														style="visibility: visible;font-weight: 700;">《卓越工程师培养认证标准》即将发布</span></b>
											</p>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block; vertical-align: top; width: auto; flex: 0 0 0%; height: auto; align-self: stretch; box-sizing: border-box; visibility: visible;">
									<section style="box-sizing: border-box; visibility: visible;">
										<section
											style="display: inline-block; vertical-align: top; overflow: hidden; height: 0px; width: 0px; border-style: solid; border-width: 24px 8px; border-color: rgb(142, 201, 101) rgba(255, 255, 255, 0) rgba(255, 255, 255, 0) rgb(142, 201, 101); box-sizing: border-box; visibility: visible;">
											<svg viewBox="0 0 1 1"
												style="float: left; line-height: 0; width: 0px; vertical-align: top; visibility: visible;"
												role="img" aria-label="插图"></svg>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section style="box-sizing: border-box; visibility: visible;">
						<p
							style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
							<span leaf=""
								style="visibility: visible;">随着国家对高层次工程技术人才的迫切需求日益增长，以及《教育强国建设规划纲要（2024-2035年）》的深入推进，教育部明确将在今年下半年正式发布</span><strong
								style="box-sizing: border-box; visibility: visible;"><span
									style="color: rgb(0, 154, 86); box-sizing: border-box; visibility: visible;"><span
										leaf="" style="visibility: visible;">《卓越工程师培养认证标准》</span></span></strong><span
								leaf=""
								style="visibility: visible;">并开展试点认证工作，这标志着中国特色、世界水平的卓越工程师培养体系正加速迈向标准化、高质量发展的新阶段。</span>
						</p>
						<p
							style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
							<span leaf="" style="visibility: visible;"><br style="visibility: visible;"></span>
						</p>
						<p
							style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
							<span leaf=""
								style="visibility: visible;">面对认证标准对管理效能、质量保障、协同深度和数据支撑的明确要求，传统的管理模式正面临巨大挑战：</span>
						</p>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;height: auto;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="height: 1px;background-color: rgb(142, 201, 101);box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="height: 1px;background-color: rgb(142, 201, 101);box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
					</section>
					<section style="padding: 0px 20px;box-sizing: border-box;">
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<span style="font-size: 18px;color: rgb(142, 201, 101);box-sizing: border-box;"><strong
									style="box-sizing: border-box;"><span leaf="" style="font-weight: 700;">如何确保信息流畅，实现全体协同？</span></strong></span>
						</p>
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<span leaf="">传统沟通渠道单一，难以满足认证对学院整体管理效能和多层次组织协作的要求。</span>
						</p>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;height: auto;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="height: 1px;background-color: rgb(142, 201, 101);box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="height: 1px;background-color: rgb(142, 201, 101);box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
					</section>
					<section style="box-sizing: border-box;">
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<span style="font-size: 18px;color: rgb(142, 201, 101);box-sizing: border-box;"><strong
									style="box-sizing: border-box;"><span leaf="" style="font-weight: 700;">如何汇聚海量数据，保障培养质量？</span></strong></span>
						</p>
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<span leaf="">分散的培养数据和缺乏系统记录，阻碍了认证所要求的校企深度协同质量保障与持续改进。</span>
						</p>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;height: auto;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="height: 1px;background-color: rgb(142, 201, 101);box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="height: 1px;background-color: rgb(142, 201, 101);box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
					</section>
					<section style="box-sizing: border-box;">
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<span style="color: rgb(142, 201, 101);font-size: 18px;box-sizing: border-box;"><strong
									style="box-sizing: border-box;"><span leaf="" style="font-weight: 700;">如何简化繁琐流程，提升运行效率？</span></strong></span>
						</p>
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<span leaf="">复杂耗时的人工流程，难以支撑认证对标准化培养和工学交替高质量实施的效率要求。</span>
						</p>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;height: auto;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="height: 1px;background-color: rgb(142, 201, 101);box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="height: 1px;background-color: rgb(142, 201, 101);box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
					</section>
					<section style="box-sizing: border-box;">
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<span style="color: rgb(142, 201, 101);font-size: 18px;box-sizing: border-box;"><strong
									style="box-sizing: border-box;"><span leaf="" style="font-weight: 700;">如何跨越山海，深化校企融合？</span></strong></span>
						</p>
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<span leaf="">缺乏统一平台，信息不对称，阻碍了认证强调的政产学研深度协同及资源共享。</span>
						</p>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;height: auto;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="height: 1px;background-color: rgb(142, 201, 101);box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="height: 1px;background-color: rgb(142, 201, 101);box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
					</section>
					<section style="box-sizing: border-box;">
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<span style="color: rgb(142, 201, 101);font-size: 18px;box-sizing: border-box;"><strong
									style="box-sizing: border-box;"><span leaf="" style="font-weight: 700;">如何洞悉全局，做出精准决策？</span></strong></span>
						</p>
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<span leaf="">没有实时数据支撑和全面分析，管理者难以做出认证所需的科学决策和职业发展规划。</span>
						</p>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;height: auto;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="height: 1px;background-color: rgb(142, 201, 101);box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(142, 201, 101);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="height: 1px;background-color: rgb(142, 201, 101);box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
					</section>
					<section style="box-sizing: border-box;">
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">面对上述挑战，赢科凭借深耕教育信息化领域的卓越经验，为高校量身打造</span><strong
								style="box-sizing: border-box;"><span
									style="color: rgb(0, 154, 86);box-sizing: border-box;"><span
										leaf="">国家卓越工程师综合管理系统解决方案</span></span></strong><span
								leaf="">，该系统是实现高效协同、数据驱动、卓越育人的智慧引擎。</span></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
					</section>
					<section style="margin: 0.5em auto; text-align: center; box-sizing: border-box; visibility: visible;">
						<section
							style="max-width: 100%; display: inline-block; line-height: 0; border-color: rgb(204, 204, 204); border-width: 8px; border-style: solid; box-sizing: border-box; visibility: visible;"
							nodeleaf=""><img
								class="rich_pages wxw-img" data-ratio="0.5555555555555556" data-s="300,640" data-type="jpeg"
								data-w="900"
								style="vertical-align: middle; max-width: 100%; width: 661px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
								data-imgfileid="503352205" data-aistatus="1"
								data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
								data-index="5"
								src="@/assets/news/03/01.png"
								_width="100%" alt="图片" data-report-img-idx="1" data-fail="0"
								data-extentions-extra-ocr-id="1b4b00a6985b4a61b9524338682ce8da"></section>
					</section>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							leaf=""><br></span></p>
					<section
						style="display: flex;flex-flow: row;text-align: center;justify-content: center;margin: 10px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: bottom;width: auto;flex: 0 0 0%;height: auto;align-self: flex-end;box-sizing: border-box;">
							<section
								style="transform: rotateZ(19deg);-webkit-transform: rotateZ(19deg);-moz-transform: rotateZ(19deg);-o-transform: rotateZ(19deg);box-sizing: border-box;">
								<section style="box-sizing: border-box;">
									<section
										style="display: inline-block;vertical-align: top;overflow: hidden;height: 34px;width: 3px;background-color: rgb(142, 201, 101);box-sizing: border-box;">
										<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
											role="img" aria-label="插图"></svg>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: top;width: auto;flex: 0 0 0%;align-self: stretch;height: auto;box-sizing: border-box;">
							<section style="text-align: right;box-sizing: border-box;">
								<section
									style="display: inline-block;width: 0px;height: 0px;vertical-align: top;overflow: hidden;border-style: solid;border-width: 24px 8px;border-color: rgba(255, 255, 255, 0) rgb(225, 234, 225) rgb(225, 234, 225) rgba(255, 255, 255, 0);box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: top;width: auto;background-color: rgb(225, 234, 225);flex: 0 0 auto;align-self: stretch;min-width: 10%;max-width: 100%;height: auto;padding: 11px 14px 0px;box-sizing: border-box;">
							<section style="margin: 0px;box-sizing: border-box;">
								<section
									style="color: rgb(0, 154, 86);text-align: justify;font-size: 18px;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span leaf="" style="font-weight: 700;">四大优势 · 赋能卓越</span></strong></p>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: top;width: auto;flex: 0 0 0%;height: auto;align-self: stretch;box-sizing: border-box;">
							<section style="text-align: left;box-sizing: border-box;">
								<section
									style="display: inline-block;width: 0px;height: 0px;vertical-align: top;overflow: hidden;border-style: solid;border-width: 24px 8px;border-color: rgb(225, 234, 225) rgba(255, 255, 255, 0) rgba(255, 255, 255, 0) rgb(225, 234, 225);box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: middle;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;border-radius: 335px;overflow: hidden;padding: 3px;background-image: conic-gradient(rgb(180, 210, 6) 0%, rgba(180, 210, 6, 0.09) 96%);background-color: rgb(142, 201, 101);box-sizing: border-box;">
							<section style="text-align: center;box-sizing: border-box;">
								<section
									style="display: inline-block;width: 26px;height: 26px;vertical-align: top;overflow: hidden;border-radius: 142px;background-color: rgb(255, 255, 255);box-sizing: border-box;">
									<section style="color: rgb(142, 201, 101);box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span leaf="">1</span></strong></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="text-align: justify;color: rgb(210, 32, 26);box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span
											style="color: rgb(62, 62, 62);box-sizing: border-box;"><span leaf="">数字引擎，人才蝶变
												—— 全周期智慧管理</span></span></strong></p>
							</section>
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section style="background-color: rgb(255, 236, 89);height: 3px;box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;border-style: solid;border-width: 0px 0px 0px 3px;border-left-color: rgba(180, 210, 6, 0.29);height: auto;margin: 0px 0px 0px 14px;padding: 6px 0px 0px 20px;box-sizing: border-box;">
							<section style="margin: 0px 0px 10px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
											leaf="">「从招生选拔到成果跟踪，系统构建全周期、一站式智慧管理平台，精准描绘每位学子的卓越成长轨迹。」</span></p>
								</section>
							</section>
							<section style="margin: 0px 0px 10px;box-sizing: border-box;">
								<section
									style="text-align: justify;color: rgb(0, 0, 0);line-height: 2;box-sizing: border-box;">
									<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
										class="list-paddingleft-1">
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">完整覆盖招生、培养、成果与论文评审全周期管理。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">实现数字化、自动化处理，确保数据可追溯，支撑“质量保障与持续改进”。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">消除信息孤岛，实现卓越工程师培养路径透明化、科学化。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">提供招生录取、培养计划、学习记录、导师及成果管理、论文评审等一站式功能。</span></p>
										</li>
									</ul>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: middle;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;border-radius: 335px;overflow: hidden;padding: 3px;background-image: conic-gradient(rgb(180, 210, 6) 0%, rgba(180, 210, 6, 0.09) 96%);background-color: rgb(142, 201, 101);box-sizing: border-box;">
							<section style="text-align: center;box-sizing: border-box;">
								<section
									style="display: inline-block;width: 26px;height: 26px;vertical-align: top;overflow: hidden;border-radius: 142px;background-color: rgb(255, 255, 255);box-sizing: border-box;">
									<section style="color: rgb(142, 201, 101);box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span leaf="">2</span></strong></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="text-align: justify;color: rgb(210, 32, 26);box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span
											style="color: rgb(62, 62, 62);box-sizing: border-box;"><span
												leaf="">&nbsp;智慧牵引，双向奔赴 —— 多维智能匹配算法</span></span></strong></p>
							</section>
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section style="background-color: rgb(255, 236, 89);height: 3px;box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;border-style: solid;border-width: 0px 0px 0px 3px;border-left-color: rgba(180, 210, 6, 0.29);height: auto;margin: 0px 0px 0px 14px;padding: 6px 0px 0px 20px;box-sizing: border-box;">
							<section style="margin: 0px 0px 10px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
											leaf="">「 集成AI智能匹配算法，深度考量学生意向、导师专长、课题需求，实现师生、课题的最优组合，赋能校企人才培养效率更高、契合度更深。」</span>
									</p>
								</section>
							</section>
							<section style="margin: 0px 0px 10px;box-sizing: border-box;">
								<section
									style="text-align: justify;color: rgb(0, 0, 0);line-height: 2;box-sizing: border-box;">
									<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
										class="list-paddingleft-2">
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">通过多因素智能算法，实现学生与导师、课题精准匹配。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">助力“工程师培养”标准化，确保工学交替高质量实施。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">优化资源配置，促成学生与导师“双向奔赴”，激发创新。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">提供智能报名、导师课题申报、多因素匹配录取功能。</span></p>
										</li>
									</ul>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: middle;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;border-radius: 335px;overflow: hidden;padding: 3px;background-image: conic-gradient(rgb(180, 210, 6) 0%, rgba(180, 210, 6, 0.09) 96%);background-color: rgb(142, 201, 101);box-sizing: border-box;">
							<section style="text-align: center;box-sizing: border-box;">
								<section
									style="display: inline-block;width: 26px;height: 26px;vertical-align: top;overflow: hidden;border-radius: 142px;background-color: rgb(255, 255, 255);box-sizing: border-box;">
									<section style="color: rgb(142, 201, 101);box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span leaf="">3</span></strong></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="text-align: justify;color: rgb(210, 32, 26);box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span
											style="color: rgb(62, 62, 62);box-sizing: border-box;"><span leaf="">跨界融合，共生共赢
												—— 校企无缝协同平台</span></span></strong></p>
							</section>
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section style="background-color: rgb(255, 236, 89);height: 3px;box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;border-style: solid;border-width: 0px 0px 0px 3px;border-left-color: rgba(180, 210, 6, 0.29);height: auto;margin: 0px 0px 0px 14px;padding: 6px 0px 0px 20px;box-sizing: border-box;">
							<section style="margin: 0px 0px 10px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
											leaf="">「
											打破传统校企壁垒，构建无缝协同数字平台，全面整合企业资源、导师管理与联合课题，将高校智慧与企业实践紧密编织，实现资源共享、优势互-补、人才共育。」</span>
									</p>
								</section>
							</section>
							<section style="margin: 0px 0px 10px;box-sizing: border-box;">
								<section
									style="text-align: justify;color: rgb(0, 0, 0);line-height: 2;box-sizing: border-box;">
									<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
										class="list-paddingleft-2">
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">构建高校与企业无缝对接的数字桥梁。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">响应“合作与开放”及“师资队伍建设”认证要求，促进产学研深度融合。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">实现资源共享、信息互通，共同培养符合产业需求的未来工程师。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">涵盖企业资源库、企业导师管理、校企交流与联合培养评估等模块。</span></p>
										</li>
									</ul>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: middle;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;border-radius: 335px;overflow: hidden;padding: 3px;background-image: conic-gradient(rgb(180, 210, 6) 0%, rgba(180, 210, 6, 0.09) 96%);background-color: rgb(142, 201, 101);box-sizing: border-box;">
							<section style="text-align: center;box-sizing: border-box;">
								<section
									style="display: inline-block;width: 26px;height: 26px;vertical-align: top;overflow: hidden;border-radius: 142px;background-color: rgb(255, 255, 255);box-sizing: border-box;">
									<section style="color: rgb(142, 201, 101);box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span leaf="">4</span></strong></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="text-align: justify;color: rgb(210, 32, 26);box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span
											style="color: rgb(62, 62, 62);box-sizing: border-box;"><span leaf="">洞察全局，决胜千里
												—— 数据驱动精准决策</span></span></strong></p>
							</section>
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section style="background-color: rgb(255, 236, 89);height: 3px;box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;border-style: solid;border-width: 0px 0px 0px 3px;border-left-color: rgba(180, 210, 6, 0.29);height: auto;margin: 0px 0px 0px 14px;padding: 6px 0px 0px 20px;box-sizing: border-box;">
							<section style="margin: 0px 0px 10px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
											leaf="">「
											告别凭经验的模糊决策，通过实时数据洞察与可视化驾驶舱，将海量培养数据转化为清晰可感的“智慧图谱”，提供实时、多维度的前瞻分析，助力精准施策。」</span>
									</p>
								</section>
							</section>
							<section style="margin: 0px 0px 10px;box-sizing: border-box;">
								<section
									style="text-align: justify;color: rgb(0, 0, 0);line-height: 2;box-sizing: border-box;">
									<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
										class="list-paddingleft-1">
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">汇聚并分析海量培养过程数据，提供实时、精准决策支持。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">优化“学院定位与组织”效能，并有力支持“工程师职业发展”规划。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">帮助管理者洞察全局，基于数据做出科学、前瞻性决策。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">提供多维度统计看板、自定义报表和全流程审批中心。</span></p>
										</li>
									</ul>
								</section>
							</section>
						</section>
					</section>
					<section style="margin: 0.5em auto; text-align: center; box-sizing: border-box; visibility: visible;">
						<section
							style="max-width: 100%; display: inline-block; line-height: 0; border-color: rgb(204, 204, 204); border-width: 8px; border-style: solid; box-sizing: border-box; visibility: visible;"
							nodeleaf=""><img
								class="rich_pages wxw-img" data-ratio="0.5555555555555556" data-s="300,640" data-type="jpeg"
								data-w="900"
								style="vertical-align: middle; max-width: 100%; width: 661px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
								data-imgfileid="503352205" data-aistatus="1"
								data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
								data-index="5"
								src="@/assets/news/03/02.png"
								_width="100%" alt="图片" data-report-img-idx="1" data-fail="0"
								data-extentions-extra-ocr-id="1b4b00a6985b4a61b9524338682ce8da"></section>
					</section>
					<section
						style="text-align: center;justify-content: center;margin: 10px 0%;display: flex;flex-flow: row;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;align-self: center;height: auto;box-sizing: border-box;">
							<section style="margin: 0px 0%;box-sizing: border-box;">
								<section style="background-color: rgb(220, 237, 200);height: 1px;box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: 40px;flex: 0 0 auto;height: auto;align-self: center;margin: 0px 15px;box-sizing: border-box;">
							<section style="margin-top: 10px;margin-bottom: 10px;line-height: 0;box-sizing: border-box;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
									nodeleaf=""><img
										class="rich_pages wxw-img" data-ratio="0.9005681818181818" data-s="300,640"
										data-type="png" data-w="1056"
										style="vertical-align: middle; max-width: 100%; width: 40px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
										data-imgfileid="503351973"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="7"
										src="@/assets/news/other/04.png"
										_width="100%" alt="图片" data-report-img-idx="4" data-fail="0"></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;align-self: center;height: auto;box-sizing: border-box;">
							<section style="margin: 0px 0%;box-sizing: border-box;">
								<section style="background-color: rgb(220, 237, 200);height: 1px;box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg>
								</section>
							</section>
						</section>
					</section>
					<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
						<section style="z-index: 1;box-sizing: border-box;">
							<section
								style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 10px 0px -25px;box-sizing: border-box;">
								<section
									style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;margin: 0px 0px 0px 4px;box-sizing: border-box;">
									<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
										<section style="z-index: auto;box-sizing: border-box;">
											<section
												style="display: flex;flex-flow: row;justify-content: flex-start;margin: 0px;box-sizing: border-box;">
												<section
													style="display: inline-block;vertical-align: bottom;width: auto;flex: 0 0 0%;height: auto;align-self: flex-end;box-sizing: border-box;">
													<section
														style="transform: rotateZ(19deg);-webkit-transform: rotateZ(19deg);-moz-transform: rotateZ(19deg);-o-transform: rotateZ(19deg);box-sizing: border-box;">
														<section style="text-align: center;box-sizing: border-box;">
															<section
																style="display: inline-block;width: 3px;height: 34px;vertical-align: top;overflow: hidden;background-color: rgb(142, 201, 101);box-sizing: border-box;">
																<svg viewBox="0 0 1 1"
																	style="float:left;line-height:0;width:0;vertical-align:top;"
																	role="img" aria-label="插图"></svg>
															</section>
														</section>
													</section>
												</section>
												<section
													style="display: inline-block;vertical-align: top;width: auto;flex: 0 0 0%;align-self: stretch;height: auto;box-sizing: border-box;">
													<section style="text-align: right;box-sizing: border-box;">
														<section
															style="display: inline-block;width: 0px;height: 0px;vertical-align: top;overflow: hidden;border-style: solid;border-width: 24px 8px;border-color: rgba(255, 255, 255, 0) rgb(142, 201, 101) rgb(142, 201, 101) rgba(255, 255, 255, 0);box-sizing: border-box;">
															<svg viewBox="0 0 1 1"
																style="float:left;line-height:0;width:0;vertical-align:top;"
																role="img" aria-label="插图"></svg>
														</section>
													</section>
												</section>
												<section
													style="display: inline-block;vertical-align: top;width: auto;background-color: rgb(142, 201, 101);flex: 0 0 auto;align-self: stretch;min-width: 5%;max-width: 100%;height: auto;padding: 11px 14px 0px;box-sizing: border-box;">
													<section style="margin: 0px;box-sizing: border-box;">
														<section
															style="color: rgb(255, 255, 255);text-align: justify;box-sizing: border-box;">
															<p
																style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
																<strong style="box-sizing: border-box;"><span
																		leaf="" style="font-weight: 700;">真实案例：北京航空航天大学卓越工程师系统</span></strong>
															</p>
														</section>
													</section>
												</section>
												<section
													style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: stretch;box-sizing: border-box;">
													<section
														style="display: inline-block;width: 0px;height: 0px;vertical-align: top;overflow: hidden;border-style: solid;border-width: 24px 8px;border-color: rgb(142, 201, 101) rgba(255, 255, 255, 0) rgba(255, 255, 255, 0) rgb(142, 201, 101);box-sizing: border-box;">
														<svg viewBox="0 0 1 1"
															style="float:left;line-height:0;width:0;vertical-align:top;"
															role="img" aria-label="插图"></svg>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="margin: 0px 0px 10px;display: flex;flex-flow: row;justify-content: flex-start;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;background-color: rgb(225, 234, 225);margin: 0px;padding: 35px 26px 11px;flex: 0 0 auto;align-self: flex-start;height: auto;box-sizing: border-box;">
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf="">赢科于2023年成功为北京航空航天大学国家卓越工程师学院搭建了综合管理系统，并投入使用。该系统全面覆盖了从报名、面试、录取，到导师见面交流、学生月报年报、课题管理、成果上报和论文评阅等所有关键业务流程。</span>
							</p>
							<section
								style="display: flex;flex-flow: row;margin: 15px 0px;justify-content: flex-start;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;width: auto;min-width: 10%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-start;box-sizing: border-box;">
									<section
										style="font-size: 19px;margin: 0px 0%;text-align: left;box-sizing: border-box;">
										<section
											style="display: inline-block;border: 1px solid rgb(142, 201, 101);background-color: rgb(142, 201, 101);text-align: center;width: 1.8em;height: 1.8em;line-height: 1.8em;border-radius: 100%;margin-left: auto;margin-right: auto;font-size: 12px;color: rgb(255, 255, 255);box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">1</span></p>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: top;width: auto;flex: 100 100 0%;align-self: flex-start;height: auto;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span leaf="">管理透明化：</span></strong><span
											leaf="">学生管理全过程清晰可控，校领导、老师、管理者对项目状态一目了然，满足认证对管理效能的要求。</span></p>
								</section>
							</section>
							<section
								style="display: flex;flex-flow: row;margin: 15px 0px;justify-content: flex-start;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;width: auto;min-width: 10%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-start;box-sizing: border-box;">
									<section
										style="font-size: 19px;margin: 0px 0%;text-align: left;box-sizing: border-box;">
										<section
											style="display: inline-block;border: 1px solid rgb(142, 201, 101);background-color: rgb(142, 201, 101);text-align: center;width: 1.8em;height: 1.8em;line-height: 1.8em;border-radius: 100%;margin-left: auto;margin-right: auto;font-size: 12px;color: rgb(255, 255, 255);box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">2</span></p>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: top;width: auto;flex: 100 100 0%;align-self: flex-start;height: auto;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span leaf="">运营数字化：</span></strong><span
											leaf="">推动学生管理向无纸化、数字化、智能化转型，高效收集和管理各项数据，为认证提供强有力的数据支撑。</span></p>
								</section>
							</section>
							<section
								style="display: flex;flex-flow: row;margin: 15px 0px;justify-content: flex-start;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;width: auto;min-width: 10%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-start;box-sizing: border-box;">
									<section
										style="font-size: 19px;margin: 0px 0%;text-align: left;box-sizing: border-box;">
										<section
											style="display: inline-block;border: 1px solid rgb(142, 201, 101);background-color: rgb(142, 201, 101);text-align: center;width: 1.8em;height: 1.8em;line-height: 1.8em;border-radius: 100%;margin-left: auto;margin-right: auto;font-size: 12px;color: rgb(255, 255, 255);box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
													leaf="">3</span></p>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: top;width: auto;flex: 100 100 0%;align-self: flex-start;height: auto;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span leaf="">数据有价值：</span></strong><span
											leaf="">关键操作留痕，业务数据实时交叉统计分析，真正让数据为决策服务，助力学院持续改进与发展。</span></p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
							<section
								style="display: flex;flex-flow: row;text-align: left;justify-content: flex-start;margin: 10px 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: bottom;width: auto;flex: 0 0 0%;height: auto;align-self: flex-end;box-sizing: border-box;">
									<section
										style="transform: rotateZ(19deg);-webkit-transform: rotateZ(19deg);-moz-transform: rotateZ(19deg);-o-transform: rotateZ(19deg);box-sizing: border-box;">
										<section style="text-align: center;box-sizing: border-box;">
											<section
												style="display: inline-block;width: 3px;height: 34px;vertical-align: top;overflow: hidden;background-color: rgb(142, 201, 101);box-sizing: border-box;">
												<svg viewBox="0 0 1 1"
													style="float:left;line-height:0;width:0;vertical-align:top;" role="img"
													aria-label="插图"></svg>
											</section>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: top;width: auto;flex: 0 0 0%;align-self: stretch;height: auto;box-sizing: border-box;">
									<section style="text-align: right;box-sizing: border-box;">
										<section
											style="display: inline-block;width: 0px;height: 0px;vertical-align: top;overflow: hidden;border-style: solid;border-width: 24px 8px;border-color: rgba(255, 255, 255, 0) rgb(142, 201, 101) rgb(142, 201, 101) rgba(255, 255, 255, 0);box-sizing: border-box;">
											<svg viewBox="0 0 1 1"
												style="float:left;line-height:0;width:0;vertical-align:top;" role="img"
												aria-label="插图"></svg>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: top;width: auto;background-color: rgb(142, 201, 101);flex: 100 100 0%;align-self: stretch;height: auto;padding: 11px 14px 0px;box-sizing: border-box;">
									<section style="margin: 0px;box-sizing: border-box;">
										<section
											style="color: rgb(255, 255, 255);text-align: justify;box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<strong style="box-sizing: border-box;"><span
														leaf="" style="font-weight: 700;">未来展望：携手赢科，共创卓越！</span></strong>
											</p>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: top;width: auto;flex: 0 0 0%;height: auto;align-self: stretch;box-sizing: border-box;">
									<section style="box-sizing: border-box;">
										<section
											style="display: inline-block;width: 0px;height: 0px;vertical-align: top;overflow: hidden;border-style: solid;border-width: 24px 8px;border-color: rgb(142, 201, 101) rgba(255, 255, 255, 0) rgba(255, 255, 255, 0) rgb(142, 201, 101);box-sizing: border-box;">
											<svg viewBox="0 0 1 1"
												style="float:left;line-height:0;width:0;vertical-align:top;" role="img"
												aria-label="插图"></svg>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							leaf="">在国家大力建设教育强国、培养卓越工程师的时代背景下，赢科期待与您携手合作！</span></p>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							leaf=""><br></span></p>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							leaf="">让我们共同努力，打造符合国家战略需求的高层次工程技术人才摇篮，为实现中华民族伟大复兴的中国梦，贡献教育的磅礴力量！</span></p>
				</section>
			</div>`
	},
	{
		"id": 121374,
		"img": require("@/assets/news/04/01.jpg"),
		"title": "赢科携手北航，为中国高等教育打造「AI基建」",
		"date": "2025年9月24日 12:00",
		"content": `<div>
				<section
					style="box-sizing: border-box; font-style: normal; font-weight: 400; text-align: justify; font-size: 16px; color: rgb(62, 62, 62); visibility: visible; margin-bottom: 0px;">
					<section style="line-height: 0; box-sizing: border-box; visibility: visible; text-align:center;">
						<section
							style="max-width: 100%; vertical-align: middle; display: inline-block; line-height: 0; box-sizing: border-box; visibility: visible;"
							nodeleaf=""><img
								class="rich_pages wxw-img" data-ratio="0.6666666666666666" data-s="300,640" data-type="jpeg"
								data-w="1080"
								style="vertical-align: middle; max-width: 100%; width: 677px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
								data-imgfileid="503351929"
								data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
								data-index="4"
								src="@/assets/news/04/01.jpg"
								_width="100%" alt="图片" data-report-img-idx="2" data-fail="0"></section>
					</section>
					<section
						style="display: flex; width: 100%; flex-flow: column; box-sizing: border-box; visibility: visible;">
						<section style="height: auto; z-index: 2; box-sizing: border-box; visibility: visible;">
							<section
								style="text-align: center; justify-content: center; display: flex; flex-flow: row; margin: 10px 0px -10px; box-sizing: border-box; visibility: visible;">
								<section
									style="display: inline-block; vertical-align: top; width: 32px; align-self: flex-start; flex: 0 0 auto; height: auto; line-height: 0; box-sizing: border-box; visibility: visible;">
									<section
										style="transform: rotateZ(343deg); box-sizing: border-box; visibility: visible;">
										<section style="box-sizing: border-box; visibility: visible;">
											<section
												style="display: inline-block; width: 7px; height: 18px; vertical-align: top; overflow: hidden; background-color: rgb(255, 236, 89); border-radius: 75px; box-sizing: border-box; visibility: visible;">
												<section
													style="text-align: justify; box-sizing: border-box; visibility: visible;">
													<p
														style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
														<span leaf="" style="visibility: visible;"><br
																style="visibility: visible;"></span></p>
												</section>
											</section>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block; vertical-align: top; width: 32px; align-self: flex-start; flex: 0 0 auto; height: auto; line-height: 0; box-sizing: border-box; visibility: visible;">
									<section
										style="transform: rotateZ(17deg); box-sizing: border-box; visibility: visible;">
										<section style="box-sizing: border-box; visibility: visible;">
											<section
												style="display: inline-block; width: 7px; height: 18px; vertical-align: top; overflow: hidden; background-color: rgb(255, 236, 89); border-radius: 75px; box-sizing: border-box; visibility: visible;">
												<section
													style="text-align: justify; box-sizing: border-box; visibility: visible;">
													<p
														style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
														<span leaf="" style="visibility: visible;"><br
																style="visibility: visible;"></span></p>
												</section>
											</section>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: flex; width: 100%; flex-flow: column; box-sizing: border-box; visibility: visible;">
						<section style="z-index: 1; box-sizing: border-box; visibility: visible;">
							<section
								style="text-align: center; justify-content: center; display: flex; flex-flow: row; margin: 0px 0px 10px; box-sizing: border-box; visibility: visible;">
								<section
									style="display: inline-block; width: auto; vertical-align: top; align-self: flex-start; flex: 0 0 auto; background-color: rgb(180, 210, 6); min-width: 5%; max-width: 100%; height: auto; padding: 9px 16px; border-radius: 99%; overflow: hidden; box-sizing: border-box; visibility: visible;">
									<section style="margin: 6px 0px 0px; box-sizing: border-box; visibility: visible;">
										<section
											style="color: rgb(255, 255, 255); box-sizing: border-box; visibility: visible;">
											<p
												style="margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
												<strong style="box-sizing: border-box; visibility: visible;"><span leaf=""
														style="visibility: visible;">当央视的镜头对准大学的课堂</span></strong></p>
											<p
												style="margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
												<strong style="box-sizing: border-box; visibility: visible;"><span leaf=""
														style="visibility: visible;">我们在看什么？</span></strong></p>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left; justify-content: flex-start; display: flex; flex-flow: row; margin: -33px 0px 10px; box-sizing: border-box; visibility: visible;">
						<section
							style="display: inline-block; width: 100%; vertical-align: top; align-self: flex-start; flex: 0 0 auto; border-style: solid; border-width: 3px; border-color: rgba(180, 210, 6, 0.29); padding: 35px 19px 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="text-align: justify; color: rgb(0, 0, 0); box-sizing: border-box; visibility: visible;">
								<p
									style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
									<span leaf=""
										style="visibility: visible;">此前，一则央视《东方时空》的报道，让全国的目光聚焦在北京航空航天大学的智慧课堂。在这里，AI不再是遥远的概念，而是贯穿教学、科研、管理全过程的强大引擎。</span>
								</p>
								<p
									style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
									<span leaf="" style="visibility: visible;"><br style="visibility: visible;"></span></p>
							</section>
							<section style="line-height: 0; box-sizing: border-box; visibility: visible; text-align:center;">
								<section
									style="max-width: 100%; vertical-align: middle; display: inline-block; line-height: 0; box-sizing: border-box; visibility: visible;"
									nodeleaf=""><img
										class="rich_pages wxw-img" data-ratio="0.5166666666666667" data-s="300,640"
										data-type="jpeg" data-w="1080"
										style="vertical-align: middle; max-width: 100%; width: 633px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
										data-imgfileid="503351927"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="5"
										src="@/assets/news/04/02.jpg"
										_width="100%" alt="图片" data-report-img-idx="1" data-fail="0"></section>
							</section>
							<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">当教育数字化上升为国家战略，教育界普遍还在探讨“AI+教育”的可能路径时，北航已然给出了一个可观、可感、可触的答案。</span></p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
							</section>
							<section style="line-height: 0;box-sizing: border-box; text-align:center;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
									nodeleaf=""><img
										class="rich_pages wxw-img" data-ratio="0.6666666666666666" data-s="300,640"
										data-type="jpeg" data-w="1080"
										style="vertical-align: middle; max-width: 100%; width: 633px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
										data-imgfileid="503351928"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="6"
										src="@/assets/news/04/03.jpg"
										_width="100%" alt="图片" data-report-img-idx="3" data-fail="0"></section>
							</section>
							<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">而在这场备受瞩目的教育革新背后，赢科作为北航深度技术伙伴，深度参与并构建了其核心教学数字基座——</span><strong
										style="box-sizing: border-box;"><span leaf="">“智学北航”在线教学平台</span></strong><span
										leaf="">。我们所做的，不仅是交付一个系统，更是与顶尖学府共同探索未来教育的全新范式。</span></p>
							</section>
							<section
								style="text-align: right;margin: 0px 0px -3px;line-height: 0;transform: translate3d(22px, 0px, 0px);-webkit-transform: translate3d(22px, 0px, 0px);-moz-transform: translate3d(22px, 0px, 0px);-o-transform: translate3d(22px, 0px, 0px);box-sizing: border-box;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 27px;height: auto;box-sizing: border-box;"
									nodeleaf=""><img
										data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj6onvblfQm7wXZfMJiccFos1R0xnw2SljDFe7ze6dXic2kticPpCWtibtKlg/640?wx_fmt=png&amp;from=appmsg#imgIndex=4"
										class="rich_pages wxw-img" data-ratio="1.2224938875305624" data-s="300,640"
										data-type="png" data-w="409"
										style="vertical-align: middle; max-width: 100%; width: 27px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
										data-imgfileid="503351926"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="7"
										src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj6onvblfQm7wXZfMJiccFos1R0xnw2SljDFe7ze6dXic2kticPpCWtibtKlg/640?wx_fmt=png&amp;from=appmsg&amp;tp=webp&amp;wxfrom=5&amp;wx_lazy=1#imgIndex=4"
										_width="100%" alt="图片" data-report-img-idx="4" data-fail="0"></section>
							</section>
						</section>
					</section>
					<section style="padding: 0px 20px;box-sizing: border-box;">
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<span style="color: rgb(0, 154, 86);box-sizing: border-box;"><strong
									style="box-sizing: border-box;"><span leaf="">一场蓄谋已久的「教学革命」</span></strong></span></p>
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<span style="color: rgb(0, 154, 86);box-sizing: border-box;"><strong
									style="box-sizing: border-box;"><span leaf="">始于对每一个痛点的深刻洞悉</span></strong></span></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<span leaf="">在拥抱变革之前，我们必须直面当下高等教育普遍存在的困境：</span></p>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;height: auto;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="background-color: rgb(180, 210, 6);height: 1px;box-sizing: border-box;"><svg
										viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="background-color: rgb(180, 210, 6);height: 1px;box-sizing: border-box;"><svg
										viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
					</section>
					<section style="padding: 0px 20px;box-sizing: border-box;">
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<strong style="box-sizing: border-box;"><span leaf="">① &nbsp;课内与课外脱节</span></strong></p>
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<strong style="box-sizing: border-box;"><span leaf=""><br></span></strong></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">课内外教学功能缺乏体系化的顶层设计，导致预习、互动、作业等环节散落在不同工具中。学生的学习过程“下课即中断”，无法形成连续的学习闭环。同步与异步教学的优势无法充分结合，使得“翻转课堂”等高阶教学创新缺乏有效的平台支撑。</span>
						</p>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;height: auto;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="background-color: rgb(180, 210, 6);height: 1px;box-sizing: border-box;"><svg
										viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="background-color: rgb(180, 210, 6);height: 1px;box-sizing: border-box;"><svg
										viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
					</section>
					<section style="padding: 0px 20px;box-sizing: border-box;">
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<strong style="box-sizing: border-box;"><span leaf="">② &nbsp;</span><span
									style="text-align: justify;box-sizing: border-box;"><span
										leaf="">线上与线下脱节</span></span></strong></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">物理课堂与线上空间成为体验割裂的“两个世界”。由于缺乏统一的教学设计与互动逻辑，导致适用教学场景单一且缺乏弹性，同一课程无法按需灵活选择教学形式，真正的“混合式教学”模式难以有效落地。</span>
						</p>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;height: auto;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="background-color: rgb(180, 210, 6);height: 1px;box-sizing: border-box;"><svg
										viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="background-color: rgb(180, 210, 6);height: 1px;box-sizing: border-box;"><svg
										viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
					</section>
					<section style="padding: 0px 20px;box-sizing: border-box;">
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<strong style="box-sizing: border-box;"><span leaf="">③ &nbsp;</span><span
									style="text-align: justify;box-sizing: border-box;"><span
										leaf="">资源与应用脱节</span></span></strong></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">各系统标准不一，形成“平台壁垒”与“数据孤岛”，导致云端和校内的海量数字资产无法被高效激活与复用。教师查找资源如同“大海捞针”，跨平台应用需进行繁琐的“人工搬家”，严重抑制了优质资源的共享与流通。</span>
						</p>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;height: auto;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="background-color: rgb(180, 210, 6);height: 1px;box-sizing: border-box;"><svg
										viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="margin: 0px 0px 8px;box-sizing: border-box;">
								<section style="background-color: rgb(180, 210, 6);height: 1px;box-sizing: border-box;"><svg
										viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
					</section>
					<section style="padding: 0px 20px;box-sizing: border-box;">
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<strong style="box-sizing: border-box;"><span leaf="">④ &nbsp;</span><span
									style="text-align: justify;box-sizing: border-box;"><span
										leaf="">管理与实施脱节</span></span></strong></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">微信群、小程序等即时性工具的泛滥，使得教学过程严重碎片化。管理粒度只能局限于“一门课”甚至“一堂课”，无法进行体系化的教学运行管理。更严重的是，基础性教学过程数据无法自动采集与沉淀，导致管理者沦为“数据盲人”，难以进行科学的质量评价与决策。</span>
						</p>
					</section>
					<section style="padding: 0px 20px;box-sizing: border-box;">
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
								style="box-sizing: border-box;"><span
									style="color: rgb(0, 154, 86);box-sizing: border-box;"><span
										leaf="">“智学北航”的诞生，正是为了终结这些困扰，将教学体验从「繁杂」推向「极简」，从「分散」推向「融合」。</span></span></strong>
						</p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
								style="box-sizing: border-box;"><span
									style="color: rgb(0, 154, 86);box-sizing: border-box;"><span
										leaf=""><br></span></span></strong></p>
					</section>
					<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
						<section style="z-index: 1;box-sizing: border-box;">
							<section
								style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
								<section
									style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgb(180, 210, 6);min-width: 5%;max-width: 100%;height: auto;padding: 9px 16px;border-radius: 99%;overflow: hidden;box-sizing: border-box;">
									<section style="margin: 6px 0px 0px;box-sizing: border-box;">
										<section
											style="text-align: justify;color: rgb(255, 255, 255);box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<strong style="box-sizing: border-box;"><span
														leaf="">“智学北航”——AI赋能解决方案</span></strong></p>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: -33px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;border-style: solid;border-width: 3px;border-color: rgba(180, 210, 6, 0.29);padding: 35px 19px 0px;box-sizing: border-box;">
							<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">北京赢科天地电子有限公司与北京航空航天大学精诚合作，通过打造“智学北航”在线教学平台，提供了一种全新的AI赋能在线教学方案，完美契合了现代教育的需求。该平台通过AI技术全面赋能，突破了传统教学的局限，打破了时空限制，提供个性化的学习体验。平台不仅为学生提供了智能答疑、编程助手等功能，也为教师提供了智能备课、智能批阅等多项高效工具，极大地提升了教学效率。</span>
								</p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
							</section>
							<section style="line-height: 0;box-sizing: border-box; text-align:center;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
									nodeleaf=""><img
										class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
										data-ratio="0.4968085106382979" data-s="300,640" data-type="png" data-w="940"
										style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(2.01285) / 1; width: 633px !important; height: auto !important;"
										data-imgfileid="503351932"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="8"
										src="@/assets/news/04/04.png"
										_width="100%" alt="图片"></section>
							</section>
							<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">智学北航平台的优势在于其无缝连接线上线下多场景的教学需求，帮助教师和学生实现教学管理、学习、评估等各环节的智能化操作，推动教育与技术的深度融合。通过平台的AI技术，教学质量得到显著提升，教育资源得到了更加精准和高效的配置。</span>
								</p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">该平台由</span><strong style="box-sizing: border-box;"><span
											style="color: rgb(0, 154, 86);box-sizing: border-box;"><span
												leaf="">“全过程交互式在线教学平台</span></span></strong><span leaf="">”与“</span><span
										style="color: rgb(0, 154, 86);box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span
												leaf="">个性化、伴随式AI教学助手</span></strong></span><span
										leaf="">”两大核心引擎构成，双引擎协同驱动，构成了完整的智慧教学解决方案。</span></p>
							</section>
							<section
								style="text-align: right;margin: 0px 0px -3px;line-height: 0;transform: translate3d(22px, 0px, 0px);-webkit-transform: translate3d(22px, 0px, 0px);-moz-transform: translate3d(22px, 0px, 0px);-o-transform: translate3d(22px, 0px, 0px);box-sizing: border-box;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 27px;height: auto;box-sizing: border-box;"
									nodeleaf=""><img
										data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj6onvblfQm7wXZfMJiccFos1R0xnw2SljDFe7ze6dXic2kticPpCWtibtKlg/640?wx_fmt=png&amp;from=appmsg#imgIndex=6"
										class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
										data-ratio="1.2224938875305624" data-s="300,640" data-type="png" data-w="409"
										style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(0.818) / 1; width: 27px !important; height: auto !important;"
										data-imgfileid="503351931"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="9"
										src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
										_width="100%" alt="图片"></section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;border-radius: 335px;overflow: hidden;padding: 3px;background-image: conic-gradient(rgb(180, 210, 6) 0%, rgba(180, 210, 6, 0.09) 96%);box-sizing: border-box;">
							<section style="text-align: center;box-sizing: border-box;">
								<section
									style="display: inline-block;width: 26px;height: 26px;vertical-align: top;overflow: hidden;border-radius: 142px;background-color: rgb(255, 255, 255);box-sizing: border-box;">
									<section style="color: rgb(180, 210, 6);box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span leaf="">1</span></strong></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="text-align: justify;color: rgb(210, 32, 26);box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span
											style="color: rgb(62, 62, 62);box-sizing: border-box;"><span
												leaf="">全过程、交互式在线教学平台</span></span></strong></p>
							</section>
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section style="background-color: rgb(255, 236, 89);height: 3px;box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;border-style: solid;border-width: 0px 0px 0px 3px;border-left-color: rgba(180, 210, 6, 0.29);height: auto;margin: 0px 0px 0px 14px;padding: 6px 0px 0px 20px;box-sizing: border-box;">
							<section style="margin: 0px 0px 10px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
											leaf="">本平台是覆盖教学管理全生命周期的数字基座，其核心架构围绕“教务”、“教学”、“教室”三大场域的数据与服务接口进行设计，确保信息的互联互通。通过统一门户、身份认证与权限管理，为学生、教师、管理人员提供一体化服务。</span>
									</p>
								</section>
							</section>
							<section style="line-height: 0;box-sizing: border-box; text-align:center;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
									nodeleaf=""><img
										
										class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
										data-ratio="0.38981481481481484" data-s="300,640" data-type="png" data-w="1080"
										style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(2.56532) / 1; width: 640px !important; height: auto !important;"
										data-imgfileid="503351933"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="10"
										src="@/assets/news/04/05.png"
										_width="100%" alt="图片"></section>
							</section>
							<section style="margin: 0px 0px 10px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
											leaf=""><br></span></p>
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
											style="color: rgb(180, 210, 6);box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span
													leaf="">功能覆盖教学八大核心环节，实现全过程闭环管理：</span></strong></span></p>
								</section>
							</section>
							<section style="margin: 0px 0px 10px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
									<ol style="list-style-type: decimal;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
										class="list-paddingleft-1">
										<li style="box-sizing: border-box;">
											<p style="margin: 0px 0px 12px;padding: 0px;box-sizing: border-box;"><strong
													style="box-sizing: border-box;"><span leaf="">计划同步：</span></strong><span
													leaf="">与教务系统深度集成，自动同步排选课信息，生成师生教学日历。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px 0px 12px;padding: 0px;box-sizing: border-box;"><strong
													style="box-sizing: border-box;"><span leaf="">教师备课：</span></strong><span
													leaf="">提供结构化的备课环境，支持课前、课中、课后三环节教学资源与活动的模块化准备。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px 0px 12px;padding: 0px;box-sizing: border-box;"><strong
													style="box-sizing: border-box;"><span leaf="">课内教学：</span></strong><span
													leaf="">支持平台内置直播与“腾讯会议”双模式融合的线上教学，并与线下智慧教室软硬件生态深度融合，保障线上线下教学模式的无缝切换与一致体验。</span>
											</p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px 0px 12px;padding: 0px;box-sizing: border-box;"><strong
													style="box-sizing: border-box;"><span leaf="">课外教学：</span></strong><span
													leaf="">完备支持课前预习、课后作业、在线测试、研讨交流与答疑辅导，将教学活动从课内有效延伸至课外。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px 0px 12px;padding: 0px;box-sizing: border-box;"><strong
													style="box-sizing: border-box;"><span leaf="">在线考试：</span></strong><span
													leaf="">提供从在线组卷、智能组考、过程监控到线上阅卷、成绩发布的完整考试解决方案。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px 0px 12px;padding: 0px;box-sizing: border-box;"><strong
													style="box-sizing: border-box;"><span leaf="">评教评学：</span></strong><span
													leaf="">建立师生双向、快捷的评价反馈机制，数据可用于教学质量分析。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px 0px 12px;padding: 0px;box-sizing: border-box;"><strong
													style="box-sizing: border-box;"><span leaf="">督导巡课：</span></strong><span
													leaf="">为教学管理人员提供远程、实时、可回溯的线上督导巡课功能。</span></p>
										</li>
										<li style="box-sizing: border-box;">
											<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
													style="box-sizing: border-box;"><span leaf="">教学分析：</span></strong><span
													leaf="">基于大数据技术，对教学全过程数据进行沉淀与多维度统计分析，生成可视化报告，为教学评估与科学决策提供数据支撑。</span>
											</p>
										</li>
									</ol>
								</section>
							</section>
							<section style="line-height: 0;box-sizing: border-box; text-align:center;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
									nodeleaf=""><img
										class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
										data-ratio="0.44166666666666665" data-s="300,640" data-type="png" data-w="1080"
										style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(2.26415) / 1; width: 640px !important; height: auto !important;"
										data-imgfileid="503351935"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="11"
										src="@/assets/news/04/06.png"
										_width="100%" alt="图片"></section>
							</section>
							<section style="text-align: justify;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
							</section>
							<section style="text-align: justify;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">平台秉持</span><strong style="box-sizing: border-box;"><span
											style="color: rgb(0, 154, 86);box-sizing: border-box;"><span
												leaf="">“教无定法”</span></span></strong><span
										leaf="">的设计原则，功能模块高度自由、轻度耦合，教师可根据课程需求与教学风格，灵活组合使用，支持从基础教学到高阶混合式、翻转式教学的各类应用场景。</span>
								</p>
							</section>
							<section style="text-align: justify;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;border-radius: 335px;overflow: hidden;padding: 3px;background-image: conic-gradient(rgb(180, 210, 6) 0%, rgba(180, 210, 6, 0.09) 96%);box-sizing: border-box;">
							<section style="text-align: center;box-sizing: border-box;">
								<section
									style="display: inline-block;width: 26px;height: 26px;vertical-align: top;overflow: hidden;border-radius: 142px;background-color: rgb(255, 255, 255);box-sizing: border-box;">
									<section style="color: rgb(180, 210, 6);box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span leaf="">2</span></strong></p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
							<section style="text-align: justify;color: rgb(210, 32, 26);box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span
											style="color: rgb(62, 62, 62);box-sizing: border-box;"><span
												leaf="">个性化、伴随式AI教学助手</span></span></strong></p>
							</section>
							<section style="text-align: center;margin: 0px;box-sizing: border-box;">
								<section style="background-color: rgb(255, 236, 89);height: 3px;box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;border-style: solid;border-width: 0px 0px 0px 3px;border-left-color: rgba(180, 210, 6, 0.29);height: auto;margin: 0px 0px 0px 14px;padding: 0px 0px 0px 20px;box-sizing: border-box;">
							<section style="margin: 0px 0px 10px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
											leaf="">以“</span><strong style="box-sizing: border-box;"><span
												leaf="">把人工智能技术深入到教育教学和管理的全过程</span></strong><span
											leaf="">”为指导思想，采用通用大语言模型（LLM）+垂直领域检索增强（RAG）的技术路线，构建了一系列嵌入式、服务化的AI教学助手。</span>
									</p>
								</section>
							</section>
							<section style="line-height: 0;box-sizing: border-box; text-align:center;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
									nodeleaf=""><img
										class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
										data-ratio="0.3962962962962963" data-s="300,640" data-type="png" data-w="1080"
										style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(2.52336) / 1; width: 640px !important; height: auto !important;"
										data-imgfileid="503351934"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="12"
										src="@/assets/news/04/07.png"
										_width="100%" alt="图片"></section>
							</section>
							<section style="margin: 0px 0px 10px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
											leaf=""><br></span></p>
								</section>
							</section>
							<section style="text-align: justify;box-sizing: border-box;">
								<p style="margin: 0px 0px 12px;white-space: normal;padding: 0px;box-sizing: border-box;">
									<span style="color: rgb(180, 210, 6);box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span leaf="">核心技术架构：</span></strong></span></p>
								<p style="margin: 0px 0px 12px;white-space: normal;padding: 0px;box-sizing: border-box;">
									<span leaf="">赢科AI引擎该引擎通过模块化设计，高效整合了数据处理、检索增强、LLM调度与应用接口，可灵活接入国内外主流大模型。</span></p>
							</section>
							<section style="line-height: 0;box-sizing: border-box; text-align:center;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
									nodeleaf=""><img
										class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
										data-ratio="0.49907407407407406" data-s="300,640" data-type="png" data-w="1080"
										style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(2.00371) / 1; width: 640px !important; height: auto !important;"
										data-imgfileid="503351940"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="13"
										src="@/assets/news/04/08.png"
										_width="100%" alt="图片"></section>
							</section>
							<section style="text-align: justify;box-sizing: border-box;">
								<p style="margin: 0px 0px 12px;white-space: normal;padding: 0px;box-sizing: border-box;">
									<span leaf=""><br></span></p>
							</section>
							<section style="text-align: justify;box-sizing: border-box;">
								<p style="margin: 0px 0px 12px;white-space: normal;padding: 0px;box-sizing: border-box;">
									<span style="color: rgb(180, 210, 6);box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span
												leaf="">覆盖六大核心智能应用场景：</span></strong></span></p>
								<p style="margin: 0px 0px 12px;white-space: normal;padding: 0px;box-sizing: border-box;">
									<strong style="box-sizing: border-box;"><span leaf="">智能答疑：</span></strong><span
										leaf="">为学生提供7x24小时课程知识问答服务，具备答案复核与合规控制机制。</span></p>
								<p style="margin: 0px 0px 12px;white-space: normal;padding: 0px;box-sizing: border-box;">
									<strong style="box-sizing: border-box;"><span leaf="">智能纠错：</span></strong><span
										leaf="">针对编程等实践类课程，提供代码错误分析、解题思路提示与AI错题本功能。</span></p>
								<p style="margin: 0px 0px 12px;white-space: normal;padding: 0px;box-sizing: border-box;">
									<strong style="box-sizing: border-box;"><span leaf="">智能摘要：</span></strong><span
										leaf="">对课程视频、PPT、文献等教学资源进行一键式内容摘要、关键字段落总结。</span></p>
								<p style="margin: 0px 0px 12px;white-space: normal;padding: 0px;box-sizing: border-box;">
									<strong style="box-sizing: border-box;"><span leaf="">智能备课：</span></strong><span
										leaf="">辅助教师进行课程大纲设计、内容建议生成和教学资源推荐。</span></p>
								<p style="margin: 0px 0px 12px;white-space: normal;padding: 0px;box-sizing: border-box;">
									<strong style="box-sizing: border-box;"><span leaf="">智能命题：</span></strong><span
										leaf="">基于知识点自动生成各类型题目，支持题库管理与智能组卷。</span></p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span leaf="">智能批阅：</span></strong><span
										leaf="">对主观题进行AI辅助评分和评语生成，支持教师一键确认与修正。</span></p>
							</section>
						</section>
					</section>
					<section
						style="text-align: center;justify-content: center;margin: 10px 0%;display: flex;flex-flow: row;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;align-self: center;height: auto;box-sizing: border-box;">
							<section style="margin: 0px 0%;box-sizing: border-box;">
								<section style="background-color: rgb(220, 237, 200);height: 1px;box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: 40px;flex: 0 0 auto;height: auto;align-self: center;margin: 0px 15px;box-sizing: border-box;">
							<section style="margin-top: 10px;margin-bottom: 10px;line-height: 0;box-sizing: border-box;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
									nodeleaf=""><img
										data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj6rwC6mibnJCJT56UNkG4fOMMHWhw1O6jiaUNgMuwjTj4cDp3eGF1libhfg/640?wx_fmt=png&amp;from=appmsg#imgIndex=11"
										class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
										data-ratio="0.9005681818181818" data-s="300,640" data-type="png" data-w="1056"
										style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.11041) / 1; width: 40px !important; height: auto !important;"
										data-imgfileid="503351939"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="14"
										src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
										_width="100%" alt="图片"></section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;align-self: center;height: auto;box-sizing: border-box;">
							<section style="margin: 0px 0%;box-sizing: border-box;">
								<section style="background-color: rgb(220, 237, 200);height: 1px;box-sizing: border-box;">
									<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
										role="img" aria-label="插图"></svg></section>
							</section>
						</section>
					</section>
					<section style="color: rgb(0, 154, 86);box-sizing: border-box;">
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<strong style="box-sizing: border-box;"><span leaf="">「赢科方案」：不止是平台，更是智慧教育新生态</span></strong></p>
						<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
							<strong style="box-sizing: border-box;"><span leaf=""><br></span></strong></p>
					</section>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							leaf="">我们致力于将前沿AI科技融入教育血脉，以“智学北航”为核心，为您呈现如何构建一个超越传统教学平台、面向未来的智慧教育新生态，真正驱动高等教育的全面升级与创新。</span>
					</p>
					<section
						style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;background-color: rgb(180, 210, 6);height: auto;margin: 0px 7px 0px 0px;padding: 9px;border-top-left-radius: 32px;border-bottom-left-radius: 32px;overflow: hidden;box-sizing: border-box;">
							<section
								style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;box-sizing: border-box;">
									<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
										<section style="z-index: 1;box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section data-cacheurl="" data-remoteid=""
													style="display: inline-block; width: 23px; height: 23px; vertical-align: top; overflow: hidden; background-repeat: no-repeat; background-attachment: scroll; box-sizing: border-box; background-image: url(&quot;data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg==&quot;); background-size: contain !important; background-position: 50% 50% !important;"
													data-lazy-bgimg="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj69oZttet9RSf7CyOHekoTic0D3CgstgEH0W8iauwmd1JGOA5wowIycicPw/640?wx_fmt=png&amp;from=appmsg"
													class="wx_imgbc_placeholder">
													<section style="text-align: center;box-sizing: border-box;">
														<section
															style="font-size: 15px;color: rgb(142, 201, 101);box-sizing: border-box;">
															<p style="margin: 0px;padding: 0px;box-sizing: border-box;">
																<span leaf=""><br></span></p>
														</section>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;padding: 0px 0px 0px 8px;box-sizing: border-box;">
									<section style="text-align: justify;color: rgb(255, 255, 255);box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<strong style="box-sizing: border-box;"><span leaf="">一体化重构教学「场」</span></strong>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: top;width: 0%;align-self: flex-start;flex: 0 0 auto;background-color: rgb(245, 245, 245);border-radius: 10px;overflow: hidden;height: auto;margin: 0px -8px 0px 0px;padding: 21px;box-sizing: border-box;">
							<section style="text-align: justify;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-start;box-sizing: border-box;">
							<section style="margin: -10px 0px 0px;line-height: 0;box-sizing: border-box;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 16px;height: auto;box-sizing: border-box;"
									nodeleaf=""><img
										data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj6fVbQW8aKNiaSiaAplBzibZMTKVr8vh6QSHUrEyIMd4CyiblJ3kHUsbeUXw/640?wx_fmt=png&amp;from=appmsg#imgIndex=12"
										class="rich_pages wxw-img wx_img_placeholder_mini" data-ratio="0.9907407407407407"
										data-s="300,640" data-type="png" data-w="1080"
										style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.00935) / 1; width: 16px !important; height: auto !important;"
										data-imgfileid="503351938"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="15"
										src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
										_width="100%" alt="图片"></section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 13px 0px 10px;width: 100%;align-self: flex-start;padding: 0px 25px;overflow: hidden;box-sizing: border-box;">
						<section style="text-align: justify;width: 100%;box-sizing: border-box;">
							<p
								style="margin: 0px 0px 5px;text-align: left;white-space: normal;padding: 0px;box-sizing: border-box;">
								<span style="text-align: justify;box-sizing: border-box;"><span
										leaf="">让知识流动，无界发生。打破了物理与数字的壁垒，将所有教学环节无缝衔接，构建了一个连贯的教学体验闭环。</span></span></p>
							<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
								class="list-paddingleft-2">
								<li style="box-sizing: border-box;">
									<p style="margin: 0px 0px 5px;padding: 0px;box-sizing: border-box;"><span
											leaf="">统一入口：所有课程通知、学习资源、作业DDL、互动讨论，在一个平台内完成，实现“信息零损耗、沟通零距离”。</span></p>
								</li>
								<li style="box-sizing: border-box;">
									<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
											leaf="">资源激活：教师可一键复用历史课程资产，灵活组织章节、周次等多种教学模式；学生可一键下载所有资料，学习路径清晰明了。</span></p>
								</li>
							</ul>
						</section>
					</section>
					<section
						style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;background-color: rgb(180, 210, 6);height: auto;margin: 0px 7px 0px 0px;padding: 9px;border-top-left-radius: 32px;border-bottom-left-radius: 32px;overflow: hidden;box-sizing: border-box;">
							<section
								style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;box-sizing: border-box;">
									<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
										<section style="z-index: 1;box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section data-cacheurl="" data-remoteid=""
													style="display: inline-block; width: 23px; height: 23px; vertical-align: top; overflow: hidden; background-repeat: no-repeat; background-attachment: scroll; box-sizing: border-box; background-image: url(&quot;data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg==&quot;); background-size: contain !important; background-position: 50% 50% !important;"
													data-lazy-bgimg="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj69oZttet9RSf7CyOHekoTic0D3CgstgEH0W8iauwmd1JGOA5wowIycicPw/640?wx_fmt=png&amp;from=appmsg"
													class="wx_imgbc_placeholder">
													<section style="text-align: center;box-sizing: border-box;">
														<section
															style="font-size: 15px;color: rgb(142, 201, 101);box-sizing: border-box;">
															<p style="margin: 0px;padding: 0px;box-sizing: border-box;">
																<span leaf=""><br></span></p>
														</section>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;padding: 0px 0px 0px 8px;box-sizing: border-box;">
									<section style="text-align: justify;color: rgb(255, 255, 255);box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<strong style="box-sizing: border-box;"><span leaf="">个性化释放师生「力」</span></strong>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: top;width: 0%;align-self: flex-start;flex: 0 0 auto;background-color: rgb(245, 245, 245);border-radius: 10px;overflow: hidden;height: auto;margin: 0px -8px 0px 0px;padding: 21px;box-sizing: border-box;">
							<section style="text-align: justify;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-start;box-sizing: border-box;">
							<section style="margin: -10px 0px 0px;line-height: 0;box-sizing: border-box;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 16px;height: auto;box-sizing: border-box;"
									nodeleaf=""><img
										data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj6fVbQW8aKNiaSiaAplBzibZMTKVr8vh6QSHUrEyIMd4CyiblJ3kHUsbeUXw/640?wx_fmt=png&amp;from=appmsg#imgIndex=13"
										class="rich_pages wxw-img wx_img_placeholder_mini" data-ratio="0.9907407407407407"
										data-s="300,640" data-type="png" data-w="1080"
										style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.00935) / 1; width: 16px !important; height: auto !important;"
										data-imgfileid="503351937"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="16"
										src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
										_width="100%" alt="图片"></section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 13px 0px 10px;width: 100%;align-self: flex-start;padding: 0px 25px;overflow: hidden;box-sizing: border-box;">
						<section style="text-align: justify;width: 100%;box-sizing: border-box;">
							<p style="margin: 0px 0px 5px;white-space: normal;padding: 0px;box-sizing: border-box;"><span
									leaf="">AI赋能，因材施教。这是“智学北航”平台最激动人心的部分，AI技术正成为师生最强大的教学与学习伙伴。</span></p>
							<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
								class="list-paddingleft-2">
								<li style="box-sizing: border-box;">
									<p style="margin: 0px 0px 5px;padding: 0px;box-sizing: border-box;"><span
											leaf="">为教师减负增效：AI智能剪辑录播视频，让教师轻松制作精品微课；作业全流程无纸化、数据化，让教师从繁琐事务中解放，回归育人本质。</span>
									</p>
								</li>
								<li style="box-sizing: border-box;">
									<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
											leaf="">为学生精准导航：课程回放视频与PPT智能关联，拖动进度条即可精准定位；AI自动生成个性化错题集，“数字孪生”你的知识盲区，实现高效查漏补缺</span>
									</p>
								</li>
							</ul>
						</section>
					</section>
					<section
						style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;background-color: rgb(180, 210, 6);height: auto;margin: 0px 7px 0px 0px;padding: 9px;border-top-left-radius: 32px;border-bottom-left-radius: 32px;overflow: hidden;box-sizing: border-box;">
							<section
								style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;box-sizing: border-box;">
									<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
										<section style="z-index: 1;box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section data-cacheurl="" data-remoteid=""
													style="display: inline-block; width: 23px; height: 23px; vertical-align: top; overflow: hidden; background-repeat: no-repeat; background-attachment: scroll; box-sizing: border-box; background-image: url(&quot;data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg==&quot;); background-size: contain !important; background-position: 50% 50% !important;"
													data-lazy-bgimg="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj69oZttet9RSf7CyOHekoTic0D3CgstgEH0W8iauwmd1JGOA5wowIycicPw/640?wx_fmt=png&amp;from=appmsg"
													class="wx_imgbc_placeholder">
													<section style="text-align: center;box-sizing: border-box;">
														<section
															style="font-size: 15px;color: rgb(142, 201, 101);box-sizing: border-box;">
															<p style="margin: 0px;padding: 0px;box-sizing: border-box;">
																<span leaf=""><br></span></p>
														</section>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;padding: 0px 0px 0px 8px;box-sizing: border-box;">
									<section style="text-align: justify;color: rgb(255, 255, 255);box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<strong style="box-sizing: border-box;"><span leaf="">智慧化驱动治理「智」</span></strong>
										</p>
									</section>
								</section>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: top;width: 0%;align-self: flex-start;flex: 0 0 auto;background-color: rgb(245, 245, 245);border-radius: 10px;overflow: hidden;height: auto;margin: 0px -8px 0px 0px;padding: 21px;box-sizing: border-box;">
							<section style="text-align: justify;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
							</section>
						</section>
						<section
							style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-start;box-sizing: border-box;">
							<section style="margin: -10px 0px 0px;line-height: 0;box-sizing: border-box;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 16px;height: auto;box-sizing: border-box;"
									nodeleaf=""><img
										data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj6fVbQW8aKNiaSiaAplBzibZMTKVr8vh6QSHUrEyIMd4CyiblJ3kHUsbeUXw/640?wx_fmt=png&amp;from=appmsg#imgIndex=14"
										class="rich_pages wxw-img wx_img_placeholder_mini" data-ratio="0.9907407407407407"
										data-s="300,640" data-type="png" data-w="1080"
										style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.00935) / 1; width: 16px !important; height: auto !important;"
										data-imgfileid="503351936"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="17"
										src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
										_width="100%" alt="图片"></section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 13px 0px 10px;width: 100%;align-self: flex-start;padding: 0px 25px;overflow: hidden;box-sizing: border-box;">
						<section style="text-align: justify;width: 100%;box-sizing: border-box;">
							<p style="margin: 0px 0px 5px;white-space: normal;padding: 0px;box-sizing: border-box;"><span
									leaf="">数据罗盘，科学决策。我们为北航打造了强大的“教学数据驾驶舱”，让校园管理者拥有了洞察全局的“智慧中枢”。</span></p>
							<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
								class="list-paddingleft-2">
								<li style="box-sizing: border-box;">
									<p style="margin: 0px 0px 5px;padding: 0px;box-sizing: border-box;"><span
											leaf="">通过AI课堂分析、教学过程数据沉淀，实时动态掌握全校教风学风。</span></p>
								</li>
								<li style="box-sizing: border-box;">
									<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
											leaf="">教学效果不再是模糊的“感觉”，而是清晰可视的“数据”，推动教育评估与决策从“经验驱动”向“数据智能驱动”深刻转型。</span></p>
								</li>
							</ul>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 10px 0px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: top;width: 50%;align-self: flex-start;flex: 0 0 auto;box-sizing: border-box;">
							<section
								style="transform: perspective(0px);-webkit-transform: perspective(0px);-moz-transform: perspective(0px);-o-transform: perspective(0px);transform-style: flat;box-sizing: border-box;">
								<section
									style="transform: rotateX(180deg);-webkit-transform: rotateX(180deg);-moz-transform: rotateX(180deg);-o-transform: rotateX(180deg);box-sizing: border-box;">
									<section
										style="display: inline-block;width: 8px;height: 8px;vertical-align: top;overflow: hidden;background-color: rgb(180, 210, 6);box-sizing: border-box;">
										<section style="text-align: justify;box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<span leaf=""><br></span></p>
										</section>
									</section>
								</section>
							</section>
						</section>
						<section style="display: inline-block;vertical-align: top;width: 50%;box-sizing: border-box;">
							<section
								style="transform: perspective(0px);-webkit-transform: perspective(0px);-moz-transform: perspective(0px);-o-transform: perspective(0px);transform-style: flat;box-sizing: border-box;">
								<section
									style="transform: rotateX(180deg) rotateY(180deg);-webkit-transform: rotateX(180deg) rotateY(180deg);-moz-transform: rotateX(180deg) rotateY(180deg);-o-transform: rotateX(180deg) rotateY(180deg);box-sizing: border-box;">
									<section
										style="display: inline-block;width: 8px;height: 8px;vertical-align: top;overflow: hidden;background-color: rgb(180, 210, 6);box-sizing: border-box;">
										<section style="text-align: justify;box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<span leaf=""><br></span></p>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: -2px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;border-style: solid;border-width: 1px;border-color: rgb(180, 210, 6);height: auto;margin: 0px 6px;padding: 14px 24px 0px;box-sizing: border-box;">
							<section
								style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: -28px 0px 10px;box-sizing: border-box;">
								<section
									style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;background-color: rgb(255, 255, 255);padding: 0px 8px;box-sizing: border-box;">
									<section
										style="justify-content: center;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
										<section
											style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;box-sizing: border-box;">
											<section style="margin: 0px;line-height: 0;box-sizing: border-box;">
												<section
													style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 16px;height: auto;box-sizing: border-box;"
													nodeleaf=""><img
														data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj6raicnvMibJFg7hIrialufyPDDMTKVA2jtIicsHNNic2KRc8LX2aJMxPRCicw/640?wx_fmt=png&amp;from=appmsg#imgIndex=15"
														class="rich_pages wxw-img wx_img_placeholder_mini"
														data-ratio="1.358" data-s="300,640" data-type="png" data-w="500"
														style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(0.736377) / 1; width: 16px !important; height: auto !important;"
														data-imgfileid="503351943"
														data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
														data-index="18"
														src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
														_width="100%" alt="图片"></section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: middle;width: auto;flex: 0 0 0%;height: auto;margin: 0px -4px 0px 0px;align-self: center;box-sizing: border-box;">
											<section
												style="transform: rotateZ(13deg);-webkit-transform: rotateZ(13deg);-moz-transform: rotateZ(13deg);-o-transform: rotateZ(13deg);box-sizing: border-box;">
												<section style="box-sizing: border-box;">
													<section
														style="display: inline-block;width: 18px;height: 29px;vertical-align: top;overflow: hidden;border-radius: 99%;background-color: rgb(180, 210, 6);box-sizing: border-box;">
														<section style="text-align: justify;box-sizing: border-box;">
															<p
																style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
																<span leaf=""><br></span></p>
														</section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: middle;width: auto;flex: 0 0 0%;height: auto;margin: 0px -4px 0px 0px;align-self: center;box-sizing: border-box;">
											<section
												style="transform: rotateZ(13deg);-webkit-transform: rotateZ(13deg);-moz-transform: rotateZ(13deg);-o-transform: rotateZ(13deg);box-sizing: border-box;">
												<section style="box-sizing: border-box;">
													<section
														style="display: inline-block;width: 18px;height: 29px;vertical-align: top;overflow: hidden;border-radius: 99%;background-color: rgb(180, 210, 6);box-sizing: border-box;">
														<section style="text-align: justify;box-sizing: border-box;">
															<p
																style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
																<span leaf=""><br></span></p>
														</section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: middle;width: auto;flex: 0 0 0%;height: auto;margin: 0px -4px 0px 0px;align-self: center;box-sizing: border-box;">
											<section
												style="transform: rotateZ(13deg);-webkit-transform: rotateZ(13deg);-moz-transform: rotateZ(13deg);-o-transform: rotateZ(13deg);box-sizing: border-box;">
												<section style="box-sizing: border-box;">
													<section
														style="display: inline-block;width: 18px;height: 29px;vertical-align: top;overflow: hidden;border-radius: 99%;background-color: rgb(180, 210, 6);box-sizing: border-box;">
														<section style="text-align: justify;box-sizing: border-box;">
															<p
																style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
																<span leaf=""><br></span></p>
														</section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: middle;width: auto;flex: 0 0 0%;height: auto;margin: 0px -4px 0px 0px;align-self: center;box-sizing: border-box;">
											<section
												style="transform: rotateZ(13deg);-webkit-transform: rotateZ(13deg);-moz-transform: rotateZ(13deg);-o-transform: rotateZ(13deg);box-sizing: border-box;">
												<section style="box-sizing: border-box;">
													<section
														style="display: inline-block;width: 18px;height: 29px;vertical-align: top;overflow: hidden;border-radius: 99%;background-color: rgb(180, 210, 6);box-sizing: border-box;">
														<section style="text-align: justify;box-sizing: border-box;">
															<p
																style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
																<span leaf=""><br></span></p>
														</section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: middle;width: auto;flex: 0 0 0%;height: auto;margin: 0px -4px 0px 0px;align-self: center;box-sizing: border-box;">
											<section
												style="transform: rotateZ(13deg);-webkit-transform: rotateZ(13deg);-moz-transform: rotateZ(13deg);-o-transform: rotateZ(13deg);box-sizing: border-box;">
												<section style="box-sizing: border-box;">
													<section
														style="display: inline-block;width: 18px;height: 29px;vertical-align: top;overflow: hidden;border-radius: 99%;background-color: rgb(180, 210, 6);box-sizing: border-box;">
														<section style="text-align: justify;box-sizing: border-box;">
															<p
																style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
																<span leaf=""><br></span></p>
														</section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;box-sizing: border-box;">
											<section style="margin: 0px;line-height: 0;box-sizing: border-box;">
												<section
													style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 16px;height: auto;box-sizing: border-box;"
													nodeleaf=""><img
														data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj6raicnvMibJFg7hIrialufyPDDMTKVA2jtIicsHNNic2KRc8LX2aJMxPRCicw/640?wx_fmt=png&amp;from=appmsg#imgIndex=16"
														class="rich_pages wxw-img wx_img_placeholder_mini"
														data-ratio="1.358" data-s="300,640" data-type="png" data-w="500"
														style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(0.736377) / 1; width: 16px !important; height: auto !important;"
														data-imgfileid="503351942"
														data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
														data-index="19"
														src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
														_width="100%" alt="图片"></section>
											</section>
										</section>
									</section>
									<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
										<section style="z-index: 1;box-sizing: border-box;">
											<section style="margin: -26px 0px 10px;box-sizing: border-box;">
												<section
													style="font-size: 14px;color: rgb(255, 255, 255);box-sizing: border-box;">
													<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
															style="box-sizing: border-box;"><span
																leaf="">赢科天地</span></strong></p>
												</section>
											</section>
										</section>
									</section>
								</section>
							</section>
							<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
								<p
									style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
									<span style="text-align: justify;box-sizing: border-box;"><span
											leaf="">作为未来教学体验探索者，赢科助力高校数字化发展，设计研发基于人工智能的高校智慧教育生态体系。紧紧围绕赢科“1+3+1”智慧教育生态模型，助力高等教育信息化的全面发展。</span></span>
								</p>
							</section>
							<section
								style="justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section
										style="justify-content: flex-start;display: flex;flex-flow: row;margin: 5px 0px 0px;box-sizing: border-box;">
										<section
											style="display: inline-block;width: 18px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;background-color: rgba(180, 210, 6, 0.29);line-height: 0;padding: 2px 0px 8px 6px;border-style: solid;border-width: 1px;border-color: rgb(180, 210, 6);border-radius: 130px;overflow: hidden;box-sizing: border-box;">
											<section
												style="transform: rotateZ(315deg);-webkit-transform: rotateZ(315deg);-moz-transform: rotateZ(315deg);-o-transform: rotateZ(315deg);box-sizing: border-box;">
												<section
													style="text-align: center;transform: translate3d(-3px, 0px, 0px);-webkit-transform: translate3d(-3px, 0px, 0px);-moz-transform: translate3d(-3px, 0px, 0px);-o-transform: translate3d(-3px, 0px, 0px);box-sizing: border-box;">
													<section
														style="display: inline-block;width: 10px;height: 6px;vertical-align: top;overflow: hidden;border-style: solid;border-width: 0px 0px 2px 2px;border-color: rgb(75, 194, 224) rgb(75, 194, 224) rgb(180, 210, 6) rgb(180, 210, 6);box-sizing: border-box;">
														<section style="text-align: justify;box-sizing: border-box;">
															<p
																style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
																<span leaf=""><br></span></p>
														</section>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: top;width: auto;flex: 100 100 0%;height: auto;padding: 0px 0px 0px 15px;box-sizing: border-box;">
									<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span style="color: rgb(180, 210, 6);box-sizing: border-box;"><strong
													style="box-sizing: border-box;"><span
														leaf="">1个核心：智慧教学</span></strong></span></p>
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span
												leaf="">确保生态体系始终围绕教学这个“轴心”运转，从技术层面推动“管理更好引导服务教学、科研更好反哺促进教学、资源更好支撑保障教学”的发展目标得以落地实现。</span>
										</p>
									</section>
								</section>
							</section>
							<section
								style="justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section
										style="justify-content: flex-start;display: flex;flex-flow: row;margin: 5px 0px 0px;box-sizing: border-box;">
										<section
											style="display: inline-block;width: 18px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;background-color: rgba(180, 210, 6, 0.29);line-height: 0;padding: 2px 0px 8px 6px;border-style: solid;border-width: 1px;border-color: rgb(180, 210, 6);border-radius: 130px;overflow: hidden;box-sizing: border-box;">
											<section
												style="transform: rotateZ(315deg);-webkit-transform: rotateZ(315deg);-moz-transform: rotateZ(315deg);-o-transform: rotateZ(315deg);box-sizing: border-box;">
												<section
													style="text-align: center;transform: translate3d(-3px, 0px, 0px);-webkit-transform: translate3d(-3px, 0px, 0px);-moz-transform: translate3d(-3px, 0px, 0px);-o-transform: translate3d(-3px, 0px, 0px);box-sizing: border-box;">
													<section
														style="display: inline-block;width: 10px;height: 6px;vertical-align: top;overflow: hidden;border-style: solid;border-width: 0px 0px 2px 2px;border-color: rgb(75, 194, 224) rgb(75, 194, 224) rgb(180, 210, 6) rgb(180, 210, 6);box-sizing: border-box;">
														<section style="text-align: justify;box-sizing: border-box;">
															<p
																style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
																<span leaf=""><br></span></p>
														</section>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: top;width: auto;flex: 100 100 0%;height: auto;padding: 0px 0px 0px 15px;box-sizing: border-box;">
									<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span style="color: rgb(180, 210, 6);box-sizing: border-box;"><strong
													style="box-sizing: border-box;"><span
														leaf="">3个支点：智慧管理服务、资源服务、安全服务</span></strong></span></p>
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf="">为教学活动提供组织管理、资源支持、安全保障等信息化服务，确保整个教育生态体系有序、高效、安全运转。</span></p>
									</section>
								</section>
							</section>
							<section
								style="justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section
										style="justify-content: flex-start;display: flex;flex-flow: row;margin: 5px 0px 0px;box-sizing: border-box;">
										<section
											style="display: inline-block;width: 18px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;background-color: rgba(180, 210, 6, 0.29);line-height: 0;padding: 2px 0px 8px 6px;border-style: solid;border-width: 1px;border-color: rgb(180, 210, 6);border-radius: 130px;overflow: hidden;box-sizing: border-box;">
											<section
												style="transform: rotateZ(315deg);-webkit-transform: rotateZ(315deg);-moz-transform: rotateZ(315deg);-o-transform: rotateZ(315deg);box-sizing: border-box;">
												<section
													style="text-align: center;transform: translate3d(-3px, 0px, 0px);-webkit-transform: translate3d(-3px, 0px, 0px);-moz-transform: translate3d(-3px, 0px, 0px);-o-transform: translate3d(-3px, 0px, 0px);box-sizing: border-box;">
													<section
														style="display: inline-block;width: 10px;height: 6px;vertical-align: top;overflow: hidden;border-style: solid;border-width: 0px 0px 2px 2px;border-color: rgb(75, 194, 224) rgb(75, 194, 224) rgb(180, 210, 6) rgb(180, 210, 6);box-sizing: border-box;">
														<section style="text-align: justify;box-sizing: border-box;">
															<p
																style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
																<span leaf=""><br></span></p>
														</section>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: top;width: auto;flex: 100 100 0%;height: auto;padding: 0px 0px 0px 15px;box-sizing: border-box;">
									<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span style="color: rgb(180, 210, 6);box-sizing: border-box;"><strong
													style="box-sizing: border-box;"><span
														leaf="">1个循环：智慧质量评价</span></strong></span></p>
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf="">按照预训练的质量评价 AI
												模型，自动对高校各类教育数据进行采集分析，生成监测结果、评价结论和预警信息，持续辅助管理者科学决策和师生改进教学。</span></p>
									</section>
								</section>
							</section>
							<section style="line-height: 0;box-sizing: border-box;">
								<section
									style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
									nodeleaf=""><img
										class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
										data-ratio="0.9759825327510917" data-s="300,640" data-type="png" data-w="458"
										style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.02461) / 1; width: 458px !important; height: auto !important;"
										data-imgfileid="503351944"
										data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
										data-index="20"
										src="@/assets/news/other/07.png"
										_width="100%" alt="图片"></section>
							</section>
							<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										style="box-sizing: border-box;"><span leaf=""><br></span></span></p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										style="box-sizing: border-box;"><span
											leaf="">赢科紧抓“人工智能”引领与“未来教学体验”导向的数智化教育主线。以人工智能基座+低代码平台的理念打造赢科智慧教育生态解决方案，对高等教育的教、管、学、评全流程实施数字化、智能化覆盖，为高等教育高质量发展提供数据决策支持与智慧教学服务。</span></span>
								</p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										style="box-sizing: border-box;"><span leaf=""><br></span></span></p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										style="box-sizing: border-box;"><span
											leaf="">合志赢科，共创未来，科技助力教育的每一分热爱与责任！</span></span></p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;vertical-align: top;width: 50%;align-self: flex-start;flex: 0 0 auto;box-sizing: border-box;">
							<section style="box-sizing: border-box;">
								<section
									style="display: inline-block;width: 8px;height: 8px;vertical-align: top;overflow: hidden;background-color: rgb(180, 210, 6);box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span></p>
									</section>
								</section>
							</section>
						</section>
						<section style="display: inline-block;vertical-align: top;width: 50%;box-sizing: border-box;">
							<section
								style="transform: perspective(0px);-webkit-transform: perspective(0px);-moz-transform: perspective(0px);-o-transform: perspective(0px);transform-style: flat;box-sizing: border-box;">
								<section
									style="transform: rotateY(180deg);-webkit-transform: rotateY(180deg);-moz-transform: rotateY(180deg);-o-transform: rotateY(180deg);box-sizing: border-box;">
									<section
										style="display: inline-block;width: 8px;height: 8px;vertical-align: top;overflow: hidden;background-color: rgb(180, 210, 6);box-sizing: border-box;">
										<section style="text-align: justify;box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<span leaf=""><br></span></p>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
				</section>
			</div>`
	},	
	{
		"id": 121375,
		"img": require("@/assets/news/05/01.jpg"),
		"title": "获评“最佳智能体共创伙伴”，携手腾讯共绘数智教育新图景",
		"date": "2025年9月19日 15:00",
		"content": `<div>
				<section
					style="box-sizing: border-box; font-style: normal; font-weight: 400; text-align: justify; font-size: 16px; color: rgb(62, 62, 62); visibility: visible; margin-bottom: 0px;">
					<section
						style="transform: rotateZ(5deg); transform-origin: left top; margin-top: 0px; margin-bottom: 0px; box-sizing: border-box; visibility: visible;">
						<section
							style="text-align: left; justify-content: flex-start; display: flex; flex-flow: row; margin: 10px 0px -20px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: middle; width: auto; min-width: 5%; max-width: 100%; flex: 0 0 auto; height: auto; align-self: center; margin: 0px -13px 0px 0px; box-sizing: border-box; visibility: visible;">
								<section
									style="display: flex; width: 100%; flex-flow: column; box-sizing: border-box; visibility: visible;">
									<section
										style="z-index: 1; transform: rotateZ(354deg); box-sizing: border-box; visibility: visible;">
										<section
											style="text-align: center; margin: 0px; line-height: 0; box-sizing: border-box; visibility: visible;">
											<section
												style="max-width: 100%; vertical-align: middle; display: inline-block; line-height: 0; width: 28px; height: auto; box-sizing: border-box; visibility: visible;"
												nodeleaf=""><img
													data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj6rxiaicRtaSmg8dSIvcf3wSIP2rFe5OLH1UCnEP33HuJOIk9PcrOuGJ9Q/640?wx_fmt=png&amp;from=appmsg#imgIndex=1"
													class="rich_pages wxw-img" data-ratio="1.262" data-s="300,640"
													data-type="png" data-w="500"
													style="vertical-align: middle; max-width: 100%; width: 28px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
													data-imgfileid="503351948"
													data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
													data-index="4"
													src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj6rxiaicRtaSmg8dSIvcf3wSIP2rFe5OLH1UCnEP33HuJOIk9PcrOuGJ9Q/640?wx_fmt=png&amp;from=appmsg&amp;tp=webp&amp;wxfrom=5&amp;wx_lazy=1#imgIndex=1"
													_width="100%" alt="图片" data-report-img-idx="1" data-fail="0"></section>
										</section>
									</section>
								</section>
							</section>
							<section data-cacheurl="" data-remoteid=""
								style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 auto; background-repeat: repeat; background-attachment: scroll; min-width: 5%; max-width: 100%; height: auto; padding: 0px 12px 8px 0px; box-sizing: border-box; background-image: url(&quot;https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj67UruWxxIeNR1fYvbLGmU1vib5z9y0iaR3849icibMoE1govdp1NUhDF8YQ/640?wx_fmt=png&amp;from=appmsg&amp;tp=webp&amp;wxfrom=15&amp;wx_lazy=1&quot;); background-position: 0% 0% !important; background-size: 3.93371% !important; visibility: visible;"
								data-lazy-bgimg="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj67UruWxxIeNR1fYvbLGmU1vib5z9y0iaR3849icibMoE1govdp1NUhDF8YQ/640?wx_fmt=png&amp;from=appmsg"
								class="" data-fail="0">
								<section
									style="transform: rotateZ(355deg); transform-origin: left top; margin-top: 0px; margin-bottom: 0px; box-sizing: border-box; visibility: visible;">
									<section
										style="justify-content: flex-start; display: flex; flex-flow: row; width: 100%; align-self: flex-start; background-color: rgba(142, 201, 101, 0.21); padding: 8px 8px 8px 15px; box-sizing: border-box; visibility: visible;">
										<section
											style="text-align: justify; color: rgb(0, 154, 86); font-size: 18px; width: 100%; box-sizing: border-box; visibility: visible;">
											<p
												style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
												<strong style="box-sizing: border-box; visibility: visible;"><span leaf=""
														style="visibility: visible;">重 | 磅 | 喜 | 讯&nbsp;</span></strong></p>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left; justify-content: flex-start; display: flex; flex-flow: row; margin: 0px 0px 10px; box-sizing: border-box; visibility: visible;">
						<section
							style="display: inline-block; width: 100%; vertical-align: top; align-self: flex-start; flex: 0 0 auto; border-style: solid; border-width: 1px; border-color: rgb(142, 201, 101); height: auto; margin: 0px; padding: 19px; box-sizing: border-box; visibility: visible;">
							<section
								style="text-align: justify; line-height: 1.8; box-sizing: border-box; visibility: visible;">
								<p
									style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
									<span leaf="" style="visibility: visible;"><br style="visibility: visible;"></span></p>
								<p
									style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
									<span leaf=""
										style="visibility: visible;">9月16日，2025腾讯全球数字生态大会智慧教育专场在深圳盛大启幕。作为腾讯教育深度战略伙伴，北京赢科天地电子有限公司在本届大会获评</span><span
										style="color: rgb(0, 154, 86); box-sizing: border-box; visibility: visible;"><strong
											style="box-sizing: border-box; visibility: visible;"><span leaf=""
												style="visibility: visible;">“腾讯教育最佳智能体共创伙伴”</span></strong></span><span
										leaf="" style="visibility: visible;">。</span></p>
							</section>
						</section>
					</section>
					<section style="margin: 0.5em auto; text-align: center; box-sizing: border-box; visibility: visible;">
						<section
							style="max-width: 100%; display: inline-block; line-height: 0; border-color: rgb(204, 204, 204); border-width: 8px; border-style: solid; box-sizing: border-box; visibility: visible;"
							nodeleaf=""><img class="rich_pages wxw-img" data-imgfileid="503351949"
								data-ratio="0.6666666666666666" data-s="300,640"
								data-type="jpeg" data-w="1080"
								style="vertical-align: middle; max-width: 100%; width: 661px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
								data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
								data-index="5"
								src="@/assets/news/05/01.jpg"
								_width="100%" alt="图片" data-report-img-idx="2" data-fail="0"></section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgba(142, 201, 101, 0.21);border-style: solid;border-width: 1px;border-color: transparent;height: auto;margin: 0px;padding: 19px;box-sizing: border-box;">
							<section style="text-align: justify;line-height: 1.8;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">本次大会汇聚了全球顶尖的科技思考与创新实践，深入洞察未来数字趋势，旨在探讨如何以科技之力赋能千行百业的数字化转型。在备受瞩目的智慧教育专场，大会更是聚焦于人工智能、大数据等前沿技术如何深刻重塑教育形态、优化教学模式、提升管理效能，为未来教育发展指明方向，具有极其重要的行业引导意义和战略价值。</span>
								</p>
							</section>
						</section>
					</section>
					<section style="margin: 0.5em auto;text-align: center;box-sizing: border-box;">
						<section
							style="max-width: 100%;display: inline-block;line-height: 0;border-color: rgb(204, 204, 204);border-width: 8px;border-style: solid;box-sizing: border-box;"
							nodeleaf=""><img class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
								data-imgfileid="503351951" data-ratio="0.6666666666666666" data-s="300,640"
								data-type="jpeg" data-w="1080"
								style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.5) / 1; width: 661px !important; height: auto !important;"
								data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
								data-index="6"
								src="@/assets/news/05/02.jpg"
								_width="100%" alt="图片"></section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;width: 100%;align-self: flex-start;border-style: solid;border-width: 1px;border-color: rgb(142, 201, 101);padding: 17px;box-sizing: border-box;">
						<section style="text-align: justify;line-height: 1.8;width: 100%;box-sizing: border-box;">
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf="">会议期间，赢科携手腾讯教育生态伙伴，共同开启上线“腾讯教育服务云应用专区”。这预示着赢科的智能教育解决方案将通过腾讯教育的云平台，触达更广泛的教育用户。此举不仅是双方产品层面的融合，更是生态共建的战略性一步，旨在共同打造一个开放的教育应用市场，加速优质教育资源的流转与创新，前瞻性地塑造未来教育的服务新范式。</span>
							</p>
						</section>
					</section>
					<section style="margin: 0.5em auto;text-align: center;box-sizing: border-box;">
						<section
							style="max-width: 100%;display: inline-block;line-height: 0;border-color: rgb(204, 204, 204);border-width: 8px;border-style: solid;box-sizing: border-box;"
							nodeleaf=""><img class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
								data-imgfileid="503351952" data-ratio="0.6666666666666666" data-s="300,640"
								data-type="jpeg" data-w="1080"
								style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.5) / 1; width: 661px !important; height: auto !important;"
								data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
								data-index="7"
								src="@/assets/news/05/03.jpg"
								_width="100%" alt="图片"></section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgba(142, 201, 101, 0.11);box-sizing: border-box;">
							<section
								style="text-align: right;justify-content: flex-end;display: flex;flex-flow: row;margin: -10px 0px 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section
										style="text-align: left;color: rgb(0, 154, 86);font-size: 18px;box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span
													leaf="">战略引领，共筑未来教育智能生态</span></strong></p>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;box-sizing: border-box;">
									<section style="line-height: 0;margin: 0px;box-sizing: border-box;">
										<section
											style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 83.0234px;height: auto;box-sizing: border-box;"
											nodeleaf=""><img
												data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj6grND21x2ruhqKALNPxMnDqXxLicabSENia8KRcLicNQAsxlzl1PHjgp7A/640?wx_fmt=png&amp;from=appmsg#imgIndex=5"
												class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
												data-ratio="0.2212962962962963" data-s="300,640" data-type="png"
												data-w="1080"
												style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(4.51883) / 1; width: 83px !important; height: auto !important;"
												data-imgfileid="503351954"
												data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
												data-index="8"
												src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
												_width="100%" alt="图片"></section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;width: 100%;align-self: flex-start;border-style: solid;border-width: 1px;border-color: rgb(142, 201, 101);padding: 17px;box-sizing: border-box;">
						<section style="text-align: justify;line-height: 1.8;width: 100%;box-sizing: border-box;">
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf="">未来，赢科将与腾讯教育一道，深刻认知和前瞻设计AI时代教育场景，着力打造引领性的智能教、学、管、评、研工具系统与服务体系，为高等教育乃至整个教育行业的数字化转型提供强劲引擎，全面赋能教学模式的改革升级与创新实践，提升学生的个性化学习体验与学习成效，助力学校优化管理与决策效率，并驱动科研范式的深度变革。最终，共同开创一个以智能为核心，以创新为驱动的学习新纪元，为中国高等教育的未来发展擘画宏伟远景，奠定可持续演进的生态基石。</span>
							</p>
						</section>
					</section>
					<section style="margin: 0.5em auto;text-align: center;box-sizing: border-box;">
						<section
							style="max-width: 100%;display: inline-block;line-height: 0;border-color: rgb(204, 204, 204);border-width: 8px;border-style: solid;box-sizing: border-box;"
							nodeleaf=""><img class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
								data-imgfileid="503351957" data-ratio="1.5" data-s="300,640"
								data-type="jpeg" data-w="1080"
								style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(0.666667) / 1; width: 661px !important; height: auto !important;"
								data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
								data-index="9"
								src="@/assets/news/05/04.jpg"
								_width="100%" alt="图片"></section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgba(142, 201, 101, 0.11);box-sizing: border-box;">
							<section
								style="text-align: right;justify-content: flex-end;display: flex;flex-flow: row;margin: -10px 0px 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section
										style="text-align: left;color: rgb(0, 154, 86);font-size: 18px;box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span
													leaf="">技术深耕，驱动高等教育创新升级</span></strong></p>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;box-sizing: border-box;">
									<section style="line-height: 0;margin: 0px;box-sizing: border-box;">
										<section
											style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 83.0234px;height: auto;box-sizing: border-box;"
											nodeleaf=""><img
												data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiccuWiagmyc2ACPg8aH65XMj6grND21x2ruhqKALNPxMnDqXxLicabSENia8KRcLicNQAsxlzl1PHjgp7A/640?wx_fmt=png&amp;from=appmsg#imgIndex=7"
												class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
												data-ratio="0.2212962962962963" data-s="300,640" data-type="png"
												data-w="1080"
												style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(4.51883) / 1; width: 83px !important; height: auto !important;"
												data-imgfileid="503351956"
												data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
												data-index="10"
												src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
												_width="100%" alt="图片"></section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgba(142, 201, 101, 0.21);border-style: solid;border-width: 1px;border-color: transparent;height: auto;margin: 0px;padding: 19px;box-sizing: border-box;">
							<section style="text-align: justify;line-height: 1.8;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">赢科在与腾讯教育的共创实践中，持续将AI技术智慧地融入高等教育场景，旨在构建全链条、多维度的智能教育服务体系：</span></p>
							</section>
						</section>
					</section>
					<section
						style="text-align: right;justify-content: flex-end;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;background-color: rgb(255, 255, 255);padding: 0px 0px 0px 14px;box-sizing: border-box;">
							<section
								style="justify-content: flex-end;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section
										style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
										<section
											style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 0%;height: auto;box-sizing: border-box;">
											<section
												style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;box-sizing: border-box;">
												<section
													style="display: inline-block;width: 16px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;border-style: solid;border-width: 0px 0px 0px 2px;border-left-color: rgb(142, 201, 101);margin: 0px 0px 0px 4px;box-sizing: border-box;">
													<section
														style="transform: translate3d(-6px, 0px, 0px);-webkit-transform: translate3d(-6px, 0px, 0px);-moz-transform: translate3d(-6px, 0px, 0px);-o-transform: translate3d(-6px, 0px, 0px);margin: 4px 0px 8px;box-sizing: border-box;">
														<section
															style="background-color: rgb(142, 201, 101);height: 2px;box-sizing: border-box;">
															<svg viewBox="0 0 1 1"
																style="float:left;line-height:0;width:0;vertical-align:top;"
																role="img" aria-label="插图"></svg></section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;padding: 7px 0px;margin: 0px -10px;box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 28px;height: 28px;vertical-align: top;overflow: hidden;border-radius: 42px;background-color: rgb(0, 154, 86);box-sizing: border-box;">
													<section style="margin: 5px 0px 0px;box-sizing: border-box;">
														<section
															style="font-size: 18px;color: rgb(255, 255, 255);line-height: 1;box-sizing: border-box;">
															<p style="margin: 0px;padding: 0px;box-sizing: border-box;">
																<strong style="box-sizing: border-box;"><span
																		leaf="">01</span></strong></p>
														</section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: bottom;width: auto;flex: 0 0 0%;height: auto;align-self: flex-end;box-sizing: border-box;">
											<section
												style="transform: perspective(0px);-webkit-transform: perspective(0px);-moz-transform: perspective(0px);-o-transform: perspective(0px);transform-style: flat;box-sizing: border-box;">
												<section
													style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;transform: rotateX(180deg) rotateY(180deg);-webkit-transform: rotateX(180deg) rotateY(180deg);-moz-transform: rotateX(180deg) rotateY(180deg);-o-transform: rotateX(180deg) rotateY(180deg);box-sizing: border-box;">
													<section
														style="display: inline-block;width: 16px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;border-style: solid;border-width: 0px 0px 0px 2px;border-left-color: rgb(142, 201, 101);margin: 0px 0px 0px 4px;box-sizing: border-box;">
														<section
															style="transform: translate3d(-6px, 0px, 0px);-webkit-transform: translate3d(-6px, 0px, 0px);-moz-transform: translate3d(-6px, 0px, 0px);-o-transform: translate3d(-6px, 0px, 0px);margin: 4px 0px 8px;box-sizing: border-box;">
															<section
																style="background-color: rgb(142, 201, 101);height: 2px;box-sizing: border-box;">
																<svg viewBox="0 0 1 1"
																	style="float:left;line-height:0;width:0;vertical-align:top;"
																	role="img" aria-label="插图"></svg></section>
														</section>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: middle;width: auto;margin: 0px 0px 0px 11px;align-self: center;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;padding: 0px 7px;border-style: solid;border-width: 0px 0px 10px;border-bottom-color: rgb(179, 211, 156);box-sizing: border-box;">
									<section style="margin: 0px 0px -10px;box-sizing: border-box;">
										<section style="text-align: justify;box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<strong style="box-sizing: border-box;"><span
														leaf="">创新驱动的AI应用实践</span></strong></p>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;padding: 7px 17px 38px;border-style: solid;border-width: 0px 2px 2px 0px;border-color: rgb(142, 201, 101);overflow: hidden;height: auto;margin: 0px;border-bottom-right-radius: 20px;box-sizing: border-box;">
							<section style="text-align: justify;line-height: 1.8;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">我们积极拥抱并深度融合前沿AI技术，将其智慧地应用于高等教育场景。通过</span><span
										style="color: rgb(0, 154, 86);box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span
												leaf="">智慧课程、AI数字人、AI助教</span></strong></span><span
										leaf="">等产品，并以</span><span
										style="color: rgb(0, 154, 86);box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span
												leaf="">AI赋能的在线教学平台</span></strong></span><span
										leaf="">为载体，我们为高校的教学、科研、管理提供精准高效的智能支持，让AI真正融入教学全环节，促进教育模式的创新升级。</span></p>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: -30px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;background-color: rgb(255, 255, 255);padding: 0px 15px 0px 0px;box-sizing: border-box;">
							<section
								style="text-align: right;justify-content: flex-end;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section
										style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
										<section
											style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 0%;height: auto;box-sizing: border-box;">
											<section
												style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;box-sizing: border-box;">
												<section
													style="display: inline-block;width: 16px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;border-style: solid;border-width: 0px 0px 0px 2px;border-left-color: rgb(142, 201, 101);margin: 0px 0px 0px 4px;box-sizing: border-box;">
													<section
														style="transform: translate3d(-6px, 0px, 0px);-webkit-transform: translate3d(-6px, 0px, 0px);-moz-transform: translate3d(-6px, 0px, 0px);-o-transform: translate3d(-6px, 0px, 0px);margin: 4px 0px 8px;box-sizing: border-box;">
														<section
															style="background-color: rgb(142, 201, 101);height: 2px;box-sizing: border-box;">
															<svg viewBox="0 0 1 1"
																style="float:left;line-height:0;width:0;vertical-align:top;"
																role="img" aria-label="插图"></svg></section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;padding: 7px 0px;margin: 0px -10px;box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 28px;height: 28px;vertical-align: top;overflow: hidden;border-radius: 42px;background-color: rgb(0, 154, 86);box-sizing: border-box;">
													<section style="margin: 5px 0px 0px;box-sizing: border-box;">
														<section
															style="font-size: 18px;color: rgb(255, 255, 255);line-height: 1;box-sizing: border-box;">
															<p style="margin: 0px;padding: 0px;box-sizing: border-box;">
																<strong style="box-sizing: border-box;"><span
																		leaf="">02</span></strong></p>
														</section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: bottom;width: auto;flex: 0 0 0%;height: auto;align-self: flex-end;box-sizing: border-box;">
											<section
												style="transform: perspective(0px);-webkit-transform: perspective(0px);-moz-transform: perspective(0px);-o-transform: perspective(0px);transform-style: flat;box-sizing: border-box;">
												<section
													style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;transform: rotateX(180deg) rotateY(180deg);-webkit-transform: rotateX(180deg) rotateY(180deg);-moz-transform: rotateX(180deg) rotateY(180deg);-o-transform: rotateX(180deg) rotateY(180deg);box-sizing: border-box;">
													<section
														style="display: inline-block;width: 16px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;border-style: solid;border-width: 0px 0px 0px 2px;border-left-color: rgb(142, 201, 101);margin: 0px 0px 0px 4px;box-sizing: border-box;">
														<section
															style="transform: translate3d(-6px, 0px, 0px);-webkit-transform: translate3d(-6px, 0px, 0px);-moz-transform: translate3d(-6px, 0px, 0px);-o-transform: translate3d(-6px, 0px, 0px);margin: 4px 0px 8px;box-sizing: border-box;">
															<section
																style="background-color: rgb(142, 201, 101);height: 2px;box-sizing: border-box;">
																<svg viewBox="0 0 1 1"
																	style="float:left;line-height:0;width:0;vertical-align:top;"
																	role="img" aria-label="插图"></svg></section>
														</section>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: middle;width: auto;margin: 0px 0px 0px 11px;align-self: center;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;padding: 0px 7px;border-style: solid;border-width: 0px 0px 10px;border-bottom-color: rgb(179, 211, 156);box-sizing: border-box;">
									<section style="margin: 0px 0px -10px;box-sizing: border-box;">
										<section style="text-align: justify;box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<strong style="box-sizing: border-box;"><span
														leaf="">深耕高等教育，构建整体解决方案</span></strong></p>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;padding: 7px 17px 30px;border-style: solid;border-width: 0px 0px 2px 2px;border-color: rgb(142, 201, 101);border-bottom-left-radius: 20px;overflow: hidden;height: auto;margin: 0px 0px 0px 20px;box-sizing: border-box;">
							<section style="text-align: justify;line-height: 1.8;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">凭借对高等教育独特运行规律、发展趋势及师生实际痛点的深刻理解，我们倾力打造</span><span
										style="color: rgb(0, 154, 86);box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span
												leaf="">未来学习中心整体解决方案</span></strong></span><span
										leaf="">。这些方案绝非单纯的技术堆砌，而是深度融合我们对于教学场景的洞察，旨在提供真正实用的、能解决实际问题的教育科技产品。</span></p>
							</section>
						</section>
					</section>
					<section
						style="text-align: right;justify-content: flex-end;display: flex;flex-flow: row;margin: -30px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;background-color: rgb(255, 255, 255);padding: 0px 0px 0px 14px;box-sizing: border-box;">
							<section
								style="justify-content: flex-end;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
								<section
									style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
									<section
										style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
										<section
											style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 0%;height: auto;box-sizing: border-box;">
											<section
												style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;box-sizing: border-box;">
												<section
													style="display: inline-block;width: 16px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;border-style: solid;border-width: 0px 0px 0px 2px;border-left-color: rgb(142, 201, 101);margin: 0px 0px 0px 4px;box-sizing: border-box;">
													<section
														style="transform: translate3d(-6px, 0px, 0px);-webkit-transform: translate3d(-6px, 0px, 0px);-moz-transform: translate3d(-6px, 0px, 0px);-o-transform: translate3d(-6px, 0px, 0px);margin: 4px 0px 8px;box-sizing: border-box;">
														<section
															style="background-color: rgb(142, 201, 101);height: 2px;box-sizing: border-box;">
															<svg viewBox="0 0 1 1"
																style="float:left;line-height:0;width:0;vertical-align:top;"
																role="img" aria-label="插图"></svg></section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;padding: 7px 0px;margin: 0px -10px;box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 28px;height: 28px;vertical-align: top;overflow: hidden;border-radius: 42px;background-color: rgb(0, 154, 86);box-sizing: border-box;">
													<section style="margin: 5px 0px 0px;box-sizing: border-box;">
														<section
															style="font-size: 18px;color: rgb(255, 255, 255);line-height: 1;box-sizing: border-box;">
															<p style="margin: 0px;padding: 0px;box-sizing: border-box;">
																<strong style="box-sizing: border-box;"><span
																		leaf="">03</span></strong></p>
														</section>
													</section>
												</section>
											</section>
										</section>
										<section
											style="display: inline-block;vertical-align: bottom;width: auto;flex: 0 0 0%;height: auto;align-self: flex-end;box-sizing: border-box;">
											<section
												style="transform: perspective(0px);-webkit-transform: perspective(0px);-moz-transform: perspective(0px);-o-transform: perspective(0px);transform-style: flat;box-sizing: border-box;">
												<section
													style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;transform: rotateX(180deg) rotateY(180deg);-webkit-transform: rotateX(180deg) rotateY(180deg);-moz-transform: rotateX(180deg) rotateY(180deg);-o-transform: rotateX(180deg) rotateY(180deg);box-sizing: border-box;">
													<section
														style="display: inline-block;width: 16px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;border-style: solid;border-width: 0px 0px 0px 2px;border-left-color: rgb(142, 201, 101);margin: 0px 0px 0px 4px;box-sizing: border-box;">
														<section
															style="transform: translate3d(-6px, 0px, 0px);-webkit-transform: translate3d(-6px, 0px, 0px);-moz-transform: translate3d(-6px, 0px, 0px);-o-transform: translate3d(-6px, 0px, 0px);margin: 4px 0px 8px;box-sizing: border-box;">
															<section
																style="background-color: rgb(142, 201, 101);height: 2px;box-sizing: border-box;">
																<svg viewBox="0 0 1 1"
																	style="float:left;line-height:0;width:0;vertical-align:top;"
																	role="img" aria-label="插图"></svg></section>
														</section>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
								<section
									style="display: inline-block;vertical-align: middle;width: auto;margin: 0px 0px 0px 11px;align-self: center;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;padding: 0px 7px;border-style: solid;border-width: 0px 0px 10px;border-bottom-color: rgb(179, 211, 156);box-sizing: border-box;">
									<section style="margin: 0px 0px -10px;box-sizing: border-box;">
										<section style="text-align: justify;box-sizing: border-box;">
											<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
												<strong style="box-sizing: border-box;"><span
														leaf="">赋能精准教学与高效管理</span></strong></p>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;padding: 7px 17px 38px;border-style: solid;border-width: 0px 2px 2px 0px;border-color: rgb(142, 201, 101);overflow: hidden;height: auto;margin: 0px;border-bottom-right-radius: 20px;box-sizing: border-box;">
							<section style="text-align: justify;line-height: 1.8;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">基于先进的AI赋能的在线教学平台，我们运用智能技术，为高校师生带来革命性的教学体验。它不仅能实现教学内容的精准个性化推荐、学习路径的智能规划，更在教学全流程中实现高效协同，全面提升教学质量与管理效能，开启未来智能学习新篇章。</span>
								</p>
							</section>
						</section>
					</section>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							leaf=""><br></span></p>
					<section
						style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
						<section
							style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;border-style: solid;border-width: 1px;border-color: rgb(220, 203, 176);height: auto;margin: 0px;padding: 19px;box-sizing: border-box;">
							<section style="text-align: justify;line-height: 1.8;box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">展望未来，北京赢科天地电子有限公司将不忘初心，继续秉持</span><span
										style="color: rgb(0, 154, 86);box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span leaf="">“</span></strong></span><strong
										style="box-sizing: border-box;"><span
											style="color: rgb(0, 154, 86);box-sizing: border-box;"><span
												leaf="">合志赢科，共创未来”</span></span></strong><span
										leaf="">的坚定信念。我们将携手腾讯教育及更多优秀的生态伙伴，在智慧教育的广阔天地中，一同探索、一同创新、一同成长！</span></p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf=""><br></span></p>
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">让我们共同期待，赢科在未来的教育科技浪潮中，书写更多精彩和辉煌篇章！</span></p>
							</section>
						</section>
					</section>
				</section>
			</div>`
	}, 
	{
		"id": 121376,
		"img": require("@/assets/news/06/01.png"),
		"title": "揭秘！中山大学高效评教的「秘密武器」，原来是它！",
		"date": "2025年8月29日 12:00",
		"content": `<div>
			<section
				style="box-sizing: border-box; font-style: normal; font-weight: 400; text-align: justify; font-size: 16px; color: rgb(62, 62, 62); visibility: visible; margin-bottom: 0px;"
				data-pm-slice="0 0 []">
				<section
					style="display: flex; width: 100%; flex-flow: column; box-sizing: border-box; visibility: visible;">
					<section style="height: auto; z-index: 2; box-sizing: border-box; visibility: visible;">
						<section
							style="text-align: center; justify-content: center; display: flex; flex-flow: row; margin: 10px 0px -10px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; width: 32px; align-self: flex-start; flex: 0 0 auto; height: auto; line-height: 0; box-sizing: border-box; visibility: visible;">
								<section
									style="transform: rotateZ(343deg); box-sizing: border-box; visibility: visible;">
									<section style="box-sizing: border-box; visibility: visible;">
										<section
											style="display: inline-block; width: 7px; height: 18px; vertical-align: top; overflow: hidden; background-color: rgb(255, 236, 89); border-radius: 75px; box-sizing: border-box; visibility: visible;">
											<section
												style="text-align: justify; box-sizing: border-box; visibility: visible;">
												<p
													style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
													<span leaf="" style="visibility: visible;"><br
															style="visibility: visible;"></span>
												</p>
											</section>
										</section>
									</section>
								</section>
							</section>
							<section
								style="display: inline-block; vertical-align: top; width: 32px; align-self: flex-start; flex: 0 0 auto; height: auto; line-height: 0; box-sizing: border-box; visibility: visible;">
								<section
									style="transform: rotateZ(17deg); box-sizing: border-box; visibility: visible;">
									<section style="box-sizing: border-box; visibility: visible;">
										<section
											style="display: inline-block; width: 7px; height: 18px; vertical-align: top; overflow: hidden; background-color: rgb(255, 236, 89); border-radius: 75px; box-sizing: border-box; visibility: visible;">
											<section
												style="text-align: justify; box-sizing: border-box; visibility: visible;">
												<p
													style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
													<span leaf="" style="visibility: visible;"><br
															style="visibility: visible;"></span>
												</p>
											</section>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
				</section>
				<section style="padding: 0px 20px; box-sizing: border-box; visibility: visible;">
					<p
						style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span leaf="" style="visibility: visible;"><br style="visibility: visible;"></span>
					</p>
					<p
						style="text-align: center; white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span style="font-size: 18px; box-sizing: border-box; visibility: visible;"><strong
								style="box-sizing: border-box; visibility: visible;"><span
									style="color: rgb(0, 154, 86); box-sizing: border-box; visibility: visible;"><span
										leaf=""
										style="visibility: visible;">教学评价，是高校管理中绕不开的核心环节，也常常是公认的痛点与难点</span></span></strong></span>
					</p>
					<p
						style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span leaf="" style="visibility: visible;"><br style="visibility: visible;"></span>
					</p>
					<p
						style="text-align: left; white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span leaf="" style="visibility: visible;">我们或许都曾面临这样的困境：</span>
					</p>
				</section>
				<section style="padding: 0px 20px; box-sizing: border-box; visibility: visible;">
					<p
						style="text-align: left; white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span leaf="" style="visibility: visible;"><br style="visibility: visible;"></span>
					</p>
				</section>
				<section
					style="text-align: left; justify-content: flex-start; display: flex; flex-flow: row; margin: 20px 0px 10px; box-sizing: border-box; visibility: visible;">
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 100 100 0%; height: auto; box-sizing: border-box; visibility: visible;">
						<section style="margin: 0px 0px 8px; box-sizing: border-box; visibility: visible;">
							<section
								style="background-color: rgb(180, 210, 6); height: 1px; box-sizing: border-box; visibility: visible;">
								<svg viewBox="0 0 1 1"
									style="float: left; line-height: 0; width: 0px; vertical-align: top; visibility: visible;"
									role="img" aria-label="插图"></svg>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 0%; height: auto; padding: 0px 2px; box-sizing: border-box; visibility: visible;">
						<section style="text-align: center; margin: 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; transform: matrix(1, 0, -0.2, 1, 0, 0); background-color: rgb(180, 210, 6); box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px; line-height: 1; letter-spacing: 0px; width: 5px; height: auto; padding: 0px; box-sizing: border-box; visibility: visible;">
								<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
									<p
										style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
										<span leaf="" style="visibility: visible;"><br
												style="visibility: visible;"></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 0%; height: auto; padding: 0px 2px; box-sizing: border-box; visibility: visible;">
						<section style="text-align: center; margin: 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; transform: matrix(1, 0, -0.2, 1, 0, 0); background-color: rgb(180, 210, 6); box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px; line-height: 1; letter-spacing: 0px; width: 5px; height: auto; padding: 0px; box-sizing: border-box; visibility: visible;">
								<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
									<p
										style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
										<span leaf="" style="visibility: visible;"><br
												style="visibility: visible;"></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 0%; height: auto; padding: 0px 2px; box-sizing: border-box; visibility: visible;">
						<section style="text-align: center; margin: 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; transform: matrix(1, 0, -0.2, 1, 0, 0); background-color: rgb(180, 210, 6); box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px; line-height: 1; letter-spacing: 0px; width: 5px; height: auto; padding: 0px; box-sizing: border-box; visibility: visible;">
								<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
									<p
										style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
										<span leaf="" style="visibility: visible;"><br
												style="visibility: visible;"></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 0%; height: auto; padding: 0px 2px; box-sizing: border-box; visibility: visible;">
						<section style="text-align: center; margin: 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; transform: matrix(1, 0, -0.2, 1, 0, 0); background-color: rgb(180, 210, 6); box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px; line-height: 1; letter-spacing: 0px; width: 5px; height: auto; padding: 0px; box-sizing: border-box; visibility: visible;">
								<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
									<p
										style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
										<span leaf="" style="visibility: visible;"><br
												style="visibility: visible;"></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 0%; height: auto; padding: 0px 2px; box-sizing: border-box; visibility: visible;">
						<section style="text-align: center; margin: 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; transform: matrix(1, 0, -0.2, 1, 0, 0); background-color: rgb(180, 210, 6); box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px; line-height: 1; letter-spacing: 0px; width: 5px; height: auto; padding: 0px; box-sizing: border-box; visibility: visible;">
								<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
									<p
										style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
										<span leaf="" style="visibility: visible;"><br
												style="visibility: visible;"></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; flex: 100 100 0%; height: auto; align-self: center; padding: 0px 0px 0px 10px; box-sizing: border-box; visibility: visible;">
						<section style="margin: 0px 0px 8px; box-sizing: border-box; visibility: visible;">
							<section
								style="background-color: rgb(180, 210, 6); height: 1px; box-sizing: border-box; visibility: visible;">
								<svg viewBox="0 0 1 1"
									style="float: left; line-height: 0; width: 0px; vertical-align: top; visibility: visible;"
									role="img" aria-label="插图"></svg>
							</section>
						</section>
					</section>
				</section>
				<section style="padding: 0px 20px; box-sizing: border-box; visibility: visible;">
					<p
						style="text-align: center; white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<strong style="box-sizing: border-box; visibility: visible;"><span leaf=""
								style="visibility: visible;">① &nbsp;流程繁琐</span></strong>
					</p>
					<p
						style="text-align: center; white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span leaf="" style="visibility: visible;">耗费大量行政与教学精力，评教工作本身成为一种负担。</span>
					</p>
				</section>
				<section
					style="text-align: left; justify-content: flex-start; display: flex; flex-flow: row; margin: 20px 0px 10px; box-sizing: border-box; visibility: visible;">
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 100 100 0%; height: auto; box-sizing: border-box; visibility: visible;">
						<section style="margin: 0px 0px 8px; box-sizing: border-box; visibility: visible;">
							<section
								style="background-color: rgb(180, 210, 6); height: 1px; box-sizing: border-box; visibility: visible;">
								<svg viewBox="0 0 1 1"
									style="float: left; line-height: 0; width: 0px; vertical-align: top; visibility: visible;"
									role="img" aria-label="插图"></svg>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 0%; height: auto; padding: 0px 2px; box-sizing: border-box; visibility: visible;">
						<section style="text-align: center; margin: 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; transform: matrix(1, 0, -0.2, 1, 0, 0); background-color: rgb(180, 210, 6); box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px; line-height: 1; letter-spacing: 0px; width: 5px; height: auto; padding: 0px; box-sizing: border-box; visibility: visible;">
								<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
									<p
										style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
										<span leaf="" style="visibility: visible;"><br
												style="visibility: visible;"></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 0%; height: auto; padding: 0px 2px; box-sizing: border-box; visibility: visible;">
						<section style="text-align: center; margin: 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; transform: matrix(1, 0, -0.2, 1, 0, 0); background-color: rgb(180, 210, 6); box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px; line-height: 1; letter-spacing: 0px; width: 5px; height: auto; padding: 0px; box-sizing: border-box; visibility: visible;">
								<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
									<p
										style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
										<span leaf="" style="visibility: visible;"><br
												style="visibility: visible;"></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 0%; height: auto; padding: 0px 2px; box-sizing: border-box; visibility: visible;">
						<section style="text-align: center; margin: 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; transform: matrix(1, 0, -0.2, 1, 0, 0); background-color: rgb(180, 210, 6); box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px; line-height: 1; letter-spacing: 0px; width: 5px; height: auto; padding: 0px; box-sizing: border-box; visibility: visible;">
								<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
									<p
										style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
										<span leaf="" style="visibility: visible;"><br
												style="visibility: visible;"></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 0%; height: auto; padding: 0px 2px; box-sizing: border-box; visibility: visible;">
						<section style="text-align: center; margin: 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; transform: matrix(1, 0, -0.2, 1, 0, 0); background-color: rgb(180, 210, 6); box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px; line-height: 1; letter-spacing: 0px; width: 5px; height: auto; padding: 0px; box-sizing: border-box; visibility: visible;">
								<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
									<p
										style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
										<span leaf="" style="visibility: visible;"><br
												style="visibility: visible;"></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 0%; height: auto; padding: 0px 2px; box-sizing: border-box; visibility: visible;">
						<section style="text-align: center; margin: 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; transform: matrix(1, 0, -0.2, 1, 0, 0); background-color: rgb(180, 210, 6); box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px; line-height: 1; letter-spacing: 0px; width: 5px; height: auto; padding: 0px; box-sizing: border-box; visibility: visible;">
								<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
									<p
										style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
										<span leaf="" style="visibility: visible;"><br
												style="visibility: visible;"></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; flex: 100 100 0%; height: auto; align-self: center; padding: 0px 0px 0px 10px; box-sizing: border-box; visibility: visible;">
						<section style="margin: 0px 0px 8px; box-sizing: border-box; visibility: visible;">
							<section
								style="background-color: rgb(180, 210, 6); height: 1px; box-sizing: border-box; visibility: visible;">
								<svg viewBox="0 0 1 1"
									style="float: left; line-height: 0; width: 0px; vertical-align: top; visibility: visible;"
									role="img" aria-label="插图"></svg>
							</section>
						</section>
					</section>
				</section>
				<section style="padding: 0px 20px; box-sizing: border-box; visibility: visible;">
					<p
						style="text-align: center; white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<strong style="box-sizing: border-box; visibility: visible;"><span leaf=""
								style="visibility: visible;">② &nbsp;数据“悬浮”</span></strong>
					</p>
					<p
						style="text-align: center; white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span leaf="" style="visibility: visible;">形成了海量数据，却难以转化为指导教学改进的有效洞察。</span>
					</p>
				</section>
				<section
					style="text-align: left; justify-content: flex-start; display: flex; flex-flow: row; margin: 20px 0px 10px; box-sizing: border-box; visibility: visible;">
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 100 100 0%; height: auto; box-sizing: border-box; visibility: visible;">
						<section style="margin: 0px 0px 8px; box-sizing: border-box; visibility: visible;">
							<section
								style="background-color: rgb(180, 210, 6); height: 1px; box-sizing: border-box; visibility: visible;">
								<svg viewBox="0 0 1 1"
									style="float: left; line-height: 0; width: 0px; vertical-align: top; visibility: visible;"
									role="img" aria-label="插图"></svg>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 0%; height: auto; padding: 0px 2px; box-sizing: border-box; visibility: visible;">
						<section style="text-align: center; margin: 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; transform: matrix(1, 0, -0.2, 1, 0, 0); background-color: rgb(180, 210, 6); box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px; line-height: 1; letter-spacing: 0px; width: 5px; height: auto; padding: 0px; box-sizing: border-box; visibility: visible;">
								<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
									<p
										style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
										<span leaf="" style="visibility: visible;"><br
												style="visibility: visible;"></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 0%; height: auto; padding: 0px 2px; box-sizing: border-box; visibility: visible;">
						<section style="text-align: center; margin: 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; transform: matrix(1, 0, -0.2, 1, 0, 0); background-color: rgb(180, 210, 6); box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px; line-height: 1; letter-spacing: 0px; width: 5px; height: auto; padding: 0px; box-sizing: border-box; visibility: visible;">
								<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
									<p
										style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
										<span leaf="" style="visibility: visible;"><br
												style="visibility: visible;"></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 0%; height: auto; padding: 0px 2px; box-sizing: border-box; visibility: visible;">
						<section style="text-align: center; margin: 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; transform: matrix(1, 0, -0.2, 1, 0, 0); background-color: rgb(180, 210, 6); box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px; line-height: 1; letter-spacing: 0px; width: 5px; height: auto; padding: 0px; box-sizing: border-box; visibility: visible;">
								<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
									<p
										style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
										<span leaf="" style="visibility: visible;"><br
												style="visibility: visible;"></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 0%; height: auto; padding: 0px 2px; box-sizing: border-box; visibility: visible;">
						<section style="text-align: center; margin: 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; transform: matrix(1, 0, -0.2, 1, 0, 0); background-color: rgb(180, 210, 6); box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px; line-height: 1; letter-spacing: 0px; width: 5px; height: auto; padding: 0px; box-sizing: border-box; visibility: visible;">
								<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
									<p
										style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
										<span leaf="" style="visibility: visible;"><br
												style="visibility: visible;"></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; align-self: center; flex: 0 0 0%; height: auto; padding: 0px 2px; box-sizing: border-box; visibility: visible;">
						<section style="text-align: center; margin: 0px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; transform: matrix(1, 0, -0.2, 1, 0, 0); background-color: rgb(180, 210, 6); box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px; line-height: 1; letter-spacing: 0px; width: 5px; height: auto; padding: 0px; box-sizing: border-box; visibility: visible;">
								<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
									<p
										style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
										<span leaf="" style="visibility: visible;"><br
												style="visibility: visible;"></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block; vertical-align: middle; width: auto; flex: 100 100 0%; height: auto; align-self: center; padding: 0px 0px 0px 10px; box-sizing: border-box; visibility: visible;">
						<section style="margin: 0px 0px 8px; box-sizing: border-box; visibility: visible;">
							<section
								style="background-color: rgb(180, 210, 6); height: 1px; box-sizing: border-box; visibility: visible;">
								<svg viewBox="0 0 1 1"
									style="float: left; line-height: 0; width: 0px; vertical-align: top; visibility: visible;"
									role="img" aria-label="插图"></svg>
							</section>
						</section>
					</section>
				</section>
				<section style="text-align: center; padding: 0px 20px; box-sizing: border-box; visibility: visible;">
					<p style="margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;"><strong
							style="box-sizing: border-box; visibility: visible;"><span leaf=""
								style="visibility: visible;">③ &nbsp;参与度瓶颈</span></strong></p>
					<p style="margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;"><span leaf=""
							style="visibility: visible;">师生反馈的积极性与真实性难以保证，评价效果大打折扣。</span></p>
				</section>
				<section style="padding: 0px 20px; box-sizing: border-box; visibility: visible;">
					<p
						style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span leaf="" style="visibility: visible;"><br style="visibility: visible;"></span>
					</p>
					<p
						style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span leaf="" style="visibility: visible;"><br style="visibility: visible;"></span>
					</p>
					<p
						style="text-align: center; white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<strong style="box-sizing: border-box; visibility: visible;"><span
								style="color: rgb(0, 154, 86); box-sizing: border-box; visibility: visible;"><span
									leaf=""
									style="visibility: visible;">如何打破这一困局，让教学评价从一项管理任务，回归其提升教学质量的本质？</span></span></strong>
					</p>
					<p
						style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span leaf="" style="visibility: visible;"><br style="visibility: visible;"></span>
					</p>
					<p
						style="text-align: center; white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span leaf=""
							style="visibility: visible;">破局的关键，在于工具的革新与理念的升级。今天，我们为您介绍的，正是经过中山大学等顶尖学府严苛实践检验的解决方案——赢科全新一代智慧评教系统。</span>
					</p>
					<p
						style="text-align: center; white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span leaf="" style="visibility: visible;"><br style="visibility: visible;"></span>
					</p>
				</section>
				<section style="line-height: 0;box-sizing: border-box; text-align: center;">
					<section
						style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
						nodeleaf=""><img class="rich_pages wxw-img" data-ratio="0.4740740740740741" data-s="300,640"
							data-type="png" data-w="1080"
							style="vertical-align: middle; max-width: 100%; width: 677px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
							data-imgfileid="503351801"
							data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
							data-index="4"
							src="@/assets/news/06/01.png"
							_width="100%" alt="图片" data-report-img-idx="1" data-fail="0"></section>
				</section>
				<section style="padding: 0px 20px;box-sizing: border-box;">
					<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
						<span leaf=""><br></span>
					</p>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							leaf=""><br></span></p>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							leaf=""><br></span></p>
				</section>
				<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
					<section style="z-index: 1;box-sizing: border-box;">
						<section
							style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
							<section
								style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgb(180, 210, 6);min-width: 5%;max-width: 100%;height: auto;padding: 9px 16px;border-radius: 99%;overflow: hidden;box-sizing: border-box;">
								<section style="margin: 6px 0px 0px;box-sizing: border-box;">
									<section style="color: rgb(255, 255, 255);box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span
													leaf="">拒绝流于形式，</span></strong><strong
												style="box-sizing: border-box;"><span leaf="">让评价回归价值本身</span></strong>
										</p>
									</section>
								</section>
							</section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: -33px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;border-style: solid;border-width: 3px;border-color: rgba(180, 210, 6, 0.29);padding: 35px 19px 0px;box-sizing: border-box;">
						<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf="">赢科系统通过对评价全流程的深度重构，旨在解决教学评价中的核心症结。</span></p>
						</section>
						<section
							style="text-align: right;margin: 0px 0px -3px;line-height: 0;transform: translate3d(22px, 0px, 0px);-webkit-transform: translate3d(22px, 0px, 0px);-moz-transform: translate3d(22px, 0px, 0px);-o-transform: translate3d(22px, 0px, 0px);box-sizing: border-box;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 27px;height: auto;box-sizing: border-box;"
								nodeleaf=""><img
									data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7Qibw88Dbibq2CicBxBCrAVgoCsXQWlCVJwvHj69pR1LcNW7XsNjoiaVCGgQ/640?wx_fmt=png&amp;from=appmsg#imgIndex=2"
									class="rich_pages wxw-img" data-ratio="1.2224938875305624" data-s="300,640"
									data-type="png" data-w="409"
									style="vertical-align: middle; max-width: 100%; width: 27px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
									data-imgfileid="503351799"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="5"
									src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7Qibw88Dbibq2CicBxBCrAVgoCsXQWlCVJwvHj69pR1LcNW7XsNjoiaVCGgQ/640?wx_fmt=png&amp;from=appmsg&amp;tp=webp&amp;wxfrom=5&amp;wx_lazy=1#imgIndex=2"
									_width="100%" alt="图片" data-report-img-idx="2" data-fail="0"></section>
						</section>
					</section>
				</section>
				<section
					style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;background-color: rgb(180, 210, 6);height: auto;margin: 0px 7px 0px 0px;padding: 9px;border-top-left-radius: 32px;border-bottom-left-radius: 32px;overflow: hidden;box-sizing: border-box;">
						<section
							style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;box-sizing: border-box;">
								<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
									<section style="z-index: 1;box-sizing: border-box;">
										<section style="box-sizing: border-box;">
											<section data-cacheurl="" data-remoteid=""
												style="display: inline-block; width: 23px; height: 23px; vertical-align: top; overflow: hidden; background-repeat: no-repeat; background-attachment: scroll; box-sizing: border-box; background-image: url(&quot;https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7QarMH4YsxLnFhHJEf7UVUro6qekrEEN3TX97QGRr1YWQovO00Rm3JGg/640?wx_fmt=png&amp;from=appmsg&amp;tp=webp&amp;wxfrom=15&amp;wx_lazy=1&quot;); background-size: contain !important; background-position: 50% 50% !important;"
												data-lazy-bgimg="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7QarMH4YsxLnFhHJEf7UVUro6qekrEEN3TX97QGRr1YWQovO00Rm3JGg/640?wx_fmt=png&amp;from=appmsg"
												class="" data-fail="0">
												<section style="text-align: center;box-sizing: border-box;">
													<section
														style="font-size: 15px;color: rgb(142, 201, 101);box-sizing: border-box;">
														<p style="margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><span textstyle=""
																	style="font-weight: bold;">1</span></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
							</section>
							<section
								style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;padding: 0px 0px 0px 8px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(255, 255, 255);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf="">指标体系重构</span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;width: 0%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgb(245, 245, 245);border-radius: 10px;overflow: hidden;height: auto;margin: 0px -8px 0px 0px;padding: 21px;box-sizing: border-box;">
						<section style="line-height: 0;box-sizing: border-box;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
								nodeleaf=""><img
									data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7QRRIIkhBvGibqlVMVjIjLHN2jjvNmQo0pRCyMs4Ew1Rjow82riafH75GA/640?wx_fmt=png&amp;from=appmsg#imgIndex=3"
									class="rich_pages wxw-img" data-ratio="1" data-s="300,640" data-type="png"
									data-w="750"
									style="vertical-align: middle; max-width: 100%; width: 0px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
									data-imgfileid="503351800"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="6"
									src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7QRRIIkhBvGibqlVMVjIjLHN2jjvNmQo0pRCyMs4Ew1Rjow82riafH75GA/640?wx_fmt=png&amp;from=appmsg&amp;tp=webp&amp;wxfrom=5&amp;wx_lazy=1#imgIndex=3"
									_width="100%" alt="图片" data-report-img-idx="4" data-fail="0"></section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-start;box-sizing: border-box;">
						<section style="margin: -10px 0px 0px;line-height: 0;box-sizing: border-box;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 16px;height: auto;box-sizing: border-box;"
								nodeleaf=""><img
									data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7Qx0VFbAWAkquGpl75H3fe8QfuaDibR8aWFXlkduEnCpXe8zX8vhKmDYw/640?wx_fmt=png&amp;from=appmsg#imgIndex=4"
									class="rich_pages wxw-img" data-ratio="0.9907407407407407" data-s="300,640"
									data-type="png" data-w="1080"
									style="vertical-align: middle; max-width: 100%; width: 16px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
									data-imgfileid="503351798"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="7"
									src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7Qx0VFbAWAkquGpl75H3fe8QfuaDibR8aWFXlkduEnCpXe8zX8vhKmDYw/640?wx_fmt=png&amp;from=appmsg&amp;tp=webp&amp;wxfrom=5&amp;wx_lazy=1#imgIndex=4"
									_width="100%" alt="图片" data-report-img-idx="3" data-fail="0"></section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 13px 0px 10px;width: 100%;align-self: flex-start;padding: 0px 25px;overflow: hidden;box-sizing: border-box;">
					<section style="text-align: justify;width: 100%;box-sizing: border-box;">
						<p
							style="margin: 0px 0px 10px;text-align: center;white-space: normal;padding: 0px;box-sizing: border-box;">
							<strong style="box-sizing: border-box;"><span
									style="text-align: justify;box-sizing: border-box;"><span
										leaf="">从“模糊”走向“精准”</span></span></strong>
						</p>
						<p style="margin: 0px 0px 10px;white-space: normal;padding: 0px;box-sizing: border-box;"><span
								leaf="">传统单一的评价模型已无法适应现代高等教育的需求。赢科系统实现了科学的维度拆分：</span></p>
						<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
							class="list-paddingleft-1">
							<li style="box-sizing: border-box;">
								<p style="margin: 0px 0px 10px;padding: 0px;box-sizing: border-box;"><span
										leaf="">课程与教师双轨并行：我们将课程设计（如内容安排、考核方式）与教师授课（如教学态度、表达能力）进行独立评价。这使得问题归因更为清晰，无论是优化课程体系，还是支持教师专业发展，都目标明确。</span>
								</p>
							</li>
							<li style="box-sizing: border-box;">
								<p style="margin: 0px 0px 10px;padding: 0px;box-sizing: border-box;"><span
										leaf="">深度聚焦“学习成效”：评价的重心从“老师教得怎么样”，转向“学生学到了什么”。我们的指标体系更关注：“课程教学是否能够让我达到学习预期？”
										“课程考核能否反映我的学习成效？”，确保反馈直指教学质量的核心。</span></p>
							</li>
						</ul>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
					</section>
				</section>
				<section
					style="display: flex;justify-content: center;margin: 10px 0px;box-sizing: border-box; align-items: center;">
					<section style="line-height: 0;box-sizing: border-box;">
						<section
							style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;border-style: dashed;border-width: 0px;box-sizing: border-box;"
							nodeleaf=""><img class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
								data-ratio="2.1259259259259258" data-s="300,640" data-type="jpeg" data-w="1080"
								style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(0.470383) / 1; width: 339px !important; height: auto !important;"
								data-imgfileid="503351805"
								data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
								data-index="8"
								src="@/assets/news/06/02.jpg"
								_width="100%" alt="图片"></section>
					</section>
					<section style="line-height: 0;box-sizing: border-box;">
						<section
							style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;border-style: dashed;border-width: 0px;box-sizing: border-box;"
							nodeleaf=""><img class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
								data-ratio="2.1287037037037035" data-s="300,640" data-type="jpeg" data-w="1080"
								style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(0.469769) / 1; width: 339px !important; height: auto !important;"
								data-imgfileid="503351806"
								data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
								data-index="9"
								src="@/assets/news/06/03.jpg"
								_width="100%" alt="图片"></section>
					</section>
				</section>
				<section
					style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;background-color: rgb(180, 210, 6);height: auto;margin: 0px 7px 0px 0px;padding: 9px;border-top-left-radius: 32px;border-bottom-left-radius: 32px;overflow: hidden;box-sizing: border-box;">
						<section
							style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;box-sizing: border-box;">
								<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
									<section style="z-index: 1;box-sizing: border-box;">
										<section style="box-sizing: border-box;">
											<section data-cacheurl="" data-remoteid=""
												style="display: inline-block; width: 23px; height: 23px; vertical-align: top; overflow: hidden; background-repeat: no-repeat; background-attachment: scroll; box-sizing: border-box; background-image: url(&quot;data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg==&quot;); background-size: contain !important; background-position: 50% 50% !important;"
												data-lazy-bgimg="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7QarMH4YsxLnFhHJEf7UVUro6qekrEEN3TX97QGRr1YWQovO00Rm3JGg/640?wx_fmt=png&amp;from=appmsg"
												class="wx_imgbc_placeholder">
												<section style="text-align: center;box-sizing: border-box;">
													<section
														style="font-size: 15px;color: rgb(142, 201, 101);box-sizing: border-box;">
														<p style="margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><span textstyle=""
																	style="font-weight: bold;">2</span></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
							</section>
							<section
								style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;padding: 0px 0px 0px 8px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(255, 255, 255);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<strong style="box-sizing: border-box;"><span leaf="">用户体验革新</span></strong>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;width: 0%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgb(245, 245, 245);border-radius: 10px;overflow: hidden;height: auto;margin: 0px -8px 0px 0px;padding: 21px;box-sizing: border-box;">
						<section style="line-height: 0;box-sizing: border-box;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
								nodeleaf=""><img
									data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7QRRIIkhBvGibqlVMVjIjLHN2jjvNmQo0pRCyMs4Ew1Rjow82riafH75GA/640?wx_fmt=png&amp;from=appmsg#imgIndex=7"
									class="rich_pages wxw-img js_img_placeholder wx_img_placeholder" data-ratio="1"
									data-s="300,640" data-type="png" data-w="750"
									style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1) / 1; width: 643px !important; height: auto !important;"
									data-imgfileid="503351803"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="10"
									src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
									_width="100%" alt="图片"></section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-start;box-sizing: border-box;">
						<section style="margin: -10px 0px 0px;line-height: 0;box-sizing: border-box;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 16px;height: auto;box-sizing: border-box;"
								nodeleaf=""><img
									data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7Qx0VFbAWAkquGpl75H3fe8QfuaDibR8aWFXlkduEnCpXe8zX8vhKmDYw/640?wx_fmt=png&amp;from=appmsg#imgIndex=8"
									class="rich_pages wxw-img wx_img_placeholder_mini" data-ratio="0.9907407407407407"
									data-s="300,640" data-type="png" data-w="1080"
									style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.00935) / 1; width: 16px !important; height: auto !important;"
									data-imgfileid="503351804"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="11"
									src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
									_width="100%" alt="图片"></section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 13px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;padding: 0px 25px;overflow: hidden;box-sizing: border-box;">
						<section style="text-align: justify;box-sizing: border-box;">
							<p
								style="text-align: center;margin: 0px 0px 10px;white-space: normal;padding: 0px;box-sizing: border-box;">
								<strong style="box-sizing: border-box;"><span leaf="">从“负担”变为“便捷”&nbsp;</span></strong>
							</p>
							<p style="margin: 0px 0px 10px;white-space: normal;padding: 0px;box-sizing: border-box;">
								<span leaf="">科学的体系，需要高效的执行来保障。我们致力于为师生提供流畅、无感的参与体验：</span>
							</p>
							<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
								class="list-paddingleft-1">
								<li style="box-sizing: border-box;">
									<p style="margin: 0px 0px 10px;padding: 0px;box-sizing: border-box;"><span
											leaf="">“多师一卷”创新模式：针对一门课程多位教师的情况，学生只需填写一份问卷，即可完成对所有教师的评价，极大提升了评教效率，有效保证了数据的回收率。</span>
									</p>
								</li>
								<li style="box-sizing: border-box;">
									<p style="margin: 0px 0px 10px;padding: 0px;box-sizing: border-box;"><span
											leaf="">全链路、多入口触达：系统可与企业微信、钉钉及校内教务系统深度融合，并通过“智能弹窗提醒”等功能，确保信息有效触达，让师生在最方便的场景下，轻松完成评价。</span>
									</p>
								</li>
							</ul>
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf=""><br></span></p>
						</section>
						<section style="line-height: 0;box-sizing: border-box; text-align: center;">
							<section
								style="vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
								nodeleaf=""><img class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
									data-ratio="1.4055555555555554" data-s="300,640" data-type="png" data-w="1080"
									style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(0.711462) / 1; width: 627px !important; height: auto !important;"
									data-imgfileid="503351807"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="12"
									src="@/assets/news/06/04.png"
									_width="100%" alt="图片"></section>
						</section>
						<section style="line-height: 0;box-sizing: border-box; text-align: center;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
								nodeleaf=""><img class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
									data-ratio="1.413888888888889" data-s="300,640" data-type="jpeg" data-w="1080"
									style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(0.707269) / 1; width: 627px !important; height: auto !important;"
									data-imgfileid="503351809"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="13"
									src="@/assets/news/06/05.jpg"
									_width="100%" alt="图片"></section>
						</section>
					</section>
				</section>
				<section
					style="text-align: center;justify-content: center;margin: 10px 0%;display: flex;flex-flow: row;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;align-self: center;height: auto;box-sizing: border-box;">
						<section style="margin: 0px 0%;box-sizing: border-box;">
							<section style="background-color: rgb(220, 237, 200);height: 1px;box-sizing: border-box;">
								<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
									role="img" aria-label="插图"></svg>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: 40px;flex: 0 0 auto;height: auto;align-self: center;margin: 0px 15px;box-sizing: border-box;">
						<section style="margin-top: 10px;margin-bottom: 10px;line-height: 0;box-sizing: border-box;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
								nodeleaf=""><img
									data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7QJ6xmiaYutqhhxN9wpUA28gAOmWzmyEhkPR9MJr9w2mrqvZadxibhqzzw/640?wx_fmt=png&amp;from=appmsg#imgIndex=11"
									class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
									data-ratio="0.9005681818181818" data-s="300,640" data-type="png" data-w="1056"
									style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.11041) / 1; width: 40px !important; height: auto !important;"
									data-imgfileid="503351811"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="14"
									src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
									_width="100%" alt="图片"></section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;align-self: center;height: auto;box-sizing: border-box;">
						<section style="margin: 0px 0%;box-sizing: border-box;">
							<section style="background-color: rgb(220, 237, 200);height: 1px;box-sizing: border-box;">
								<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
									role="img" aria-label="插图"></svg>
							</section>
						</section>
					</section>
				</section>
				<section
					style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
						<section style="margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;min-width: 10%;max-width: 100%;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 0;letter-spacing: 0px;width: auto;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
									<section style="z-index: 2;box-sizing: border-box;">
										<section
											style="text-align: left;margin: 0px 0px -5px;transform: translate3d(-4px, 0px, 0px);-webkit-transform: translate3d(-4px, 0px, 0px);-moz-transform: translate3d(-4px, 0px, 0px);-o-transform: translate3d(-4px, 0px, 0px);box-sizing: border-box;">
											<section
												style="display: inline-block;width: 8px;height: 8px;vertical-align: top;overflow: hidden;background-color: rgb(77, 179, 50);box-sizing: border-box;">
												<svg viewBox="0 0 1 1"
													style="float:left;line-height:0;width:0;vertical-align:top;"
													role="img" aria-label="插图"></svg>
											</section>
										</section>
									</section>
								</section>
								<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
									<section style="z-index: 1;box-sizing: border-box;">
										<section
											style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;box-sizing: border-box;">
											<section
												style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;background-image: linear-gradient(90deg, rgb(77, 179, 50) 13%, rgb(240, 240, 240) 88%);padding: 1px;line-height: 1.6;box-sizing: border-box;">
												<section
													style="justify-content: flex-start;display: flex;flex-flow: row;box-sizing: border-box;">
													<section
														style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-image: linear-gradient(90deg, rgb(202, 229, 194) 13%, rgb(240, 240, 240) 88%);padding: 10px 20px;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
														<section
															style="text-align: justify;font-size: 18px;color: rgb(77, 179, 50);letter-spacing: 2px;box-sizing: border-box;">
															<p
																style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
																<strong style="box-sizing: border-box;"><span
																		leaf="">中山大学的成功实践&nbsp;</span></strong>
															</p>
														</section>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
								<section
									style="transform: translate3d(30px, 0px, 0px);-webkit-transform: translate3d(30px, 0px, 0px);-moz-transform: translate3d(30px, 0px, 0px);-o-transform: translate3d(30px, 0px, 0px);margin: -10px 0px 0px;box-sizing: border-box;">
									<section
										style="display: inline-block;width: 100%;height: 20px;vertical-align: top;overflow: hidden;background-color: rgb(180, 210, 6);box-sizing: border-box;">
										<svg viewBox="0 0 1 1"
											style="float:left;line-height:0;width:0;vertical-align:top;" role="img"
											aria-label="插图"></svg>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;margin: 0px 0px 0px -10px;z-index: 1;box-sizing: border-box;">
						<section style="margin-top: 10px;margin-bottom: 10px;line-height: 0;box-sizing: border-box;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 45px;height: auto;box-sizing: border-box;"
								nodeleaf=""><img
									data-src="https://mmbiz.qpic.cn/mmbiz_gif/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7QcgPVmcXZ7YoJJJzBSxxaexaAUzSiaC93Jhic7PEnI3dCeG9R3Q6nsgTQ/640?wx_fmt=gif&amp;from=appmsg#imgIndex=12"
									class="rich_pages wxw-img js_img_placeholder wx_img_placeholder __bg_gif"
									data-ratio="0.684375" data-s="300,640" data-type="gif" data-w="640"
									style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.46119) / 1; width: 45px !important; height: auto !important;"
									data-imgfileid="503351812"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="15"
									src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
									_width="100%" data-order="1" alt="图片"></section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: -33px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;border-style: solid;border-width: 3px;border-color: rgba(180, 210, 6, 0.29);padding: 35px 19px 0px;box-sizing: border-box;">
						<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf="">一套系统的价值，最终要在真实的、高标准的场景中得到检验。</span></p>
						</section>
						<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf=""><br></span></p>
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf="">作为国内顶尖的“双一流”高校，中山大学对教学评价工作的严谨性、高效性与数据价值挖掘有着极高的要求。通过部署赢科智慧评教系统，中山大学实现了：</span>
							</p>
						</section>
						<section
							style="text-align: right;margin: 0px 0px -3px;line-height: 0;transform: translate3d(22px, 0px, 0px);-webkit-transform: translate3d(22px, 0px, 0px);-moz-transform: translate3d(22px, 0px, 0px);-o-transform: translate3d(22px, 0px, 0px);box-sizing: border-box;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 27px;height: auto;box-sizing: border-box;"
								nodeleaf=""><img
									data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7Qibw88Dbibq2CicBxBCrAVgoCsXQWlCVJwvHj69pR1LcNW7XsNjoiaVCGgQ/640?wx_fmt=png&amp;from=appmsg#imgIndex=13"
									class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
									data-ratio="1.2224938875305624" data-s="300,640" data-type="png" data-w="409"
									style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(0.818) / 1; width: 27px !important; height: auto !important;"
									data-imgfileid="503351810"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="16"
									src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
									_width="100%" alt="图片"></section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;border-radius: 335px;overflow: hidden;padding: 3px;background-image: conic-gradient(rgb(180, 210, 6) 0%, rgba(180, 210, 6, 0.09) 96%);box-sizing: border-box;">
						<section style="text-align: center;box-sizing: border-box;">
							<section
								style="display: inline-block;width: 26px;height: 26px;vertical-align: top;overflow: hidden;border-radius: 142px;background-color: rgb(255, 255, 255);box-sizing: border-box;">
								<section style="color: rgb(180, 210, 6);box-sizing: border-box;">
									<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span leaf="">1</span></strong></p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
						<section style="text-align: justify;color: rgb(210, 32, 26);box-sizing: border-box;">
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
									style="box-sizing: border-box;"><span
										style="color: rgb(62, 62, 62);box-sizing: border-box;"><span
											leaf="">从“管理难题”到“运行典范”</span></span></strong></p>
						</section>
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section style="background-color: rgb(255, 236, 89);height: 3px;box-sizing: border-box;">
								<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
									role="img" aria-label="插图"></svg>
							</section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;border-style: solid;border-width: 0px 0px 0px 3px;border-left-color: rgba(180, 210, 6, 0.29);height: auto;margin: 0px 0px 0px 14px;padding: 6px 0px 0px 20px;box-sizing: border-box;">
						<section style="margin: 0px 0px 10px;box-sizing: border-box;">
							<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">面对多校区、数万师生的大规模评教需求，赢科系统以其强大的高并发处理能力和稳定的架构，从容应对峰值压力，保障了评教工作的平稳、有序进行，将一项复杂的管理任务转变为高效的运行典范。</span>
								</p>
							</section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;border-radius: 335px;overflow: hidden;padding: 3px;background-image: conic-gradient(rgb(180, 210, 6) 0%, rgba(180, 210, 6, 0.09) 96%);box-sizing: border-box;">
						<section style="text-align: center;box-sizing: border-box;">
							<section
								style="display: inline-block;width: 26px;height: 26px;vertical-align: top;overflow: hidden;border-radius: 142px;background-color: rgb(255, 255, 255);box-sizing: border-box;">
								<section style="color: rgb(180, 210, 6);box-sizing: border-box;">
									<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span leaf="">2</span></strong></p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
						<section style="text-align: justify;color: rgb(210, 32, 26);box-sizing: border-box;">
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
									style="box-sizing: border-box;"><span
										style="color: rgb(62, 62, 62);box-sizing: border-box;"><span
											leaf="">从“沉睡数据”到“决策金矿”</span></span></strong></p>
						</section>
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section style="background-color: rgb(255, 236, 89);height: 3px;box-sizing: border-box;">
								<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
									role="img" aria-label="插图"></svg>
							</section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;border-style: solid;border-width: 0px 0px 0px 3px;border-left-color: rgba(180, 210, 6, 0.29);height: auto;margin: 0px 0px 0px 14px;padding: 0px 0px 0px 20px;box-sizing: border-box;">
						<section style="margin: 0px 0px 10px;box-sizing: border-box;">
							<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">系统强大的数据分析与可视化引擎，将海量评教结果转化为直观、多维的洞察报告。院系负责人可以清晰看到某门公共课在“实践应用性”指标上连续几个学期得分偏低，从而精准启动课程改革；学校管理层也能通过数据洞察，为教学资源的优化配置提供前所未有的坚实依据。</span>
								</p>
							</section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;border-radius: 335px;overflow: hidden;padding: 3px;background-image: conic-gradient(rgb(180, 210, 6) 0%, rgba(180, 210, 6, 0.09) 96%);box-sizing: border-box;">
						<section style="text-align: center;box-sizing: border-box;">
							<section
								style="display: inline-block;width: 26px;height: 26px;vertical-align: top;overflow: hidden;border-radius: 142px;background-color: rgb(255, 255, 255);box-sizing: border-box;">
								<section style="color: rgb(180, 210, 6);box-sizing: border-box;">
									<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
											style="box-sizing: border-box;"><span leaf="">3</span></strong></p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
						<section style="text-align: justify;color: rgb(210, 32, 26);box-sizing: border-box;">
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
									style="box-sizing: border-box;"><span
										style="color: rgb(62, 62, 62);box-sizing: border-box;"><span
											leaf="">从“被动应付”到“主动参与”</span></span></strong></p>
						</section>
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section style="background-color: rgb(255, 236, 89);height: 3px;box-sizing: border-box;">
								<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
									role="img" aria-label="插图"></svg>
							</section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;border-style: solid;border-width: 0px 0px 0px 3px;border-left-color: rgba(180, 210, 6, 0.29);height: auto;margin: 0px 0px 0px 14px;padding: 0px 0px 0px 20px;box-sizing: border-box;">
						<section style="margin: 0px 0px 10px;box-sizing: border-box;">
							<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
								<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">便捷的操作流程与人性化的设计，获得了师生的广泛认可。当评价不再是一种负担，师生更愿意投入时间，提供真实、有建设性的反馈。这不仅提升了数据质量，更在校园内营造了一种积极、开放的教学相长文化氛围。</span>
								</p>
							</section>
						</section>
					</section>
				</section>
				<section style="margin-top: 10px;margin-bottom: 10px;box-sizing: border-box;">
					<section style="border: 3px solid rgb(142, 201, 101);padding: 3px;box-sizing: border-box;">
						<section
							style="border-color: rgb(161, 228, 115);border-width: 1px;border-style: dashed;padding: 10px;box-sizing: border-box;">
							<section style="text-align: left;box-sizing: border-box;">
								<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">选择赢科智慧评教系统，您所获得的将是：</span></p>
							</section>
						</section>
					</section>
				</section>
				<section style="margin-top: 10px;margin-bottom: 10px;box-sizing: border-box;">
					<section style="border: 1px solid rgb(142, 201, 101);padding: 3px;box-sizing: border-box;">
						<section
							style="border-color: rgb(142, 201, 101);border-width: 3px;border-style: solid;padding: 10px;box-sizing: border-box;">
							<section style="text-align: center;box-sizing: border-box;">
								<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
									class="list-paddingleft-2">
									<li style="box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
												style="box-sizing: border-box;"><span
													leaf="">一个经过顶尖高校复杂场景验证的成熟、可靠的技术平台。</span></span></p>
									</li>
									<li style="box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
												style="box-sizing: border-box;"><span
													leaf="">一支深刻理解高等教育管理痛点的专家咨询与实施团队。</span></span></p>
									</li>
									<li style="box-sizing: border-box;">
										<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
												style="box-sizing: border-box;"><span
													leaf="">一种以数据驱动教学质量持续提升的先进管理范式。</span></span></p>
									</li>
								</ul>
							</section>
						</section>
					</section>
				</section>
				<section style="margin-top: 10px;margin-bottom: 10px;box-sizing: border-box;">
					<section style="border: 3px solid rgb(142, 201, 101);padding: 3px;box-sizing: border-box;">
						<section
							style="border-color: rgb(161, 228, 115);border-width: 1px;border-style: dashed;padding: 10px;box-sizing: border-box;">
							<section style="text-align: left;box-sizing: border-box;">
								<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">我们相信，是时候用更智慧的方式，将教学评价从一项管理任务，升级为驱动教学质量提升的核心引擎。</span></p>
							</section>
						</section>
					</section>
				</section>
				<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
						leaf=""><br></span></p>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 10px 0px 0px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: top;width: 50%;align-self: flex-start;flex: 0 0 auto;box-sizing: border-box;">
						<section
							style="transform: perspective(0px);-webkit-transform: perspective(0px);-moz-transform: perspective(0px);-o-transform: perspective(0px);transform-style: flat;box-sizing: border-box;">
							<section
								style="transform: rotateX(180deg);-webkit-transform: rotateX(180deg);-moz-transform: rotateX(180deg);-o-transform: rotateX(180deg);box-sizing: border-box;">
								<section
									style="display: inline-block;width: 8px;height: 8px;vertical-align: top;overflow: hidden;background-color: rgb(180, 210, 6);box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section style="display: inline-block;vertical-align: top;width: 50%;box-sizing: border-box;">
						<section
							style="transform: perspective(0px);-webkit-transform: perspective(0px);-moz-transform: perspective(0px);-o-transform: perspective(0px);transform-style: flat;box-sizing: border-box;">
							<section
								style="transform: rotateX(180deg) rotateY(180deg);-webkit-transform: rotateX(180deg) rotateY(180deg);-moz-transform: rotateX(180deg) rotateY(180deg);-o-transform: rotateX(180deg) rotateY(180deg);box-sizing: border-box;">
								<section
									style="display: inline-block;width: 8px;height: 8px;vertical-align: top;overflow: hidden;background-color: rgb(180, 210, 6);box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: -2px 0px;box-sizing: border-box;">
					<section
						style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;border-style: solid;border-width: 1px;border-color: rgb(180, 210, 6);height: auto;margin: 0px 6px;padding: 14px 24px 0px;box-sizing: border-box;">
						<section
							style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: -28px 0px 10px;box-sizing: border-box;">
							<section
								style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;background-color: rgb(255, 255, 255);padding: 0px 8px;box-sizing: border-box;">
								<section
									style="justify-content: center;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
									<section
										style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;box-sizing: border-box;">
										<section style="margin: 0px;line-height: 0;box-sizing: border-box;">
											<section
												style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 16px;height: auto;box-sizing: border-box;"
												nodeleaf=""><img
													data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7QOQyLNliaZsvXaf3TD80ZekwLzApqNXdBbMvU3m9RcmEuDsIaSMxaTJQ/640?wx_fmt=png&amp;from=appmsg#imgIndex=14"
													class="rich_pages wxw-img wx_img_placeholder_mini"
													data-ratio="1.358" data-s="300,640" data-type="png" data-w="500"
													style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(0.736377) / 1; width: 16px !important; height: auto !important;"
													data-imgfileid="503351808"
													data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
													data-index="17"
													src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
													_width="100%" alt="图片"></section>
										</section>
									</section>
									<section
										style="display: inline-block;vertical-align: middle;width: auto;flex: 0 0 0%;height: auto;margin: 0px -4px 0px 0px;align-self: center;box-sizing: border-box;">
										<section
											style="transform: rotateZ(13deg);-webkit-transform: rotateZ(13deg);-moz-transform: rotateZ(13deg);-o-transform: rotateZ(13deg);box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 18px;height: 29px;vertical-align: top;overflow: hidden;border-radius: 99%;background-color: rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
									<section
										style="display: inline-block;vertical-align: middle;width: auto;flex: 0 0 0%;height: auto;margin: 0px -4px 0px 0px;align-self: center;box-sizing: border-box;">
										<section
											style="transform: rotateZ(13deg);-webkit-transform: rotateZ(13deg);-moz-transform: rotateZ(13deg);-o-transform: rotateZ(13deg);box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 18px;height: 29px;vertical-align: top;overflow: hidden;border-radius: 99%;background-color: rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
									<section
										style="display: inline-block;vertical-align: middle;width: auto;flex: 0 0 0%;height: auto;margin: 0px -4px 0px 0px;align-self: center;box-sizing: border-box;">
										<section
											style="transform: rotateZ(13deg);-webkit-transform: rotateZ(13deg);-moz-transform: rotateZ(13deg);-o-transform: rotateZ(13deg);box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 18px;height: 29px;vertical-align: top;overflow: hidden;border-radius: 99%;background-color: rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
									<section
										style="display: inline-block;vertical-align: middle;width: auto;flex: 0 0 0%;height: auto;margin: 0px -4px 0px 0px;align-self: center;box-sizing: border-box;">
										<section
											style="transform: rotateZ(13deg);-webkit-transform: rotateZ(13deg);-moz-transform: rotateZ(13deg);-o-transform: rotateZ(13deg);box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 18px;height: 29px;vertical-align: top;overflow: hidden;border-radius: 99%;background-color: rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
									<section
										style="display: inline-block;vertical-align: middle;width: auto;flex: 0 0 0%;height: auto;margin: 0px -4px 0px 0px;align-self: center;box-sizing: border-box;">
										<section
											style="transform: rotateZ(13deg);-webkit-transform: rotateZ(13deg);-moz-transform: rotateZ(13deg);-o-transform: rotateZ(13deg);box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 18px;height: 29px;vertical-align: top;overflow: hidden;border-radius: 99%;background-color: rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
									<section
										style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;box-sizing: border-box;">
										<section style="margin: 0px;line-height: 0;box-sizing: border-box;">
											<section
												style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 16px;height: auto;box-sizing: border-box;"
												nodeleaf=""><img
													data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpicfA8SFfxUoPGcJoiboNq1w7QOQyLNliaZsvXaf3TD80ZekwLzApqNXdBbMvU3m9RcmEuDsIaSMxaTJQ/640?wx_fmt=png&amp;from=appmsg#imgIndex=15"
													class="rich_pages wxw-img wx_img_placeholder_mini"
													data-ratio="1.358" data-s="300,640" data-type="png" data-w="500"
													style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(0.736377) / 1; width: 16px !important; height: auto !important;"
													data-imgfileid="503351815"
													data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
													data-index="18"
													src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
													_width="100%" alt="图片"></section>
										</section>
									</section>
								</section>
								<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
									<section style="z-index: 1;box-sizing: border-box;">
										<section style="margin: -26px 0px 10px;box-sizing: border-box;">
											<section
												style="font-size: 14px;color: rgb(255, 255, 255);box-sizing: border-box;">
												<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
														style="box-sizing: border-box;"><span
															leaf="">赢科天地</span></strong></p>
											</section>
										</section>
									</section>
								</section>
							</section>
						</section>
						<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
							<p
								style="text-align: left;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
								<span style="text-align: justify;box-sizing: border-box;"><span
										leaf="">作为未来教学体验探索者，赢科助力高校数字化发展，设计研发基于人工智能的高校智慧教育生态体系。紧紧围绕赢科“1+3+1”智慧教育生态模型，助力高等教育信息化的全面发展。</span></span>
							</p>
						</section>
						<section
							style="justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
								<section
									style="justify-content: flex-start;display: flex;flex-flow: row;margin: 5px 0px 0px;box-sizing: border-box;">
									<section
										style="display: inline-block;width: 18px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;background-color: rgba(180, 210, 6, 0.29);line-height: 0;padding: 2px 0px 8px 6px;border-style: solid;border-width: 1px;border-color: rgb(180, 210, 6);border-radius: 130px;overflow: hidden;box-sizing: border-box;">
										<section
											style="transform: rotateZ(315deg);-webkit-transform: rotateZ(315deg);-moz-transform: rotateZ(315deg);-o-transform: rotateZ(315deg);box-sizing: border-box;">
											<section
												style="text-align: center;transform: translate3d(-3px, 0px, 0px);-webkit-transform: translate3d(-3px, 0px, 0px);-moz-transform: translate3d(-3px, 0px, 0px);-o-transform: translate3d(-3px, 0px, 0px);box-sizing: border-box;">
												<section
													style="display: inline-block;width: 10px;height: 6px;vertical-align: top;overflow: hidden;border-style: solid;border-width: 0px 0px 2px 2px;border-color: rgb(75, 194, 224) rgb(75, 194, 224) rgb(180, 210, 6) rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
							</section>
							<section
								style="display: inline-block;vertical-align: top;width: auto;flex: 100 100 0%;height: auto;padding: 0px 0px 0px 15px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span style="color: rgb(180, 210, 6);box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span
													leaf="">1个核心：智慧教学</span></strong></span>
									</p>
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span
											leaf="">确保生态体系始终围绕教学这个“轴心”运转，从技术层面推动“管理更好引导服务教学、科研更好反哺促进教学、资源更好支撑保障教学”的发展目标得以落地实现。</span>
									</p>
								</section>
							</section>
						</section>
						<section
							style="justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
								<section
									style="justify-content: flex-start;display: flex;flex-flow: row;margin: 5px 0px 0px;box-sizing: border-box;">
									<section
										style="display: inline-block;width: 18px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;background-color: rgba(180, 210, 6, 0.29);line-height: 0;padding: 2px 0px 8px 6px;border-style: solid;border-width: 1px;border-color: rgb(180, 210, 6);border-radius: 130px;overflow: hidden;box-sizing: border-box;">
										<section
											style="transform: rotateZ(315deg);-webkit-transform: rotateZ(315deg);-moz-transform: rotateZ(315deg);-o-transform: rotateZ(315deg);box-sizing: border-box;">
											<section
												style="text-align: center;transform: translate3d(-3px, 0px, 0px);-webkit-transform: translate3d(-3px, 0px, 0px);-moz-transform: translate3d(-3px, 0px, 0px);-o-transform: translate3d(-3px, 0px, 0px);box-sizing: border-box;">
												<section
													style="display: inline-block;width: 10px;height: 6px;vertical-align: top;overflow: hidden;border-style: solid;border-width: 0px 0px 2px 2px;border-color: rgb(75, 194, 224) rgb(75, 194, 224) rgb(180, 210, 6) rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
							</section>
							<section
								style="display: inline-block;vertical-align: top;width: auto;flex: 100 100 0%;height: auto;padding: 0px 0px 0px 15px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span style="color: rgb(180, 210, 6);box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span
													leaf="">3个支点：智慧管理服务、资源服务、安全服务</span></strong></span>
									</p>
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf="">为教学活动提供组织管理、资源支持、安全保障等信息化服务，确保整个教育生态体系有序、高效、安全运转。</span>
									</p>
								</section>
							</section>
						</section>
						<section
							style="justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
								<section
									style="justify-content: flex-start;display: flex;flex-flow: row;margin: 5px 0px 0px;box-sizing: border-box;">
									<section
										style="display: inline-block;width: 18px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;background-color: rgba(180, 210, 6, 0.29);line-height: 0;padding: 2px 0px 8px 6px;border-style: solid;border-width: 1px;border-color: rgb(180, 210, 6);border-radius: 130px;overflow: hidden;box-sizing: border-box;">
										<section
											style="transform: rotateZ(315deg);-webkit-transform: rotateZ(315deg);-moz-transform: rotateZ(315deg);-o-transform: rotateZ(315deg);box-sizing: border-box;">
											<section
												style="text-align: center;transform: translate3d(-3px, 0px, 0px);-webkit-transform: translate3d(-3px, 0px, 0px);-moz-transform: translate3d(-3px, 0px, 0px);-o-transform: translate3d(-3px, 0px, 0px);box-sizing: border-box;">
												<section
													style="display: inline-block;width: 10px;height: 6px;vertical-align: top;overflow: hidden;border-style: solid;border-width: 0px 0px 2px 2px;border-color: rgb(75, 194, 224) rgb(75, 194, 224) rgb(180, 210, 6) rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
							</section>
							<section
								style="display: inline-block;vertical-align: top;width: auto;flex: 100 100 0%;height: auto;padding: 0px 0px 0px 15px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span style="color: rgb(180, 210, 6);box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span
													leaf="">1个循环：智慧质量评价</span></strong></span>
									</p>
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf="">按照预训练的质量评价 AI
											模型，自动对高校各类教育数据进行采集分析，生成监测结果、评价结论和预警信息，持续辅助管理者科学决策和师生改进教学。</span>
									</p>
								</section>
							</section>
						</section>
						<section style="line-height: 0;box-sizing: border-box;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
								nodeleaf=""><img class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
									data-ratio="0.9759825327510917" data-s="300,640" data-type="png" data-w="458"
									style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.02461) / 1; width: 458px !important; height: auto !important;"
									data-imgfileid="503351817"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="19"
									src="@/assets/news/other/07.png"
									_width="100%" alt="图片"></section>
						</section>
						<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									style="box-sizing: border-box;"><span leaf=""><br></span></span></p>
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									style="box-sizing: border-box;"><span
										leaf="">赢科紧抓“人工智能”引领与“未来教学体验”导向的数智化教育主线。以人工智能基座+低代码平台的理念打造赢科智慧教育生态解决方案，对高等教育的教、管、学、评全流程实施数字化、智能化覆盖，为高等教育高质量发展提供数据决策支持与智慧教学服务。</span></span>
							</p>
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									style="box-sizing: border-box;"><span leaf=""><br></span></span></p>
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									style="box-sizing: border-box;"><span
										leaf="">合志赢科，共创未来，科技助力教育的每一分热爱与责任！</span></span></p>
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf=""><br></span></p>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: top;width: 50%;align-self: flex-start;flex: 0 0 auto;box-sizing: border-box;">
						<section style="box-sizing: border-box;">
							<section
								style="display: inline-block;width: 8px;height: 8px;vertical-align: top;overflow: hidden;background-color: rgb(180, 210, 6);box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section style="display: inline-block;vertical-align: top;width: 50%;box-sizing: border-box;">
						<section
							style="transform: perspective(0px);-webkit-transform: perspective(0px);-moz-transform: perspective(0px);-o-transform: perspective(0px);transform-style: flat;box-sizing: border-box;">
							<section
								style="transform: rotateY(180deg);-webkit-transform: rotateY(180deg);-moz-transform: rotateY(180deg);-o-transform: rotateY(180deg);box-sizing: border-box;">
								<section
									style="display: inline-block;width: 8px;height: 8px;vertical-align: top;overflow: hidden;background-color: rgb(180, 210, 6);box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
					</section>
				</section>
			</section>
		</div>`
	}, 
	{
		"id": 121377,
		"img": require("@/assets/news/07/01.png"),
		"title": "赢科教学档案袋系统：高校教师评价与发展体系的未来探索",
		"date": "2025年8月22日 12:00",
		"content": `<div>
			<section
				style="box-sizing: border-box; font-style: normal; font-weight: 400; text-align: justify; font-size: 16px; color: rgb(62, 62, 62); visibility: visible; margin-bottom: 0px;"
				data-pm-slice="0 0 []">
				<section
					style="display: flex; width: 100%; flex-flow: column; box-sizing: border-box; visibility: visible;">
					<section style="height: auto; z-index: 2; box-sizing: border-box; visibility: visible;">
						<section
							style="text-align: center; justify-content: center; display: flex; flex-flow: row; margin: 10px 0px -10px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; vertical-align: top; width: 32px; align-self: flex-start; flex: 0 0 auto; height: auto; line-height: 0; box-sizing: border-box; visibility: visible;">
								<section
									style="transform: rotateZ(343deg); box-sizing: border-box; visibility: visible;">
									<section style="box-sizing: border-box; visibility: visible;">
										<section
											style="display: inline-block; width: 7px; height: 18px; vertical-align: top; overflow: hidden; background-color: rgb(255, 236, 89); border-radius: 75px; box-sizing: border-box; visibility: visible;">
											<section
												style="text-align: justify; box-sizing: border-box; visibility: visible;">
												<p
													style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
													<span leaf="" style="visibility: visible;"><br
															style="visibility: visible;"></span>
												</p>
											</section>
										</section>
									</section>
								</section>
							</section>
							<section
								style="display: inline-block; vertical-align: top; width: 32px; align-self: flex-start; flex: 0 0 auto; height: auto; line-height: 0; box-sizing: border-box; visibility: visible;">
								<section
									style="transform: rotateZ(17deg); box-sizing: border-box; visibility: visible;">
									<section style="box-sizing: border-box; visibility: visible;">
										<section
											style="display: inline-block; width: 7px; height: 18px; vertical-align: top; overflow: hidden; background-color: rgb(255, 236, 89); border-radius: 75px; box-sizing: border-box; visibility: visible;">
											<section
												style="text-align: justify; box-sizing: border-box; visibility: visible;">
												<p
													style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
													<span leaf="" style="visibility: visible;"><br
															style="visibility: visible;"></span>
												</p>
											</section>
										</section>
									</section>
								</section>
							</section>
						</section>
					</section>
				</section>
				<section
					style="display: flex; width: 100%; flex-flow: column; box-sizing: border-box; visibility: visible;">
					<section style="z-index: 1; box-sizing: border-box; visibility: visible;">
						<section
							style="text-align: center; justify-content: center; display: flex; flex-flow: row; margin: 0px 0px 10px; box-sizing: border-box; visibility: visible;">
							<section
								style="display: inline-block; width: auto; vertical-align: top; align-self: flex-start; flex: 0 0 auto; background-color: rgb(180, 210, 6); min-width: 5%; max-width: 100%; height: auto; padding: 9px 16px; border-radius: 99%; overflow: hidden; box-sizing: border-box; visibility: visible;">
								<section style="margin: 6px 0px 0px; box-sizing: border-box; visibility: visible;">
									<section
										style="color: rgb(255, 255, 255); box-sizing: border-box; visibility: visible;">
										<p
											style="margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
											<strong style="box-sizing: border-box; visibility: visible;"><span leaf=""
													style="visibility: visible;">高等教育的核心议题与数字化转型</span></strong>
										</p>
									</section>
								</section>
							</section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left; justify-content: flex-start; display: flex; flex-flow: row; margin: -33px 0px 10px; box-sizing: border-box; visibility: visible;">
					<section
						style="display: inline-block; width: 100%; vertical-align: top; align-self: flex-start; flex: 0 0 auto; border-style: solid; border-width: 3px; border-color: rgba(180, 210, 6, 0.29); padding: 35px 19px 0px; box-sizing: border-box; visibility: visible;">
						<section
							style="text-align: justify; color: rgb(0, 0, 0); box-sizing: border-box; visibility: visible;">
							<p
								style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
								<span leaf=""
									style="visibility: visible;">在“双一流”建设进入关键深化阶段的宏观背景下，如何将教师个体的学术智慧与教学经验，转化为可量化、可传承、可评估的制度化教学资产，已成为衡量高校核心竞争力的重要标尺。传统以成果为导向的评价方式，越来越难以全面、客观地反映教学过程的复杂性以及教师发展的动态特征。</span>
							</p>
							<p
								style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
								<span leaf="" style="visibility: visible;"><br style="visibility: visible;"></span>
							</p>
						</section>
						<section style="text-align: justify; box-sizing: border-box; visibility: visible;">
							<p
								style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
								<span leaf=""
									style="visibility: visible;">在此背景下，构建一套能够系统支撑教师专业成长、持续推动教学质量改进的数字化基础设施，不再是可选方案，而是高校发展的战略必然。</span>
							</p>
						</section>
					</section>
				</section>
				<section style="padding: 0px 20px; box-sizing: border-box; visibility: visible;">
					<p
						style="white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span leaf="" style="visibility: visible;"><br style="visibility: visible;"></span>
					</p>
					<p
						style="text-align: center; white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span style="font-size: 18px; box-sizing: border-box; visibility: visible;"><strong
								style="box-sizing: border-box; visibility: visible;"><span
									style="color: rgb(0, 154, 86); box-sizing: border-box; visibility: visible;"><span
										leaf="" style="visibility: visible;">为何要建“教学档案袋”？</span></span></strong></span>
					</p>
					<p
						style="text-align: center; white-space: normal; margin: 0px; padding: 0px; box-sizing: border-box; visibility: visible;">
						<span style="font-size: 18px; box-sizing: border-box; visibility: visible;"><strong
								style="box-sizing: border-box; visibility: visible;"><span
									style="color: rgb(0, 154, 86); box-sizing: border-box; visibility: visible;"><span
										leaf="" style="visibility: visible;"><br
											style="visibility: visible;"></span></span></strong></span>
					</p>
				</section>
				<section style="line-height: 0; box-sizing: border-box; visibility: visible; text-align: center;">
					<section
						style="max-width: 100%; vertical-align: middle; display: inline-block; line-height: 0; box-sizing: border-box; visibility: visible;"
						nodeleaf=""><img class="rich_pages wxw-img" data-ratio="0.43425925925925923" data-s="300,640"
							data-type="png" data-w="1080"
							style="vertical-align: middle; max-width: 100%; width: 677px !important; box-sizing: border-box; height: auto !important; visibility: visible !important;"
							data-imgfileid="503351823"
							data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
							data-index="5" src="@/assets/news/07/01.png" _width="100%" alt="图片" data-report-img-idx="1"
							data-fail="0"></section>
				</section>
				<section style="padding: 0px 20px;box-sizing: border-box;">
					<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
						<span leaf=""><br></span>
					</p>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							style="text-align: left;box-sizing: border-box;"><span leaf="">其核心价值在于：</span></span></p>
				</section>
				<section
					style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 10px 0px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: bottom;width: auto;align-self: flex-end;flex: 100 100 0%;height: auto;box-sizing: border-box;">
						<section style="margin: 0px;box-sizing: border-box;">
							<section
								style="width: 100%;height: 5px;background-color: rgb(180, 210, 6);box-sizing: border-box;">
								<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
									role="img" aria-label="插图"></svg>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: bottom;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-end;padding: 0px 8px;box-sizing: border-box;">
						<section
							style="justify-content: center;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: bottom;width: auto;align-self: flex-end;flex: 0 0 0%;height: auto;box-sizing: border-box;">
								<section style="margin: 0px;line-height: 0;box-sizing: border-box;">
									<section
										style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 11px;height: auto;box-sizing: border-box;"
										nodeleaf=""><img data-src="" class="rich_pages wxw-img wx_img_placeholder_mini"
											data-ratio="0.9564814814814815" data-s="300,640" data-type="png"
											data-w="1080"
											style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.0455) / 1; width: 11px !important; height: auto !important;"
											data-imgfileid="503351822"
											data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
											data-index="6"
											src="@/assets/news/other/06.png"
											_width="100%" alt="图片"></section>
								</section>
							</section>
							<section
								style="display: inline-block;vertical-align: bottom;width: auto;align-self: flex-end;flex: 0 0 0%;height: auto;padding: 2px;box-sizing: border-box;">
								<section style="margin: 0px;line-height: 0;box-sizing: border-box;">
									<section
										style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 14px;height: auto;box-sizing: border-box;"
										nodeleaf=""><img class="rich_pages wxw-img wx_img_placeholder_mini"
											data-ratio="0.9564814814814815" data-s="300,640" data-type="png"
											data-w="1080"
											style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.0455) / 1; width: 14px !important; height: auto !important;"
											data-imgfileid="503351820"
											data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
											data-index="7"
											src="@/assets/news/other/06.png"
											_width="100%" alt="图片"></section>
								</section>
							</section>
							<section
								style="display: inline-block;vertical-align: bottom;width: auto;align-self: flex-end;flex: 0 0 0%;height: auto;box-sizing: border-box;">
								<section style="margin: 0px;line-height: 0;box-sizing: border-box;">
									<section
										style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 11px;height: auto;box-sizing: border-box;"
										nodeleaf=""><img class="rich_pages wxw-img wx_img_placeholder_mini"
											data-ratio="0.9564814814814815" data-s="300,640" data-type="png"
											data-w="1080"
											style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.0455) / 1; width: 11px !important; height: auto !important;"
											data-imgfileid="503351824"
											data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
											data-index="8"
											src="@/assets/news/other/06.png"
											_width="100%" alt="图片"></section>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: bottom;width: auto;align-self: flex-end;flex: 100 100 0%;height: auto;box-sizing: border-box;">
						<section style="margin: 0px;box-sizing: border-box;">
							<section
								style="width: 100%;height: 5px;background-color: rgb(180, 210, 6);box-sizing: border-box;">
								<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
									role="img" aria-label="插图"></svg>
							</section>
						</section>
					</section>
				</section>
				<section style="padding: 0px 20px;box-sizing: border-box;">
					<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
						<strong style="box-sizing: border-box;"><span leaf="">① &nbsp;变“主观印象”为“客观证据”</span></strong>
					</p>
					<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
						<span leaf=""><br></span>
					</p>
					<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
						<span
							leaf="">传统的评教评优，容易陷入主观偏向。而教学档案袋通过汇集课程大纲、教学视频、学生作品、同行评议、教学反思等多源数据，为教学评估提供了真实、公正、基于证据的素材。</span>
					</p>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;height: auto;box-sizing: border-box;">
						<section style="margin: 0px 0px 8px;box-sizing: border-box;">
							<section style="background-color: rgb(180, 210, 6);height: 1px;box-sizing: border-box;"><svg
									viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
									role="img" aria-label="插图"></svg></section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
						<section style="margin: 0px 0px 8px;box-sizing: border-box;">
							<section style="background-color: rgb(180, 210, 6);height: 1px;box-sizing: border-box;"><svg
									viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
									role="img" aria-label="插图"></svg></section>
						</section>
					</section>
				</section>
				<section style="padding: 0px 20px;box-sizing: border-box;">
					<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
						<strong style="box-sizing: border-box;"><span leaf="">② &nbsp;变“终点评估”为“过程支持”</span></strong>
					</p>
					<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
						<strong style="box-sizing: border-box;"><span leaf=""><br></span></strong>
					</p>
					<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
						<span leaf="">它不仅是评职称的工具，更是引导教师直观看到个人成长与进步的“导航图”。通过记录、反思、交流、改进，真正赋能教师的专业发展。</span>
					</p>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;height: auto;box-sizing: border-box;">
						<section style="margin: 0px 0px 8px;box-sizing: border-box;">
							<section style="background-color: rgb(180, 210, 6);height: 1px;box-sizing: border-box;"><svg
									viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
									role="img" aria-label="插图"></svg></section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
						<section style="margin: 0px 0px 8px;box-sizing: border-box;">
							<section style="background-color: rgb(180, 210, 6);height: 1px;box-sizing: border-box;"><svg
									viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
									role="img" aria-label="插图"></svg></section>
						</section>
					</section>
				</section>
				<section style="padding: 0px 20px;box-sizing: border-box;">
					<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
						<strong style="box-sizing: border-box;"><span leaf="">③ &nbsp;变“孤立个体”为“发展体系”</span></strong>
					</p>
					<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
						<span leaf=""><br></span>
					</p>
					<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
						<span leaf="">当全校的教学档案数据汇集，学校便能追踪教师发展轨迹，评估教学发展项目的成效，为教学改革提供数据驱动的决策支持。</span>
					</p>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;height: auto;box-sizing: border-box;">
						<section style="margin: 0px 0px 8px;box-sizing: border-box;">
							<section style="background-color: rgb(180, 210, 6);height: 1px;box-sizing: border-box;"><svg
									viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
									role="img" aria-label="插图"></svg></section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 0 0 0%;height: auto;padding: 0px 2px;box-sizing: border-box;">
						<section style="text-align: center;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;transform: matrix(1, 0, -0.2, 1, 0, 0);-webkit-transform: matrix(1, 0, -0.2, 1, 0, 0);-moz-transform: matrix(1, 0, -0.2, 1, 0, 0);-o-transform: matrix(1, 0, -0.2, 1, 0, 0);background-color: rgb(180, 210, 6);box-shadow: rgba(255, 255, 255, 0) 0px 0px 0px;line-height: 1;letter-spacing: 0px;width: 5px;height: auto;padding: 0px;box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;height: auto;align-self: center;padding: 0px 0px 0px 10px;box-sizing: border-box;">
						<section style="margin: 0px 0px 8px;box-sizing: border-box;">
							<section style="background-color: rgb(180, 210, 6);height: 1px;box-sizing: border-box;"><svg
									viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
									role="img" aria-label="插图"></svg></section>
						</section>
					</section>
				</section>
				<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
					<section style="z-index: 1;box-sizing: border-box;">
						<section
							style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
							<section
								style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;background-color: rgb(180, 210, 6);min-width: 5%;max-width: 100%;height: auto;padding: 9px 16px;border-radius: 99%;overflow: hidden;box-sizing: border-box;">
								<section style="margin: 6px 0px 0px;box-sizing: border-box;">
									<section
										style="text-align: justify;color: rgb(255, 255, 255);box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<strong style="box-sizing: border-box;"><span
													leaf="">实践范式：源自顶尖学府的深度探索</span></strong>
										</p>
									</section>
								</section>
							</section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: -33px 0px 10px;width: 100%;align-self: flex-start;border-style: solid;border-width: 3px;border-color: rgba(180, 210, 6, 0.29);padding: 35px 19px 0px;box-sizing: border-box;">
					<section style="text-align: justify;color: rgb(0, 0, 0);width: 100%;box-sizing: border-box;">
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">作为中国高等教育的领航者，北京大学具备前瞻性的视野，率先就此核心议题展开了系统性探索。其教师教学发展中心旨在构建一个能够完整记录、科学评估并有效促进教师教学全周期发展的数字化平台。</span>
						</p>
						<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
					</section>
				</section>
				<section style="line-height: 0;box-sizing: border-box; text-align: center;">
					<section
						style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;border-style: solid;border-width: 1px;border-color: rgb(180, 210, 6);border-radius: 5px;overflow: hidden;box-sizing: border-box;"
						nodeleaf=""><img class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
							data-imgfileid="503351828" data-ratio="0.6750936329588015" data-s="300,640" data-type="png"
							data-w="1068"
							style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.48128) / 1; width: 675px !important; height: auto !important;"
							data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
							data-index="9" src="@/assets/news/07/02.png" _width="100%" alt="图片"></section>
				</section>
				<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
						leaf=""><br></span></p>
				<section style="color: rgb(0, 154, 86);box-sizing: border-box;">
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							style="color: rgb(0, 0, 0);box-sizing: border-box;"><span
								leaf="">赢科，作为深耕教育信息化的技术伙伴，有幸深度参与并支撑了此项具有开创性的工作。我们与北京大学专家团队协同攻关，将其先进的教学管理理念与我们的技术架构深度融合，共同研发并部署了其“教学档案袋平台”。平台的成功运行，不仅验证了技术路径的可行性，更重要的是，形成了一套可供借鉴的、关于未来高校教学管理与教师发展的实践范式。</span></span>
					</p>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
							style="color: rgb(0, 0, 0);box-sizing: border-box;"><span leaf=""><br></span></span></p>
				</section>
				<section style="color: rgb(0, 154, 86);box-sizing: border-box;">
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
							style="box-sizing: border-box;"><span
								leaf="">基于此一经实践检验的成功模型，我们将其凝练、升华并产品化，形成了面向全国高校的综合性解决方案——「赢科教学档案袋系统」。</span></strong></p>
					<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
							style="box-sizing: border-box;"><span leaf=""><br></span></strong></p>
				</section>
				<section style="margin-top: 10px;margin-bottom: 10px;box-sizing: border-box;">
					<section style="border: 1px solid rgb(180, 210, 6);padding: 3px;box-sizing: border-box;">
						<section
							style="border-color: rgb(180, 210, 6);border-width: 3px;border-style: solid;padding: 10px;box-sizing: border-box;">
							<section style="text-align: center;box-sizing: border-box;">
								<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
										style="box-sizing: border-box;"><span leaf="">系统构架：三大战略支柱，赋能教学卓越</span></strong>
								</p>
							</section>
						</section>
					</section>
				</section>
				<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
						leaf="">赢科教学档案袋系统，并非传统意义上的档案管理软件，而是围绕教学发展的核心逻辑，构建了三大战略支柱：</span></p>
				<section
					style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;background-color: rgb(180, 210, 6);height: auto;margin: 0px 7px 0px 0px;padding: 9px;border-top-left-radius: 32px;border-bottom-left-radius: 32px;overflow: hidden;box-sizing: border-box;">
						<section
							style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;box-sizing: border-box;">
								<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
									<section style="z-index: 1;box-sizing: border-box;">
										<section style="box-sizing: border-box;">
											<section data-cacheurl="" data-remoteid=""
												style="display: inline-block; width: 23px; height: 23px; vertical-align: top; overflow: hidden; background-repeat: no-repeat; background-attachment: scroll; box-sizing: border-box; background-image: url(@/assets/news/other/05.png); background-size: contain !important; background-position: 50% 50% !important;"
												data-lazy-bgimg="https://mmbiz.qpic.cn/mmbiz_png//640?wx_fmt=png&amp;from=appmsg"
												class="wx_imgbc_placeholder">
												<section style="text-align: center;box-sizing: border-box;">
													<section
														style="font-size: 15px;color: rgb(142, 201, 101);box-sizing: border-box;">
														<p style="margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf="">1</span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
							</section>
							<section
								style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;padding: 0px 0px 0px 8px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(255, 255, 255);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<strong style="box-sizing: border-box;"><span
												leaf="">教学资本的制度性沉淀与资产化管理</span></strong>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: top;width: 0%;align-self: flex-start;flex: 0 0 auto;background-color: rgb(245, 245, 245);border-radius: 10px;overflow: hidden;height: auto;margin: 0px -8px 0px 0px;padding: 21px;box-sizing: border-box;">
						<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;" role="img"
							aria-label="插图"></svg>
					</section>
					<section
						style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-start;box-sizing: border-box;">
						<section style="margin: -10px 0px 0px;line-height: 0;box-sizing: border-box;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 16px;height: auto;box-sizing: border-box;"
								nodeleaf=""><img
									data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiceDWMBqOq7J0SJ5UDbwCbOAkh5DticRiafZ6el2w5WCEiaa2cfeUD0nZ9WZicqTh14Cgm2kuREG3wy0Hw/640?wx_fmt=png&amp;from=appmsg#imgIndex=7"
									class="rich_pages wxw-img wx_img_placeholder_mini" data-ratio="0.9907407407407407"
									data-s="300,640" data-type="png" data-w="1080"
									style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.00935) / 1; width: 16px !important; height: auto !important;"
									data-imgfileid="503351827"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="10"
									src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
									_width="100%" alt="图片"></section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 13px 0px 10px;width: 100%;align-self: flex-start;padding: 0px 25px;overflow: hidden;box-sizing: border-box;">
					<section style="text-align: justify;width: 100%;box-sizing: border-box;">
						<p
							style="margin: 0px 0px 10px;text-align: left;white-space: normal;padding: 0px;box-sizing: border-box;">
							<span style="text-align: justify;box-sizing: border-box;"><span
									leaf="">本系统旨在将教师零散的教学过程材料，转化为结构化的“教学资本”。</span></span>
						</p>
						<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
							class="list-paddingleft-2">
							<li style="box-sizing: border-box;">
								<p style="margin: 0px 0px 10px;padding: 0px;box-sizing: border-box;"><span
										leaf="">全景式资料整合：系统化归集课程大纲、教案课件、教学视频、学生作业范例、学术成果、同行评议、教学反思等全链条教学资料，形成教师个人的纵向发展数据档案。</span>
								</p>
							</li>
							<li style="box-sizing: border-box;">
								<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">多维度证据链构建：智能关联各类数据，为教学评估、职称晋升、项目申报等提供客观、完整的证据支持。它将教学工作的隐性价值显性化，构建了教师专业的“学术肖像”。</span>
								</p>
							</li>
						</ul>
					</section>
				</section>
				<section
					style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;background-color: rgb(180, 210, 6);height: auto;margin: 0px 7px 0px 0px;padding: 9px;border-top-left-radius: 32px;border-bottom-left-radius: 32px;overflow: hidden;box-sizing: border-box;">
						<section
							style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;box-sizing: border-box;">
								<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
									<section style="z-index: 1;box-sizing: border-box;">
										<section style="box-sizing: border-box;">
											<section data-cacheurl="" data-remoteid=""
												style="display: inline-block; width: 23px; height: 23px; vertical-align: top; overflow: hidden; background-repeat: no-repeat; background-attachment: scroll; box-sizing: border-box; background-image: url(@/assets/news/other/05.png); background-size: contain !important; background-position: 50% 50% !important;"
												data-lazy-bgimg="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiceDWMBqOq7J0SJ5UDbwCbOAyXUJWfC4dKMz3hdA26SH15iciaeDeUPuLajsv8068HGZUYKibG2xZbI5w/640?wx_fmt=png&amp;from=appmsg"
												class="wx_imgbc_placeholder">
												<section style="text-align: center;box-sizing: border-box;">
													<section
														style="font-size: 15px;color: rgb(142, 201, 101);box-sizing: border-box;">
														<p style="margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf="">2</span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
							</section>
							<section
								style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;padding: 0px 0px 0px 8px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(255, 255, 255);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<strong style="box-sizing: border-box;"><span
												leaf="">高影响力教学互动的体系化与效能提升</span></strong>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: top;width: 0%;align-self: flex-start;flex: 0 0 auto;background-color: rgb(245, 245, 245);border-radius: 10px;overflow: hidden;height: auto;margin: 0px -8px 0px 0px;padding: 21px;box-sizing: border-box;">
						<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;" role="img"
							aria-label="插图"></svg>
					</section>
					<section
						style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-start;box-sizing: border-box;">
						<section style="margin: -10px 0px 0px;line-height: 0;box-sizing: border-box;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 16px;height: auto;box-sizing: border-box;"
								nodeleaf=""><img
									data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiceDWMBqOq7J0SJ5UDbwCbOAkh5DticRiafZ6el2w5WCEiaa2cfeUD0nZ9WZicqTh14Cgm2kuREG3wy0Hw/640?wx_fmt=png&amp;from=appmsg#imgIndex=8"
									class="rich_pages wxw-img wx_img_placeholder_mini" data-ratio="0.9907407407407407"
									data-s="300,640" data-type="png" data-w="1080"
									style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.00935) / 1; width: 16px !important; height: auto !important;"
									data-imgfileid="503351825"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="11"
									src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
									_width="100%" alt="图片"></section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 13px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;width: 100%;vertical-align: top;align-self: flex-start;flex: 0 0 auto;padding: 0px 25px;overflow: hidden;box-sizing: border-box;">
						<section style="text-align: justify;box-sizing: border-box;">
							<p style="margin: 0px 0px 10px;white-space: normal;padding: 0px;box-sizing: border-box;">
								<span leaf="">我们深刻理解，高质量的师生互动是现代教育的关键环节。系统借鉴并优化了北京大学的实践模式。</span>
							</p>
							<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
								class="list-paddingleft-2">
								<li style="box-sizing: border-box;">
									<p style="margin: 0px 0px 10px;padding: 0px;box-sizing: border-box;"><span
											leaf="">结构化预约咨询机制：教师可依据其学术日程，精确配置并发布可预约的交流时段、主题与形式。系统支持精细化规则设定，如面向特定学生群体、前置议题提交等，旨在将“Office
											Hour”从被动的答疑，升级为主动引导的、高质量的学术对话。</span></p>
								</li>
								<li style="box-sizing: border-box;">
									<p style="margin: 0px 0px 10px;padding: 0px;box-sizing: border-box;"><span
											leaf="">流程自动化与数据分析：预约、提醒、反馈全程自动化管理，极大降低沟通成本。同时，系统可对互动频率、主题分布等进行数据分析，为教学管理部门优化指导资源配置提供依据。</span>
									</p>
								</li>
							</ul>
						</section>
						<section style="line-height: 0;box-sizing: border-box; text-align: center;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
								nodeleaf=""><img class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
									data-imgfileid="503351826" data-ratio="0.41388888888888886" data-s="300,640"
									data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiceDWMBqOq7J0SJ5UDbwCbOASYx4Qic70vQqaFsrKf4CFiaRsuu70OcicxV4sTjiatWiaF5yR8ibNY33pfbA/640?wx_fmt=png&amp;from=appmsg#imgIndex=9"
									data-type="png" data-w="1080"
									style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(2.41611) / 1; width: 627px !important; height: auto !important;"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="12" src="@/assets/news/07/03.png" _width="100%" alt="图片"></section>
						</section>
					</section>
				</section>
				<section
					style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: 20px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: middle;width: auto;align-self: center;flex: 100 100 0%;background-color: rgb(180, 210, 6);height: auto;margin: 0px 7px 0px 0px;padding: 9px;border-top-left-radius: 32px;border-bottom-left-radius: 32px;overflow: hidden;box-sizing: border-box;">
						<section
							style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;box-sizing: border-box;">
								<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
									<section style="z-index: 1;box-sizing: border-box;">
										<section style="box-sizing: border-box;">
											<section data-cacheurl="" data-remoteid=""
												style="display: inline-block; width: 23px; height: 23px; vertical-align: top; overflow: hidden; background-repeat: no-repeat; background-attachment: scroll; box-sizing: border-box; background-image: url(@/assets/news/other/05.png); background-size: contain !important; background-position: 50% 50% !important;"
												data-lazy-bgimg="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiceDWMBqOq7J0SJ5UDbwCbOAyXUJWfC4dKMz3hdA26SH15iciaeDeUPuLajsv8068HGZUYKibG2xZbI5w/640?wx_fmt=png&amp;from=appmsg"
												class="wx_imgbc_placeholder">
												<section style="text-align: center;box-sizing: border-box;">
													<section
														style="font-size: 15px;color: rgb(142, 201, 101);box-sizing: border-box;">
														<p style="margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf="">3</span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
							</section>
							<section
								style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;padding: 0px 0px 0px 8px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(255, 255, 255);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<strong style="box-sizing: border-box;"><span
												leaf="">保障体系的数据驱动与智能治理</span></strong>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: top;width: 0%;align-self: flex-start;flex: 0 0 auto;background-color: rgb(245, 245, 245);border-radius: 10px;overflow: hidden;height: auto;margin: 0px -8px 0px 0px;padding: 21px;box-sizing: border-box;">
						<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;" role="img"
							aria-label="插图"></svg>
					</section>
					<section
						style="display: inline-block;vertical-align: top;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: flex-start;box-sizing: border-box;">
						<section style="margin: -10px 0px 0px;line-height: 0;box-sizing: border-box;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 16px;height: auto;box-sizing: border-box;"
								nodeleaf=""><img class="rich_pages wxw-img wx_img_placeholder_mini"
									data-imgfileid="503351829" data-ratio="0.9907407407407407" data-s="300,640"
									data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiceDWMBqOq7J0SJ5UDbwCbOAkh5DticRiafZ6el2w5WCEiaa2cfeUD0nZ9WZicqTh14Cgm2kuREG3wy0Hw/640?wx_fmt=png&amp;from=appmsg#imgIndex=10"
									data-type="png" data-w="1080"
									style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.00935) / 1; width: 16px !important; height: auto !important;"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="13"
									src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
									_width="100%" alt="图片"></section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 13px 0px 10px;width: 100%;align-self: flex-start;padding: 0px 25px;overflow: hidden;box-sizing: border-box;">
					<section style="text-align: justify;width: 100%;box-sizing: border-box;">
						<p style="margin: 0px 0px 10px;white-space: normal;padding: 0px;box-sizing: border-box;"><span
								leaf="">本系统是高校教学质量保障体系的核心数据引擎。</span></p>
						<ul style="list-style-type: disc;box-sizing: border-box;padding-left: 20px;list-style-position: outside;"
							class="list-paddingleft-2">
							<li style="box-sizing: border-box;">
								<p style="margin: 0px 0px 10px;padding: 0px;box-sizing: border-box;"><span
										leaf="">宏观态势感知：通过对全校教学档案数据的聚合分析，管理者能够从宏观层面洞察各院系、各学科的教学发展态势、资源投入效益及潜在的改进空间。</span>
								</p>
							</li>
							<li style="box-sizing: border-box;">
								<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span
										leaf="">循证决策支持：系统提供的多维度、可视化分析报告，将取代经验驱动的管理模式，为教学改革、师资培训、课程设置等重大决策提供坚实的数据基础与决策依据。</span>
								</p>
							</li>
						</ul>
					</section>
				</section>
				<section
					style="text-align: center;justify-content: center;margin: 10px 0%;display: flex;flex-flow: row;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;align-self: center;height: auto;box-sizing: border-box;">
						<section style="margin: 0px 0%;box-sizing: border-box;">
							<section style="background-color: rgb(220, 237, 200);height: 1px;box-sizing: border-box;">
								<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
									role="img" aria-label="插图"></svg>
							</section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: 40px;flex: 0 0 auto;height: auto;align-self: center;margin: 0px 15px;box-sizing: border-box;">
						<section style="margin-top: 10px;margin-bottom: 10px;line-height: 0;box-sizing: border-box;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
								nodeleaf=""><img
									data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiceDWMBqOq7J0SJ5UDbwCbOA32pq0BZUmeQ38P5KuKaSTriaSpQeN3E724KqchOOQ2NwRKkV8W6NIwg/640?wx_fmt=png&amp;from=appmsg#imgIndex=11"
									class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
									data-ratio="0.9005681818181818" data-s="300,640" data-type="png" data-w="1056"
									style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.11041) / 1; width: 40px !important; height: auto !important;"
									data-imgfileid="503351833"
									data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
									data-index="14"
									src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
									_width="100%" alt="图片"></section>
						</section>
					</section>
					<section
						style="display: inline-block;vertical-align: middle;width: auto;flex: 100 100 0%;align-self: center;height: auto;box-sizing: border-box;">
						<section style="margin: 0px 0%;box-sizing: border-box;">
							<section style="background-color: rgb(220, 237, 200);height: 1px;box-sizing: border-box;">
								<svg viewBox="0 0 1 1" style="float:left;line-height:0;width:0;vertical-align:top;"
									role="img" aria-label="插图"></svg>
							</section>
						</section>
					</section>
				</section>
				<section style="color: rgb(0, 154, 86);box-sizing: border-box;">
					<p style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
						<strong style="box-sizing: border-box;"><span leaf="">选择赢科——携手共创卓越未来</span></strong>
					</p>
				</section>
				<section
					style="margin-top: 10px;margin-bottom: 10px;display: inline-block;width: 100%;border: 1px solid rgb(180, 210, 6);padding: 10px;box-shadow: rgb(204, 204, 204) 0.2em 0.2em 0.3em;box-sizing: border-box;">
					<section style="width: 100%;box-sizing: border-box;">
						<p style="text-align: center;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">与北京大学的深度共建，不仅是对赢科技术实力与创新能力的权威验证，更是我们对高等教育本质理解的深刻历练。</span></p>
						<p style="text-align: center;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<p style="text-align: center;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">我们所提供的，不止于一套先进的教学档案袋系统，更是一份通过顶尖学府实践检验、面向未来发展趋势的综合性解决方案。</span></p>
						<p style="text-align: center;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<p style="text-align: center;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
								style="box-sizing: border-box;"><span
									leaf="">我们相信，卓越的教学，源于对每一位教师专业成长的尊重与系统性支持。</span></strong></p>
						<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><span leaf=""><br></span></p>
						<p style="text-align: center;margin: 0px;padding: 0px;box-sizing: border-box;"><strong
								style="box-sizing: border-box;"><span
									style="color: rgb(0, 154, 86);box-sizing: border-box;"><span
										leaf="">「赢科教学档案袋系统」</span></span></strong><span
								leaf="">所承载的，是一套经过验证的、科学的教学发展与评估方法论。</span></p>
						<p style="text-align: center;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf=""><br></span></p>
						<p style="text-align: center;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								leaf="">我们诚挚地邀请各高校管理者、教务及教师发展领域的同仁，携手构建符合高校战略发展需求的教学新基建，</span><span
								style="text-align: justify;box-sizing: border-box;"><span
									leaf="">擘画高等教育的崭新篇章。</span></span></p>
						<p style="text-align: center;margin: 0px;padding: 0px;box-sizing: border-box;"><span
								style="text-align: justify;box-sizing: border-box;"><span leaf=""><br></span></span></p>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 10px 0px 0px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: top;width: 50%;align-self: flex-start;flex: 0 0 auto;box-sizing: border-box;">
						<section
							style="transform: perspective(0px);-webkit-transform: perspective(0px);-moz-transform: perspective(0px);-o-transform: perspective(0px);transform-style: flat;box-sizing: border-box;">
							<section
								style="transform: rotateX(180deg);-webkit-transform: rotateX(180deg);-moz-transform: rotateX(180deg);-o-transform: rotateX(180deg);box-sizing: border-box;">
								<section
									style="display: inline-block;width: 8px;height: 8px;vertical-align: top;overflow: hidden;background-color: rgb(180, 210, 6);box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
					</section>
					<section style="display: inline-block;vertical-align: top;width: 50%;box-sizing: border-box;">
						<section
							style="transform: perspective(0px);-webkit-transform: perspective(0px);-moz-transform: perspective(0px);-o-transform: perspective(0px);transform-style: flat;box-sizing: border-box;">
							<section
								style="transform: rotateX(180deg) rotateY(180deg);-webkit-transform: rotateX(180deg) rotateY(180deg);-moz-transform: rotateX(180deg) rotateY(180deg);-o-transform: rotateX(180deg) rotateY(180deg);box-sizing: border-box;">
								<section
									style="display: inline-block;width: 8px;height: 8px;vertical-align: top;overflow: hidden;background-color: rgb(180, 210, 6);box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: -2px 0px;box-sizing: border-box;">
					<section
						style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 100 100 0%;border-style: solid;border-width: 1px;border-color: rgb(180, 210, 6);height: auto;margin: 0px 6px;padding: 14px 24px 0px;box-sizing: border-box;">
						<section
							style="text-align: center;justify-content: center;display: flex;flex-flow: row;margin: -28px 0px 10px;box-sizing: border-box;">
							<section
								style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;background-color: rgb(255, 255, 255);padding: 0px 8px;box-sizing: border-box;">
								<section
									style="justify-content: center;display: flex;flex-flow: row;margin: 0px;box-sizing: border-box;">
									<section
										style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;box-sizing: border-box;">
										<section style="margin: 0px;line-height: 0;box-sizing: border-box;">
											<section
												style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 16px;height: auto;box-sizing: border-box;"
												nodeleaf=""><img
													data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiceDWMBqOq7J0SJ5UDbwCbOAQumZwBjXuib9dvWaUcYofyqxKUenpo1cR5Mzx8rKvoNwXtFLlsLVP8Q/640?wx_fmt=png&amp;from=appmsg#imgIndex=12"
													class="rich_pages wxw-img wx_img_placeholder_mini"
													data-ratio="1.358" data-s="300,640" data-type="png" data-w="500"
													style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(0.736377) / 1; width: 16px !important; height: auto !important;"
													data-imgfileid="503351831"
													data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
													data-index="15"
													src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
													_width="100%" alt="图片"></section>
										</section>
									</section>
									<section
										style="display: inline-block;vertical-align: middle;width: auto;flex: 0 0 0%;height: auto;margin: 0px -4px 0px 0px;align-self: center;box-sizing: border-box;">
										<section
											style="transform: rotateZ(13deg);-webkit-transform: rotateZ(13deg);-moz-transform: rotateZ(13deg);-o-transform: rotateZ(13deg);box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 18px;height: 29px;vertical-align: top;overflow: hidden;border-radius: 99%;background-color: rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
									<section
										style="display: inline-block;vertical-align: middle;width: auto;flex: 0 0 0%;height: auto;margin: 0px -4px 0px 0px;align-self: center;box-sizing: border-box;">
										<section
											style="transform: rotateZ(13deg);-webkit-transform: rotateZ(13deg);-moz-transform: rotateZ(13deg);-o-transform: rotateZ(13deg);box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 18px;height: 29px;vertical-align: top;overflow: hidden;border-radius: 99%;background-color: rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
									<section
										style="display: inline-block;vertical-align: middle;width: auto;flex: 0 0 0%;height: auto;margin: 0px -4px 0px 0px;align-self: center;box-sizing: border-box;">
										<section
											style="transform: rotateZ(13deg);-webkit-transform: rotateZ(13deg);-moz-transform: rotateZ(13deg);-o-transform: rotateZ(13deg);box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 18px;height: 29px;vertical-align: top;overflow: hidden;border-radius: 99%;background-color: rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
									<section
										style="display: inline-block;vertical-align: middle;width: auto;flex: 0 0 0%;height: auto;margin: 0px -4px 0px 0px;align-self: center;box-sizing: border-box;">
										<section
											style="transform: rotateZ(13deg);-webkit-transform: rotateZ(13deg);-moz-transform: rotateZ(13deg);-o-transform: rotateZ(13deg);box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 18px;height: 29px;vertical-align: top;overflow: hidden;border-radius: 99%;background-color: rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
									<section
										style="display: inline-block;vertical-align: middle;width: auto;flex: 0 0 0%;height: auto;margin: 0px -4px 0px 0px;align-self: center;box-sizing: border-box;">
										<section
											style="transform: rotateZ(13deg);-webkit-transform: rotateZ(13deg);-moz-transform: rotateZ(13deg);-o-transform: rotateZ(13deg);box-sizing: border-box;">
											<section style="box-sizing: border-box;">
												<section
													style="display: inline-block;width: 18px;height: 29px;vertical-align: top;overflow: hidden;border-radius: 99%;background-color: rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
									<section
										style="display: inline-block;vertical-align: middle;width: auto;min-width: 5%;max-width: 100%;flex: 0 0 auto;height: auto;align-self: center;box-sizing: border-box;">
										<section style="margin: 0px;line-height: 0;box-sizing: border-box;">
											<section
												style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;width: 16px;height: auto;box-sizing: border-box;"
												nodeleaf=""><img
													data-src="https://mmbiz.qpic.cn/mmbiz_png/6hSD81RFpiceDWMBqOq7J0SJ5UDbwCbOAQumZwBjXuib9dvWaUcYofyqxKUenpo1cR5Mzx8rKvoNwXtFLlsLVP8Q/640?wx_fmt=png&amp;from=appmsg#imgIndex=13"
													class="rich_pages wxw-img wx_img_placeholder_mini"
													data-ratio="1.358" data-s="300,640" data-type="png" data-w="500"
													style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(0.736377) / 1; width: 16px !important; height: auto !important;"
													data-imgfileid="503351832"
													data-original-style="vertical-align: middle;max-width: 100%;width: 100%;box-sizing: border-box;"
													data-index="16"
													src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='1px' height='1px' viewBox='0 0 1 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E%3C/title%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' fill-opacity='0'%3E%3Cg transform='translate(-249.000000, -126.000000)' fill='%23FFFFFF'%3E%3Crect x='249' y='126' width='1' height='1'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
													_width="100%" alt="图片"></section>
										</section>
									</section>
								</section>
								<section style="display: flex;width: 100%;flex-flow: column;box-sizing: border-box;">
									<section style="z-index: 1;box-sizing: border-box;">
										<section style="margin: -26px 0px 10px;box-sizing: border-box;">
											<section
												style="font-size: 14px;color: rgb(255, 255, 255);box-sizing: border-box;">
												<p style="margin: 0px;padding: 0px;box-sizing: border-box;"><strong
														style="box-sizing: border-box;"><span
															leaf="">赢科天地</span></strong></p>
											</section>
										</section>
									</section>
								</section>
							</section>
						</section>
						<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
							<p
								style="text-align: center;white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
								<span style="text-align: justify;box-sizing: border-box;"><span
										leaf="">作为未来教学体验探索者，赢科助力高校数字化发展，设计研发基于人工智能的高校智慧教育生态体系。紧紧围绕赢科“1+3+1”智慧教育生态模型，助力高等教育信息化的全面发展。</span></span>
							</p>
						</section>
						<section
							style="justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
								<section
									style="justify-content: flex-start;display: flex;flex-flow: row;margin: 5px 0px 0px;box-sizing: border-box;">
									<section
										style="display: inline-block;width: 18px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;background-color: rgba(180, 210, 6, 0.29);line-height: 0;padding: 2px 0px 8px 6px;border-style: solid;border-width: 1px;border-color: rgb(180, 210, 6);border-radius: 130px;overflow: hidden;box-sizing: border-box;">
										<section
											style="transform: rotateZ(315deg);-webkit-transform: rotateZ(315deg);-moz-transform: rotateZ(315deg);-o-transform: rotateZ(315deg);box-sizing: border-box;">
											<section
												style="text-align: center;transform: translate3d(-3px, 0px, 0px);-webkit-transform: translate3d(-3px, 0px, 0px);-moz-transform: translate3d(-3px, 0px, 0px);-o-transform: translate3d(-3px, 0px, 0px);box-sizing: border-box;">
												<section
													style="display: inline-block;width: 10px;height: 6px;vertical-align: top;overflow: hidden;border-style: solid;border-width: 0px 0px 2px 2px;border-color: rgb(75, 194, 224) rgb(75, 194, 224) rgb(180, 210, 6) rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
							</section>
							<section
								style="display: inline-block;vertical-align: top;width: auto;flex: 100 100 0%;height: auto;padding: 0px 0px 0px 15px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span style="color: rgb(180, 210, 6);box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span
													leaf="">1个核心：智慧教学</span></strong></span>
									</p>
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span
											leaf="">确保生态体系始终围绕教学这个“轴心”运转，从技术层面推动“管理更好引导服务教学、科研更好反哺促进教学、资源更好支撑保障教学”的发展目标得以落地实现。</span>
									</p>
								</section>
							</section>
						</section>
						<section
							style="justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
								<section
									style="justify-content: flex-start;display: flex;flex-flow: row;margin: 5px 0px 0px;box-sizing: border-box;">
									<section
										style="display: inline-block;width: 18px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;background-color: rgba(180, 210, 6, 0.29);line-height: 0;padding: 2px 0px 8px 6px;border-style: solid;border-width: 1px;border-color: rgb(180, 210, 6);border-radius: 130px;overflow: hidden;box-sizing: border-box;">
										<section
											style="transform: rotateZ(315deg);-webkit-transform: rotateZ(315deg);-moz-transform: rotateZ(315deg);-o-transform: rotateZ(315deg);box-sizing: border-box;">
											<section
												style="text-align: center;transform: translate3d(-3px, 0px, 0px);-webkit-transform: translate3d(-3px, 0px, 0px);-moz-transform: translate3d(-3px, 0px, 0px);-o-transform: translate3d(-3px, 0px, 0px);box-sizing: border-box;">
												<section
													style="display: inline-block;width: 10px;height: 6px;vertical-align: top;overflow: hidden;border-style: solid;border-width: 0px 0px 2px 2px;border-color: rgb(75, 194, 224) rgb(75, 194, 224) rgb(180, 210, 6) rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
							</section>
							<section
								style="display: inline-block;vertical-align: top;width: auto;flex: 100 100 0%;height: auto;padding: 0px 0px 0px 15px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span style="color: rgb(180, 210, 6);box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span
													leaf="">3个支点：智慧管理服务、资源服务、安全服务</span></strong></span>
									</p>
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf="">为教学活动提供组织管理、资源支持、安全保障等信息化服务，确保整个教育生态体系有序、高效、安全运转。</span>
									</p>
								</section>
							</section>
						</section>
						<section
							style="justify-content: flex-start;display: flex;flex-flow: row;margin: 20px 0px;box-sizing: border-box;">
							<section
								style="display: inline-block;vertical-align: top;width: auto;align-self: flex-start;flex: 0 0 auto;min-width: 5%;max-width: 100%;height: auto;box-sizing: border-box;">
								<section
									style="justify-content: flex-start;display: flex;flex-flow: row;margin: 5px 0px 0px;box-sizing: border-box;">
									<section
										style="display: inline-block;width: 18px;vertical-align: top;align-self: flex-start;flex: 0 0 auto;height: auto;background-color: rgba(180, 210, 6, 0.29);line-height: 0;padding: 2px 0px 8px 6px;border-style: solid;border-width: 1px;border-color: rgb(180, 210, 6);border-radius: 130px;overflow: hidden;box-sizing: border-box;">
										<section
											style="transform: rotateZ(315deg);-webkit-transform: rotateZ(315deg);-moz-transform: rotateZ(315deg);-o-transform: rotateZ(315deg);box-sizing: border-box;">
											<section
												style="text-align: center;transform: translate3d(-3px, 0px, 0px);-webkit-transform: translate3d(-3px, 0px, 0px);-moz-transform: translate3d(-3px, 0px, 0px);-o-transform: translate3d(-3px, 0px, 0px);box-sizing: border-box;">
												<section
													style="display: inline-block;width: 10px;height: 6px;vertical-align: top;overflow: hidden;border-style: solid;border-width: 0px 0px 2px 2px;border-color: rgb(75, 194, 224) rgb(75, 194, 224) rgb(180, 210, 6) rgb(180, 210, 6);box-sizing: border-box;">
													<section style="text-align: justify;box-sizing: border-box;">
														<p
															style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
															<span leaf=""><br></span>
														</p>
													</section>
												</section>
											</section>
										</section>
									</section>
								</section>
							</section>
							<section
								style="display: inline-block;vertical-align: top;width: auto;flex: 100 100 0%;height: auto;padding: 0px 0px 0px 15px;box-sizing: border-box;">
								<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span style="color: rgb(180, 210, 6);box-sizing: border-box;"><strong
												style="box-sizing: border-box;"><span
													leaf="">1个循环：智慧质量评价</span></strong></span>
									</p>
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf="">按照预训练的质量评价 AI
											模型，自动对高校各类教育数据进行采集分析，生成监测结果、评价结论和预警信息，持续辅助管理者科学决策和师生改进教学。</span>
									</p>
								</section>
							</section>
						</section>
						<section style="line-height: 0;box-sizing: border-box;">
							<section
								style="max-width: 100%;vertical-align: middle;display: inline-block;line-height: 0;box-sizing: border-box;"
								nodeleaf=""><img class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
									data-ratio="0.9759825327510917" data-s="300,640" data-type="png" data-w="458"
									style="vertical-align: middle; max-width: 100%; box-sizing: border-box; aspect-ratio: calc(1.02461) / 1; width: 458px !important; height: auto !important;"
									data-backw="458" data-backh="447" data-imgfileid="503351830"
									data-original-style="vertical-align:middle;max-width:100%;width:100%;box-sizing:border-box;"
									data-index="17"
									src="@/assets/news/other/07.png"
									_width="100%" alt="图片"></section>
						</section>
						<section style="text-align: justify;color: rgb(0, 0, 0);box-sizing: border-box;">
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									style="box-sizing: border-box;"><span leaf=""><br></span></span></p>
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									style="box-sizing: border-box;"><span
										leaf="">赢科紧抓“人工智能”引领与“未来教学体验”导向的数智化教育主线。以人工智能基座+低代码平台的理念打造赢科智慧教育生态解决方案，对高等教育的教、管、学、评全流程实施数字化、智能化覆盖，为高等教育高质量发展提供数据决策支持与智慧教学服务。</span></span>
							</p>
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									style="box-sizing: border-box;"><span leaf=""><br></span></span></p>
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									style="box-sizing: border-box;"><span
										leaf="">合志赢科，共创未来，科技助力教育的每一分热爱与责任！</span></span></p>
							<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;"><span
									leaf=""><br></span></p>
						</section>
					</section>
				</section>
				<section
					style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row;margin: 0px 0px 10px;box-sizing: border-box;">
					<section
						style="display: inline-block;vertical-align: top;width: 50%;align-self: flex-start;flex: 0 0 auto;box-sizing: border-box;">
						<section style="box-sizing: border-box;">
							<section
								style="display: inline-block;width: 8px;height: 8px;vertical-align: top;overflow: hidden;background-color: rgb(180, 210, 6);box-sizing: border-box;">
								<section style="text-align: justify;box-sizing: border-box;">
									<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
										<span leaf=""><br></span>
									</p>
								</section>
							</section>
						</section>
					</section>
					<section style="display: inline-block;vertical-align: top;width: 50%;box-sizing: border-box;">
						<section
							style="transform: perspective(0px);-webkit-transform: perspective(0px);-moz-transform: perspective(0px);-o-transform: perspective(0px);transform-style: flat;box-sizing: border-box;">
							<section
								style="transform: rotateY(180deg);-webkit-transform: rotateY(180deg);-moz-transform: rotateY(180deg);-o-transform: rotateY(180deg);box-sizing: border-box;">
								<section
									style="display: inline-block;width: 8px;height: 8px;vertical-align: top;overflow: hidden;background-color: rgb(180, 210, 6);box-sizing: border-box;">
									<section style="text-align: justify;box-sizing: border-box;">
										<p style="white-space: normal;margin: 0px;padding: 0px;box-sizing: border-box;">
											<span leaf=""><br></span>
										</p>
									</section>
								</section>
							</section>
						</section>
					</section>
				</section>
			</section>
		</div>`
	}, 
	{
		"id": 121378,
		"img": require('../assets/news/08/01.png'),
		"title": "慕课西部行大讲堂-第七期培训通知",
		"date": "2025年4月21日 10:13",
		"content": `<div>
				<section style="text-align: center; visibility: visible;" nodeleaf="">
					<img
						class="rich_pages wxw-img" data-ratio="5.281481481481482" data-s="300,640" data-type="png"
						data-w="1080" type="block" data-imgfileid="503351521" data-original-style="null" data-index="3"
						src="@/assets/news/08/01.png"
						_width="677px"
						style="height: auto !important; visibility: visible !important; width: 676.984px !important;"
						alt="图片" data-report-img-idx="0" data-fail="0">
				</section>
			</div>`
	}
]


export default _news_data;